import { UnknownError, NetworkError, ConnectionAbortedError, TimeoutError, InvalidSdkConfigurationError, InvalidRegionOrHostError, InvalidRegionError, InvalidHostError } from "@smash-sdk/core";
import { GenericError as ListGroupsGenericError } from "./types/ListGroups/ListGroupsError";
import { UnauthorizedError as ListGroupsUnauthorizedError } from "./types/ListGroups/ListGroupsError";
import { ForbiddenError as ListGroupsForbiddenError } from "./types/ListGroups/ListGroupsError";
import { NotFoundError as ListGroupsNotFoundError } from "./types/ListGroups/ListGroupsError";
import { InternalServerError as ListGroupsInternalServerError } from "./types/ListGroups/ListGroupsError";
import { BadGatewayError as ListGroupsBadGatewayError } from "./types/ListGroups/ListGroupsError";
import { GatewayTimeoutError as ListGroupsGatewayTimeoutError } from "./types/ListGroups/ListGroupsError";
import { GenericError as ListGroupsSCIMGenericError } from "./types/ListGroupsSCIM/ListGroupsSCIMError";
import { InvalidParameterError as ListGroupsSCIMInvalidParameterError } from "./types/ListGroupsSCIM/ListGroupsSCIMError";
import { UnauthorizedError as ListGroupsSCIMUnauthorizedError } from "./types/ListGroupsSCIM/ListGroupsSCIMError";
import { ForbiddenError as ListGroupsSCIMForbiddenError } from "./types/ListGroupsSCIM/ListGroupsSCIMError";
import { InternalServerError as ListGroupsSCIMInternalServerError } from "./types/ListGroupsSCIM/ListGroupsSCIMError";
import { BadGatewayError as ListGroupsSCIMBadGatewayError } from "./types/ListGroupsSCIM/ListGroupsSCIMError";
import { GatewayTimeoutError as ListGroupsSCIMGatewayTimeoutError } from "./types/ListGroupsSCIM/ListGroupsSCIMError";
import { GenericError as ListPoliciesGenericError } from "./types/ListPolicies/ListPoliciesError";
import { UnauthorizedError as ListPoliciesUnauthorizedError } from "./types/ListPolicies/ListPoliciesError";
import { ForbiddenError as ListPoliciesForbiddenError } from "./types/ListPolicies/ListPoliciesError";
import { InternalServerError as ListPoliciesInternalServerError } from "./types/ListPolicies/ListPoliciesError";
import { BadGatewayError as ListPoliciesBadGatewayError } from "./types/ListPolicies/ListPoliciesError";
import { GatewayTimeoutError as ListPoliciesGatewayTimeoutError } from "./types/ListPolicies/ListPoliciesError";
import { GenericError as ListProvidersGenericError } from "./types/ListProviders/ListProvidersError";
import { UnauthorizedError as ListProvidersUnauthorizedError } from "./types/ListProviders/ListProvidersError";
import { ForbiddenError as ListProvidersForbiddenError } from "./types/ListProviders/ListProvidersError";
import { InternalServerError as ListProvidersInternalServerError } from "./types/ListProviders/ListProvidersError";
import { BadGatewayError as ListProvidersBadGatewayError } from "./types/ListProviders/ListProvidersError";
import { GatewayTimeoutError as ListProvidersGatewayTimeoutError } from "./types/ListProviders/ListProvidersError";
import { GenericError as ListRolesGenericError } from "./types/ListRoles/ListRolesError";
import { UnauthorizedError as ListRolesUnauthorizedError } from "./types/ListRoles/ListRolesError";
import { ForbiddenError as ListRolesForbiddenError } from "./types/ListRoles/ListRolesError";
import { InternalServerError as ListRolesInternalServerError } from "./types/ListRoles/ListRolesError";
import { BadGatewayError as ListRolesBadGatewayError } from "./types/ListRoles/ListRolesError";
import { GatewayTimeoutError as ListRolesGatewayTimeoutError } from "./types/ListRoles/ListRolesError";
import { GenericError as ListTeamGroupRolesGenericError } from "./types/ListTeamGroupRoles/ListTeamGroupRolesError";
import { InvalidParameterError as ListTeamGroupRolesInvalidParameterError } from "./types/ListTeamGroupRoles/ListTeamGroupRolesError";
import { UnauthorizedError as ListTeamGroupRolesUnauthorizedError } from "./types/ListTeamGroupRoles/ListTeamGroupRolesError";
import { ForbiddenError as ListTeamGroupRolesForbiddenError } from "./types/ListTeamGroupRoles/ListTeamGroupRolesError";
import { NotFoundError as ListTeamGroupRolesNotFoundError } from "./types/ListTeamGroupRoles/ListTeamGroupRolesError";
import { InternalServerError as ListTeamGroupRolesInternalServerError } from "./types/ListTeamGroupRoles/ListTeamGroupRolesError";
import { BadGatewayError as ListTeamGroupRolesBadGatewayError } from "./types/ListTeamGroupRoles/ListTeamGroupRolesError";
import { GatewayTimeoutError as ListTeamGroupRolesGatewayTimeoutError } from "./types/ListTeamGroupRoles/ListTeamGroupRolesError";
import { GenericError as ListTeamGroupUsersGenericError } from "./types/ListTeamGroupUsers/ListTeamGroupUsersError";
import { InvalidParameterError as ListTeamGroupUsersInvalidParameterError } from "./types/ListTeamGroupUsers/ListTeamGroupUsersError";
import { UnauthorizedError as ListTeamGroupUsersUnauthorizedError } from "./types/ListTeamGroupUsers/ListTeamGroupUsersError";
import { ForbiddenError as ListTeamGroupUsersForbiddenError } from "./types/ListTeamGroupUsers/ListTeamGroupUsersError";
import { NotFoundError as ListTeamGroupUsersNotFoundError } from "./types/ListTeamGroupUsers/ListTeamGroupUsersError";
import { InternalServerError as ListTeamGroupUsersInternalServerError } from "./types/ListTeamGroupUsers/ListTeamGroupUsersError";
import { BadGatewayError as ListTeamGroupUsersBadGatewayError } from "./types/ListTeamGroupUsers/ListTeamGroupUsersError";
import { GatewayTimeoutError as ListTeamGroupUsersGatewayTimeoutError } from "./types/ListTeamGroupUsers/ListTeamGroupUsersError";
import { GenericError as ListTeamGroupsGenericError } from "./types/ListTeamGroups/ListTeamGroupsError";
import { InvalidParameterError as ListTeamGroupsInvalidParameterError } from "./types/ListTeamGroups/ListTeamGroupsError";
import { UnauthorizedError as ListTeamGroupsUnauthorizedError } from "./types/ListTeamGroups/ListTeamGroupsError";
import { ForbiddenError as ListTeamGroupsForbiddenError } from "./types/ListTeamGroups/ListTeamGroupsError";
import { NotFoundError as ListTeamGroupsNotFoundError } from "./types/ListTeamGroups/ListTeamGroupsError";
import { InternalServerError as ListTeamGroupsInternalServerError } from "./types/ListTeamGroups/ListTeamGroupsError";
import { BadGatewayError as ListTeamGroupsBadGatewayError } from "./types/ListTeamGroups/ListTeamGroupsError";
import { GatewayTimeoutError as ListTeamGroupsGatewayTimeoutError } from "./types/ListTeamGroups/ListTeamGroupsError";
import { GenericError as ListTeamRolesGenericError } from "./types/ListTeamRoles/ListTeamRolesError";
import { InvalidParameterError as ListTeamRolesInvalidParameterError } from "./types/ListTeamRoles/ListTeamRolesError";
import { UnauthorizedError as ListTeamRolesUnauthorizedError } from "./types/ListTeamRoles/ListTeamRolesError";
import { ForbiddenError as ListTeamRolesForbiddenError } from "./types/ListTeamRoles/ListTeamRolesError";
import { NotFoundError as ListTeamRolesNotFoundError } from "./types/ListTeamRoles/ListTeamRolesError";
import { InternalServerError as ListTeamRolesInternalServerError } from "./types/ListTeamRoles/ListTeamRolesError";
import { BadGatewayError as ListTeamRolesBadGatewayError } from "./types/ListTeamRoles/ListTeamRolesError";
import { GatewayTimeoutError as ListTeamRolesGatewayTimeoutError } from "./types/ListTeamRoles/ListTeamRolesError";
import { GenericError as ListTeamUserGroupsGenericError } from "./types/ListTeamUserGroups/ListTeamUserGroupsError";
import { InvalidParameterError as ListTeamUserGroupsInvalidParameterError } from "./types/ListTeamUserGroups/ListTeamUserGroupsError";
import { UnauthorizedError as ListTeamUserGroupsUnauthorizedError } from "./types/ListTeamUserGroups/ListTeamUserGroupsError";
import { ForbiddenError as ListTeamUserGroupsForbiddenError } from "./types/ListTeamUserGroups/ListTeamUserGroupsError";
import { NotFoundError as ListTeamUserGroupsNotFoundError } from "./types/ListTeamUserGroups/ListTeamUserGroupsError";
import { InternalServerError as ListTeamUserGroupsInternalServerError } from "./types/ListTeamUserGroups/ListTeamUserGroupsError";
import { BadGatewayError as ListTeamUserGroupsBadGatewayError } from "./types/ListTeamUserGroups/ListTeamUserGroupsError";
import { GatewayTimeoutError as ListTeamUserGroupsGatewayTimeoutError } from "./types/ListTeamUserGroups/ListTeamUserGroupsError";
import { GenericError as ListTeamUserRolesGenericError } from "./types/ListTeamUserRoles/ListTeamUserRolesError";
import { InvalidParameterError as ListTeamUserRolesInvalidParameterError } from "./types/ListTeamUserRoles/ListTeamUserRolesError";
import { UnauthorizedError as ListTeamUserRolesUnauthorizedError } from "./types/ListTeamUserRoles/ListTeamUserRolesError";
import { ForbiddenError as ListTeamUserRolesForbiddenError } from "./types/ListTeamUserRoles/ListTeamUserRolesError";
import { NotFoundError as ListTeamUserRolesNotFoundError } from "./types/ListTeamUserRoles/ListTeamUserRolesError";
import { InternalServerError as ListTeamUserRolesInternalServerError } from "./types/ListTeamUserRoles/ListTeamUserRolesError";
import { BadGatewayError as ListTeamUserRolesBadGatewayError } from "./types/ListTeamUserRoles/ListTeamUserRolesError";
import { GatewayTimeoutError as ListTeamUserRolesGatewayTimeoutError } from "./types/ListTeamUserRoles/ListTeamUserRolesError";
import { GenericError as ListTeamUsersGenericError } from "./types/ListTeamUsers/ListTeamUsersError";
import { InvalidParameterError as ListTeamUsersInvalidParameterError } from "./types/ListTeamUsers/ListTeamUsersError";
import { UnauthorizedError as ListTeamUsersUnauthorizedError } from "./types/ListTeamUsers/ListTeamUsersError";
import { ForbiddenError as ListTeamUsersForbiddenError } from "./types/ListTeamUsers/ListTeamUsersError";
import { NotFoundError as ListTeamUsersNotFoundError } from "./types/ListTeamUsers/ListTeamUsersError";
import { InternalServerError as ListTeamUsersInternalServerError } from "./types/ListTeamUsers/ListTeamUsersError";
import { BadGatewayError as ListTeamUsersBadGatewayError } from "./types/ListTeamUsers/ListTeamUsersError";
import { GatewayTimeoutError as ListTeamUsersGatewayTimeoutError } from "./types/ListTeamUsers/ListTeamUsersError";
import { GenericError as ListTeamsGenericError } from "./types/ListTeams/ListTeamsError";
import { UnauthorizedError as ListTeamsUnauthorizedError } from "./types/ListTeams/ListTeamsError";
import { ForbiddenError as ListTeamsForbiddenError } from "./types/ListTeams/ListTeamsError";
import { InternalServerError as ListTeamsInternalServerError } from "./types/ListTeams/ListTeamsError";
import { BadGatewayError as ListTeamsBadGatewayError } from "./types/ListTeams/ListTeamsError";
import { GatewayTimeoutError as ListTeamsGatewayTimeoutError } from "./types/ListTeams/ListTeamsError";
import { GenericError as ListUserGroupsGenericError } from "./types/ListUserGroups/ListUserGroupsError";
import { InvalidParameterError as ListUserGroupsInvalidParameterError } from "./types/ListUserGroups/ListUserGroupsError";
import { UnauthorizedError as ListUserGroupsUnauthorizedError } from "./types/ListUserGroups/ListUserGroupsError";
import { ForbiddenError as ListUserGroupsForbiddenError } from "./types/ListUserGroups/ListUserGroupsError";
import { NotFoundError as ListUserGroupsNotFoundError } from "./types/ListUserGroups/ListUserGroupsError";
import { InternalServerError as ListUserGroupsInternalServerError } from "./types/ListUserGroups/ListUserGroupsError";
import { BadGatewayError as ListUserGroupsBadGatewayError } from "./types/ListUserGroups/ListUserGroupsError";
import { GatewayTimeoutError as ListUserGroupsGatewayTimeoutError } from "./types/ListUserGroups/ListUserGroupsError";
import { GenericError as ListUserGroupsRolesGenericError } from "./types/ListUserGroupsRoles/ListUserGroupsRolesError";
import { InvalidParameterError as ListUserGroupsRolesInvalidParameterError } from "./types/ListUserGroupsRoles/ListUserGroupsRolesError";
import { UnauthorizedError as ListUserGroupsRolesUnauthorizedError } from "./types/ListUserGroupsRoles/ListUserGroupsRolesError";
import { ForbiddenError as ListUserGroupsRolesForbiddenError } from "./types/ListUserGroupsRoles/ListUserGroupsRolesError";
import { NotFoundError as ListUserGroupsRolesNotFoundError } from "./types/ListUserGroupsRoles/ListUserGroupsRolesError";
import { InternalServerError as ListUserGroupsRolesInternalServerError } from "./types/ListUserGroupsRoles/ListUserGroupsRolesError";
import { BadGatewayError as ListUserGroupsRolesBadGatewayError } from "./types/ListUserGroupsRoles/ListUserGroupsRolesError";
import { GatewayTimeoutError as ListUserGroupsRolesGatewayTimeoutError } from "./types/ListUserGroupsRoles/ListUserGroupsRolesError";
import { GenericError as ListUserGroupsTeamsGenericError } from "./types/ListUserGroupsTeams/ListUserGroupsTeamsError";
import { InvalidParameterError as ListUserGroupsTeamsInvalidParameterError } from "./types/ListUserGroupsTeams/ListUserGroupsTeamsError";
import { UnauthorizedError as ListUserGroupsTeamsUnauthorizedError } from "./types/ListUserGroupsTeams/ListUserGroupsTeamsError";
import { ForbiddenError as ListUserGroupsTeamsForbiddenError } from "./types/ListUserGroupsTeams/ListUserGroupsTeamsError";
import { NotFoundError as ListUserGroupsTeamsNotFoundError } from "./types/ListUserGroupsTeams/ListUserGroupsTeamsError";
import { InternalServerError as ListUserGroupsTeamsInternalServerError } from "./types/ListUserGroupsTeams/ListUserGroupsTeamsError";
import { BadGatewayError as ListUserGroupsTeamsBadGatewayError } from "./types/ListUserGroupsTeams/ListUserGroupsTeamsError";
import { GatewayTimeoutError as ListUserGroupsTeamsGatewayTimeoutError } from "./types/ListUserGroupsTeams/ListUserGroupsTeamsError";
import { GenericError as ListUserRolesGenericError } from "./types/ListUserRoles/ListUserRolesError";
import { InvalidParameterError as ListUserRolesInvalidParameterError } from "./types/ListUserRoles/ListUserRolesError";
import { UnauthorizedError as ListUserRolesUnauthorizedError } from "./types/ListUserRoles/ListUserRolesError";
import { ForbiddenError as ListUserRolesForbiddenError } from "./types/ListUserRoles/ListUserRolesError";
import { NotFoundError as ListUserRolesNotFoundError } from "./types/ListUserRoles/ListUserRolesError";
import { InternalServerError as ListUserRolesInternalServerError } from "./types/ListUserRoles/ListUserRolesError";
import { BadGatewayError as ListUserRolesBadGatewayError } from "./types/ListUserRoles/ListUserRolesError";
import { GatewayTimeoutError as ListUserRolesGatewayTimeoutError } from "./types/ListUserRoles/ListUserRolesError";
import { GenericError as ListUserTeamsGenericError } from "./types/ListUserTeams/ListUserTeamsError";
import { InvalidParameterError as ListUserTeamsInvalidParameterError } from "./types/ListUserTeams/ListUserTeamsError";
import { UnauthorizedError as ListUserTeamsUnauthorizedError } from "./types/ListUserTeams/ListUserTeamsError";
import { ForbiddenError as ListUserTeamsForbiddenError } from "./types/ListUserTeams/ListUserTeamsError";
import { NotFoundError as ListUserTeamsNotFoundError } from "./types/ListUserTeams/ListUserTeamsError";
import { InternalServerError as ListUserTeamsInternalServerError } from "./types/ListUserTeams/ListUserTeamsError";
import { BadGatewayError as ListUserTeamsBadGatewayError } from "./types/ListUserTeams/ListUserTeamsError";
import { GatewayTimeoutError as ListUserTeamsGatewayTimeoutError } from "./types/ListUserTeams/ListUserTeamsError";
import { GenericError as ListUsersGenericError } from "./types/ListUsers/ListUsersError";
import { UnauthorizedError as ListUsersUnauthorizedError } from "./types/ListUsers/ListUsersError";
import { ForbiddenError as ListUsersForbiddenError } from "./types/ListUsers/ListUsersError";
import { InternalServerError as ListUsersInternalServerError } from "./types/ListUsers/ListUsersError";
import { BadGatewayError as ListUsersBadGatewayError } from "./types/ListUsers/ListUsersError";
import { GatewayTimeoutError as ListUsersGatewayTimeoutError } from "./types/ListUsers/ListUsersError";
import { GenericError as ListUsersSCIMGenericError } from "./types/ListUsersSCIM/ListUsersSCIMError";
import { InvalidParameterError as ListUsersSCIMInvalidParameterError } from "./types/ListUsersSCIM/ListUsersSCIMError";
import { UnauthorizedError as ListUsersSCIMUnauthorizedError } from "./types/ListUsersSCIM/ListUsersSCIMError";
import { ForbiddenError as ListUsersSCIMForbiddenError } from "./types/ListUsersSCIM/ListUsersSCIMError";
import { InternalServerError as ListUsersSCIMInternalServerError } from "./types/ListUsersSCIM/ListUsersSCIMError";
import { BadGatewayError as ListUsersSCIMBadGatewayError } from "./types/ListUsersSCIM/ListUsersSCIMError";
import { GatewayTimeoutError as ListUsersSCIMGatewayTimeoutError } from "./types/ListUsersSCIM/ListUsersSCIMError";
import { GenericError as PatchGroupSCIMGenericError } from "./types/PatchGroupSCIM/PatchGroupSCIMError";
import { InvalidParameterError as PatchGroupSCIMInvalidParameterError } from "./types/PatchGroupSCIM/PatchGroupSCIMError";
import { UnauthorizedError as PatchGroupSCIMUnauthorizedError } from "./types/PatchGroupSCIM/PatchGroupSCIMError";
import { ForbiddenError as PatchGroupSCIMForbiddenError } from "./types/PatchGroupSCIM/PatchGroupSCIMError";
import { NotFoundError as PatchGroupSCIMNotFoundError } from "./types/PatchGroupSCIM/PatchGroupSCIMError";
import { InternalServerError as PatchGroupSCIMInternalServerError } from "./types/PatchGroupSCIM/PatchGroupSCIMError";
import { BadGatewayError as PatchGroupSCIMBadGatewayError } from "./types/PatchGroupSCIM/PatchGroupSCIMError";
import { GatewayTimeoutError as PatchGroupSCIMGatewayTimeoutError } from "./types/PatchGroupSCIM/PatchGroupSCIMError";
import { GenericError as PatchUserSCIMGenericError } from "./types/PatchUserSCIM/PatchUserSCIMError";
import { InvalidParameterError as PatchUserSCIMInvalidParameterError } from "./types/PatchUserSCIM/PatchUserSCIMError";
import { UnauthorizedError as PatchUserSCIMUnauthorizedError } from "./types/PatchUserSCIM/PatchUserSCIMError";
import { ForbiddenError as PatchUserSCIMForbiddenError } from "./types/PatchUserSCIM/PatchUserSCIMError";
import { NotFoundError as PatchUserSCIMNotFoundError } from "./types/PatchUserSCIM/PatchUserSCIMError";
import { ConflictError as PatchUserSCIMConflictError } from "./types/PatchUserSCIM/PatchUserSCIMError";
import { InternalServerError as PatchUserSCIMInternalServerError } from "./types/PatchUserSCIM/PatchUserSCIMError";
import { BadGatewayError as PatchUserSCIMBadGatewayError } from "./types/PatchUserSCIM/PatchUserSCIMError";
import { GatewayTimeoutError as PatchUserSCIMGatewayTimeoutError } from "./types/PatchUserSCIM/PatchUserSCIMError";
import { GenericError as RenewTokenGenericError } from "./types/RenewToken/RenewTokenError";
import { InvalidParameterError as RenewTokenInvalidParameterError } from "./types/RenewToken/RenewTokenError";
import { PasswordRevokedError as RenewTokenPasswordRevokedError } from "./types/RenewToken/RenewTokenError";
import { IdentityDisabledError as RenewTokenIdentityDisabledError } from "./types/RenewToken/RenewTokenError";
import { NotAllowedError as RenewTokenNotAllowedError } from "./types/RenewToken/RenewTokenError";
import { InvalidRefreshTokenError as RenewTokenInvalidRefreshTokenError } from "./types/RenewToken/RenewTokenError";
import { NotFoundError as RenewTokenNotFoundError } from "./types/RenewToken/RenewTokenError";
import { InternalServerError as RenewTokenInternalServerError } from "./types/RenewToken/RenewTokenError";
import { BadGatewayError as RenewTokenBadGatewayError } from "./types/RenewToken/RenewTokenError";
import { GatewayTimeoutError as RenewTokenGatewayTimeoutError } from "./types/RenewToken/RenewTokenError";
import { GenericError as ResetMfaFactorGenericError } from "./types/ResetMfaFactor/ResetMfaFactorError";
import { InvalidParameterError as ResetMfaFactorInvalidParameterError } from "./types/ResetMfaFactor/ResetMfaFactorError";
import { UnauthorizedError as ResetMfaFactorUnauthorizedError } from "./types/ResetMfaFactor/ResetMfaFactorError";
import { ForbiddenError as ResetMfaFactorForbiddenError } from "./types/ResetMfaFactor/ResetMfaFactorError";
import { NotFoundError as ResetMfaFactorNotFoundError } from "./types/ResetMfaFactor/ResetMfaFactorError";
import { InternalServerError as ResetMfaFactorInternalServerError } from "./types/ResetMfaFactor/ResetMfaFactorError";
import { BadGatewayError as ResetMfaFactorBadGatewayError } from "./types/ResetMfaFactor/ResetMfaFactorError";
import { GatewayTimeoutError as ResetMfaFactorGatewayTimeoutError } from "./types/ResetMfaFactor/ResetMfaFactorError";
import { GenericError as ResetPasswordGenericError } from "./types/ResetPassword/ResetPasswordError";
import { InvalidParameterError as ResetPasswordInvalidParameterError } from "./types/ResetPassword/ResetPasswordError";
import { InvalidSecretError as ResetPasswordInvalidSecretError } from "./types/ResetPassword/ResetPasswordError";
import { ExpiredSecretError as ResetPasswordExpiredSecretError } from "./types/ResetPassword/ResetPasswordError";
import { NotFoundError as ResetPasswordNotFoundError } from "./types/ResetPassword/ResetPasswordError";
import { InternalServerError as ResetPasswordInternalServerError } from "./types/ResetPassword/ResetPasswordError";
import { BadGatewayError as ResetPasswordBadGatewayError } from "./types/ResetPassword/ResetPasswordError";
import { GatewayTimeoutError as ResetPasswordGatewayTimeoutError } from "./types/ResetPassword/ResetPasswordError";
import { GenericError as ResetUserMfaFactorGenericError } from "./types/ResetUserMfaFactor/ResetUserMfaFactorError";
import { InvalidParameterError as ResetUserMfaFactorInvalidParameterError } from "./types/ResetUserMfaFactor/ResetUserMfaFactorError";
import { UnauthorizedError as ResetUserMfaFactorUnauthorizedError } from "./types/ResetUserMfaFactor/ResetUserMfaFactorError";
import { ForbiddenError as ResetUserMfaFactorForbiddenError } from "./types/ResetUserMfaFactor/ResetUserMfaFactorError";
import { NotFoundError as ResetUserMfaFactorNotFoundError } from "./types/ResetUserMfaFactor/ResetUserMfaFactorError";
import { InternalServerError as ResetUserMfaFactorInternalServerError } from "./types/ResetUserMfaFactor/ResetUserMfaFactorError";
import { BadGatewayError as ResetUserMfaFactorBadGatewayError } from "./types/ResetUserMfaFactor/ResetUserMfaFactorError";
import { GatewayTimeoutError as ResetUserMfaFactorGatewayTimeoutError } from "./types/ResetUserMfaFactor/ResetUserMfaFactorError";
import { GenericError as RotateKeyGenericError } from "./types/RotateKey/RotateKeyError";
import { UnauthorizedError as RotateKeyUnauthorizedError } from "./types/RotateKey/RotateKeyError";
import { ForbiddenError as RotateKeyForbiddenError } from "./types/RotateKey/RotateKeyError";
import { NotFoundError as RotateKeyNotFoundError } from "./types/RotateKey/RotateKeyError";
import { InternalServerError as RotateKeyInternalServerError } from "./types/RotateKey/RotateKeyError";
import { BadGatewayError as RotateKeyBadGatewayError } from "./types/RotateKey/RotateKeyError";
import { GatewayTimeoutError as RotateKeyGatewayTimeoutError } from "./types/RotateKey/RotateKeyError";
import { GenericError as RotateUserKeyGenericError } from "./types/RotateUserKey/RotateUserKeyError";
import { InvalidParameterError as RotateUserKeyInvalidParameterError } from "./types/RotateUserKey/RotateUserKeyError";
import { UnauthorizedError as RotateUserKeyUnauthorizedError } from "./types/RotateUserKey/RotateUserKeyError";
import { ForbiddenError as RotateUserKeyForbiddenError } from "./types/RotateUserKey/RotateUserKeyError";
import { NotFoundError as RotateUserKeyNotFoundError } from "./types/RotateUserKey/RotateUserKeyError";
import { InternalServerError as RotateUserKeyInternalServerError } from "./types/RotateUserKey/RotateUserKeyError";
import { BadGatewayError as RotateUserKeyBadGatewayError } from "./types/RotateUserKey/RotateUserKeyError";
import { GatewayTimeoutError as RotateUserKeyGatewayTimeoutError } from "./types/RotateUserKey/RotateUserKeyError";
import { GenericError as SamlSignonGenericError } from "./types/SamlSignon/SamlSignonError";
import { InvalidParameterError as SamlSignonInvalidParameterError } from "./types/SamlSignon/SamlSignonError";
import { UserNotAllowedToSignonError as SamlSignonUserNotAllowedToSignonError } from "./types/SamlSignon/SamlSignonError";
import { InvalidAudienceUriError as SamlSignonInvalidAudienceUriError } from "./types/SamlSignon/SamlSignonError";
import { NotFoundError as SamlSignonNotFoundError } from "./types/SamlSignon/SamlSignonError";
import { ConflictError as SamlSignonConflictError } from "./types/SamlSignon/SamlSignonError";
import { InternalServerError as SamlSignonInternalServerError } from "./types/SamlSignon/SamlSignonError";
import { BadGatewayError as SamlSignonBadGatewayError } from "./types/SamlSignon/SamlSignonError";
import { GatewayTimeoutError as SamlSignonGatewayTimeoutError } from "./types/SamlSignon/SamlSignonError";
import { GenericError as SendOtpGenericError } from "./types/SendOtp/SendOtpError";
import { InvalidParameterError as SendOtpInvalidParameterError } from "./types/SendOtp/SendOtpError";
import { InvalidTokenError as SendOtpInvalidTokenError } from "./types/SendOtp/SendOtpError";
import { MfaFactorNotAllowedError as SendOtpMfaFactorNotAllowedError } from "./types/SendOtp/SendOtpError";
import { ConflictError as SendOtpConflictError } from "./types/SendOtp/SendOtpError";
import { InternalServerError as SendOtpInternalServerError } from "./types/SendOtp/SendOtpError";
import { BadGatewayError as SendOtpBadGatewayError } from "./types/SendOtp/SendOtpError";
import { GatewayTimeoutError as SendOtpGatewayTimeoutError } from "./types/SendOtp/SendOtpError";
import { GenericError as SsoSigninGenericError } from "./types/SsoSignin/SsoSigninError";
import { InvalidParameterError as SsoSigninInvalidParameterError } from "./types/SsoSignin/SsoSigninError";
import { NotFoundError as SsoSigninNotFoundError } from "./types/SsoSignin/SsoSigninError";
import { ConflictError as SsoSigninConflictError } from "./types/SsoSignin/SsoSigninError";
import { InternalServerError as SsoSigninInternalServerError } from "./types/SsoSignin/SsoSigninError";
import { BadGatewayError as SsoSigninBadGatewayError } from "./types/SsoSignin/SsoSigninError";
import { GatewayTimeoutError as SsoSigninGatewayTimeoutError } from "./types/SsoSignin/SsoSigninError";
import { GenericError as UpdateAccountGenericError } from "./types/UpdateAccount/UpdateAccountError";
import { InvalidParameterError as UpdateAccountInvalidParameterError } from "./types/UpdateAccount/UpdateAccountError";
import { UnauthorizedError as UpdateAccountUnauthorizedError } from "./types/UpdateAccount/UpdateAccountError";
import { ForbiddenError as UpdateAccountForbiddenError } from "./types/UpdateAccount/UpdateAccountError";
import { NotFoundError as UpdateAccountNotFoundError } from "./types/UpdateAccount/UpdateAccountError";
import { ConflictError as UpdateAccountConflictError } from "./types/UpdateAccount/UpdateAccountError";
import { InternalServerError as UpdateAccountInternalServerError } from "./types/UpdateAccount/UpdateAccountError";
import { BadGatewayError as UpdateAccountBadGatewayError } from "./types/UpdateAccount/UpdateAccountError";
import { GatewayTimeoutError as UpdateAccountGatewayTimeoutError } from "./types/UpdateAccount/UpdateAccountError";
import { GenericError as UpdateGroupGenericError } from "./types/UpdateGroup/UpdateGroupError";
import { InvalidParameterError as UpdateGroupInvalidParameterError } from "./types/UpdateGroup/UpdateGroupError";
import { UnauthorizedError as UpdateGroupUnauthorizedError } from "./types/UpdateGroup/UpdateGroupError";
import { ForbiddenError as UpdateGroupForbiddenError } from "./types/UpdateGroup/UpdateGroupError";
import { NotFoundError as UpdateGroupNotFoundError } from "./types/UpdateGroup/UpdateGroupError";
import { InternalServerError as UpdateGroupInternalServerError } from "./types/UpdateGroup/UpdateGroupError";
import { BadGatewayError as UpdateGroupBadGatewayError } from "./types/UpdateGroup/UpdateGroupError";
import { GatewayTimeoutError as UpdateGroupGatewayTimeoutError } from "./types/UpdateGroup/UpdateGroupError";
import { GenericError as UpdateGroupSCIMGenericError } from "./types/UpdateGroupSCIM/UpdateGroupSCIMError";
import { InvalidParameterError as UpdateGroupSCIMInvalidParameterError } from "./types/UpdateGroupSCIM/UpdateGroupSCIMError";
import { UnauthorizedError as UpdateGroupSCIMUnauthorizedError } from "./types/UpdateGroupSCIM/UpdateGroupSCIMError";
import { ForbiddenError as UpdateGroupSCIMForbiddenError } from "./types/UpdateGroupSCIM/UpdateGroupSCIMError";
import { NotFoundError as UpdateGroupSCIMNotFoundError } from "./types/UpdateGroupSCIM/UpdateGroupSCIMError";
import { InternalServerError as UpdateGroupSCIMInternalServerError } from "./types/UpdateGroupSCIM/UpdateGroupSCIMError";
import { BadGatewayError as UpdateGroupSCIMBadGatewayError } from "./types/UpdateGroupSCIM/UpdateGroupSCIMError";
import { GatewayTimeoutError as UpdateGroupSCIMGatewayTimeoutError } from "./types/UpdateGroupSCIM/UpdateGroupSCIMError";
import { GenericError as UpdateManagedPolicyGenericError } from "./types/UpdateManagedPolicy/UpdateManagedPolicyError";
import { InvalidParameterError as UpdateManagedPolicyInvalidParameterError } from "./types/UpdateManagedPolicy/UpdateManagedPolicyError";
import { UnauthorizedError as UpdateManagedPolicyUnauthorizedError } from "./types/UpdateManagedPolicy/UpdateManagedPolicyError";
import { ForbiddenError as UpdateManagedPolicyForbiddenError } from "./types/UpdateManagedPolicy/UpdateManagedPolicyError";
import { NotFoundError as UpdateManagedPolicyNotFoundError } from "./types/UpdateManagedPolicy/UpdateManagedPolicyError";
import { InternalServerError as UpdateManagedPolicyInternalServerError } from "./types/UpdateManagedPolicy/UpdateManagedPolicyError";
import { BadGatewayError as UpdateManagedPolicyBadGatewayError } from "./types/UpdateManagedPolicy/UpdateManagedPolicyError";
import { GatewayTimeoutError as UpdateManagedPolicyGatewayTimeoutError } from "./types/UpdateManagedPolicy/UpdateManagedPolicyError";
import { GenericError as UpdateMfaGenericError } from "./types/UpdateMfa/UpdateMfaError";
import { InvalidParameterError as UpdateMfaInvalidParameterError } from "./types/UpdateMfa/UpdateMfaError";
import { UnauthorizedError as UpdateMfaUnauthorizedError } from "./types/UpdateMfa/UpdateMfaError";
import { MfaFactorNotVerifiedError as UpdateMfaMfaFactorNotVerifiedError } from "./types/UpdateMfa/UpdateMfaError";
import { ForbiddenError as UpdateMfaForbiddenError } from "./types/UpdateMfa/UpdateMfaError";
import { NotFoundError as UpdateMfaNotFoundError } from "./types/UpdateMfa/UpdateMfaError";
import { InternalServerError as UpdateMfaInternalServerError } from "./types/UpdateMfa/UpdateMfaError";
import { BadGatewayError as UpdateMfaBadGatewayError } from "./types/UpdateMfa/UpdateMfaError";
import { GatewayTimeoutError as UpdateMfaGatewayTimeoutError } from "./types/UpdateMfa/UpdateMfaError";
import { GenericError as UpdatePasswordGenericError } from "./types/UpdatePassword/UpdatePasswordError";
import { InvalidParameterError as UpdatePasswordInvalidParameterError } from "./types/UpdatePassword/UpdatePasswordError";
import { UnauthorizedError as UpdatePasswordUnauthorizedError } from "./types/UpdatePassword/UpdatePasswordError";
import { InvalidAuthenticationModeError as UpdatePasswordInvalidAuthenticationModeError } from "./types/UpdatePassword/UpdatePasswordError";
import { PasswordDoesNotMatchError as UpdatePasswordPasswordDoesNotMatchError } from "./types/UpdatePassword/UpdatePasswordError";
import { ForbiddenError as UpdatePasswordForbiddenError } from "./types/UpdatePassword/UpdatePasswordError";
import { NotFoundError as UpdatePasswordNotFoundError } from "./types/UpdatePassword/UpdatePasswordError";
import { InternalServerError as UpdatePasswordInternalServerError } from "./types/UpdatePassword/UpdatePasswordError";
import { BadGatewayError as UpdatePasswordBadGatewayError } from "./types/UpdatePassword/UpdatePasswordError";
import { GatewayTimeoutError as UpdatePasswordGatewayTimeoutError } from "./types/UpdatePassword/UpdatePasswordError";
import { GenericError as UpdatePolicyGenericError } from "./types/UpdatePolicy/UpdatePolicyError";
import { InvalidParameterError as UpdatePolicyInvalidParameterError } from "./types/UpdatePolicy/UpdatePolicyError";
import { UnauthorizedError as UpdatePolicyUnauthorizedError } from "./types/UpdatePolicy/UpdatePolicyError";
import { ForbiddenError as UpdatePolicyForbiddenError } from "./types/UpdatePolicy/UpdatePolicyError";
import { NotFoundError as UpdatePolicyNotFoundError } from "./types/UpdatePolicy/UpdatePolicyError";
import { InternalServerError as UpdatePolicyInternalServerError } from "./types/UpdatePolicy/UpdatePolicyError";
import { BadGatewayError as UpdatePolicyBadGatewayError } from "./types/UpdatePolicy/UpdatePolicyError";
import { GatewayTimeoutError as UpdatePolicyGatewayTimeoutError } from "./types/UpdatePolicy/UpdatePolicyError";
import { GenericError as UpdateProviderGenericError } from "./types/UpdateProvider/UpdateProviderError";
import { InvalidParameterError as UpdateProviderInvalidParameterError } from "./types/UpdateProvider/UpdateProviderError";
import { UnauthorizedError as UpdateProviderUnauthorizedError } from "./types/UpdateProvider/UpdateProviderError";
import { InvalidCertificateError as UpdateProviderInvalidCertificateError } from "./types/UpdateProvider/UpdateProviderError";
import { ForbiddenError as UpdateProviderForbiddenError } from "./types/UpdateProvider/UpdateProviderError";
import { NotFoundError as UpdateProviderNotFoundError } from "./types/UpdateProvider/UpdateProviderError";
import { InternalServerError as UpdateProviderInternalServerError } from "./types/UpdateProvider/UpdateProviderError";
import { BadGatewayError as UpdateProviderBadGatewayError } from "./types/UpdateProvider/UpdateProviderError";
import { GatewayTimeoutError as UpdateProviderGatewayTimeoutError } from "./types/UpdateProvider/UpdateProviderError";
import { GenericError as UpdateRoleGenericError } from "./types/UpdateRole/UpdateRoleError";
import { InvalidParameterError as UpdateRoleInvalidParameterError } from "./types/UpdateRole/UpdateRoleError";
import { UnauthorizedError as UpdateRoleUnauthorizedError } from "./types/UpdateRole/UpdateRoleError";
import { ForbiddenError as UpdateRoleForbiddenError } from "./types/UpdateRole/UpdateRoleError";
import { NotFoundError as UpdateRoleNotFoundError } from "./types/UpdateRole/UpdateRoleError";
import { InternalServerError as UpdateRoleInternalServerError } from "./types/UpdateRole/UpdateRoleError";
import { BadGatewayError as UpdateRoleBadGatewayError } from "./types/UpdateRole/UpdateRoleError";
import { GatewayTimeoutError as UpdateRoleGatewayTimeoutError } from "./types/UpdateRole/UpdateRoleError";
import { GenericError as UpdateSecurityGenericError } from "./types/UpdateSecurity/UpdateSecurityError";
import { InvalidParameterError as UpdateSecurityInvalidParameterError } from "./types/UpdateSecurity/UpdateSecurityError";
import { UnauthorizedError as UpdateSecurityUnauthorizedError } from "./types/UpdateSecurity/UpdateSecurityError";
import { ForbiddenError as UpdateSecurityForbiddenError } from "./types/UpdateSecurity/UpdateSecurityError";
import { NotFoundError as UpdateSecurityNotFoundError } from "./types/UpdateSecurity/UpdateSecurityError";
import { InternalServerError as UpdateSecurityInternalServerError } from "./types/UpdateSecurity/UpdateSecurityError";
import { BadGatewayError as UpdateSecurityBadGatewayError } from "./types/UpdateSecurity/UpdateSecurityError";
import { GatewayTimeoutError as UpdateSecurityGatewayTimeoutError } from "./types/UpdateSecurity/UpdateSecurityError";
import { GenericError as UpdateTeamGenericError } from "./types/UpdateTeam/UpdateTeamError";
import { InvalidParameterError as UpdateTeamInvalidParameterError } from "./types/UpdateTeam/UpdateTeamError";
import { UnauthorizedError as UpdateTeamUnauthorizedError } from "./types/UpdateTeam/UpdateTeamError";
import { ForbiddenError as UpdateTeamForbiddenError } from "./types/UpdateTeam/UpdateTeamError";
import { NotFoundError as UpdateTeamNotFoundError } from "./types/UpdateTeam/UpdateTeamError";
import { InternalServerError as UpdateTeamInternalServerError } from "./types/UpdateTeam/UpdateTeamError";
import { BadGatewayError as UpdateTeamBadGatewayError } from "./types/UpdateTeam/UpdateTeamError";
import { GatewayTimeoutError as UpdateTeamGatewayTimeoutError } from "./types/UpdateTeam/UpdateTeamError";
import { GenericError as UpdateTeamGroupGenericError } from "./types/UpdateTeamGroup/UpdateTeamGroupError";
import { InvalidParameterError as UpdateTeamGroupInvalidParameterError } from "./types/UpdateTeamGroup/UpdateTeamGroupError";
import { UnauthorizedError as UpdateTeamGroupUnauthorizedError } from "./types/UpdateTeamGroup/UpdateTeamGroupError";
import { ForbiddenError as UpdateTeamGroupForbiddenError } from "./types/UpdateTeamGroup/UpdateTeamGroupError";
import { NotFoundError as UpdateTeamGroupNotFoundError } from "./types/UpdateTeamGroup/UpdateTeamGroupError";
import { InternalServerError as UpdateTeamGroupInternalServerError } from "./types/UpdateTeamGroup/UpdateTeamGroupError";
import { BadGatewayError as UpdateTeamGroupBadGatewayError } from "./types/UpdateTeamGroup/UpdateTeamGroupError";
import { GatewayTimeoutError as UpdateTeamGroupGatewayTimeoutError } from "./types/UpdateTeamGroup/UpdateTeamGroupError";
import { GenericError as UpdateTeamUserGenericError } from "./types/UpdateTeamUser/UpdateTeamUserError";
import { InvalidParameterError as UpdateTeamUserInvalidParameterError } from "./types/UpdateTeamUser/UpdateTeamUserError";
import { UnauthorizedError as UpdateTeamUserUnauthorizedError } from "./types/UpdateTeamUser/UpdateTeamUserError";
import { InvalidSubscriptionError as UpdateTeamUserInvalidSubscriptionError } from "./types/UpdateTeamUser/UpdateTeamUserError";
import { ForbiddenToUpdateProvisionedUserError as UpdateTeamUserForbiddenToUpdateProvisionedUserError } from "./types/UpdateTeamUser/UpdateTeamUserError";
import { ForbiddenError as UpdateTeamUserForbiddenError } from "./types/UpdateTeamUser/UpdateTeamUserError";
import { NotFoundError as UpdateTeamUserNotFoundError } from "./types/UpdateTeamUser/UpdateTeamUserError";
import { ConflictError as UpdateTeamUserConflictError } from "./types/UpdateTeamUser/UpdateTeamUserError";
import { InternalServerError as UpdateTeamUserInternalServerError } from "./types/UpdateTeamUser/UpdateTeamUserError";
import { BadGatewayError as UpdateTeamUserBadGatewayError } from "./types/UpdateTeamUser/UpdateTeamUserError";
import { GatewayTimeoutError as UpdateTeamUserGatewayTimeoutError } from "./types/UpdateTeamUser/UpdateTeamUserError";
import { GenericError as UpdateUserGenericError } from "./types/UpdateUser/UpdateUserError";
import { InvalidParameterError as UpdateUserInvalidParameterError } from "./types/UpdateUser/UpdateUserError";
import { UnauthorizedError as UpdateUserUnauthorizedError } from "./types/UpdateUser/UpdateUserError";
import { ForbiddenToUpdateProvisionedUserError as UpdateUserForbiddenToUpdateProvisionedUserError } from "./types/UpdateUser/UpdateUserError";
import { InvalidSubscriptionError as UpdateUserInvalidSubscriptionError } from "./types/UpdateUser/UpdateUserError";
import { ForbiddenError as UpdateUserForbiddenError } from "./types/UpdateUser/UpdateUserError";
import { NotFoundError as UpdateUserNotFoundError } from "./types/UpdateUser/UpdateUserError";
import { InternalServerError as UpdateUserInternalServerError } from "./types/UpdateUser/UpdateUserError";
import { BadGatewayError as UpdateUserBadGatewayError } from "./types/UpdateUser/UpdateUserError";
import { GatewayTimeoutError as UpdateUserGatewayTimeoutError } from "./types/UpdateUser/UpdateUserError";
import { GenericError as UpdateUserMfaGenericError } from "./types/UpdateUserMfa/UpdateUserMfaError";
import { InvalidParameterError as UpdateUserMfaInvalidParameterError } from "./types/UpdateUserMfa/UpdateUserMfaError";
import { UnauthorizedError as UpdateUserMfaUnauthorizedError } from "./types/UpdateUserMfa/UpdateUserMfaError";
import { MfaFactorNotVerifiedError as UpdateUserMfaMfaFactorNotVerifiedError } from "./types/UpdateUserMfa/UpdateUserMfaError";
import { ForbiddenError as UpdateUserMfaForbiddenError } from "./types/UpdateUserMfa/UpdateUserMfaError";
import { NotFoundError as UpdateUserMfaNotFoundError } from "./types/UpdateUserMfa/UpdateUserMfaError";
import { InternalServerError as UpdateUserMfaInternalServerError } from "./types/UpdateUserMfa/UpdateUserMfaError";
import { BadGatewayError as UpdateUserMfaBadGatewayError } from "./types/UpdateUserMfa/UpdateUserMfaError";
import { GatewayTimeoutError as UpdateUserMfaGatewayTimeoutError } from "./types/UpdateUserMfa/UpdateUserMfaError";
import { GenericError as UpdateUserSCIMGenericError } from "./types/UpdateUserSCIM/UpdateUserSCIMError";
import { InvalidParameterError as UpdateUserSCIMInvalidParameterError } from "./types/UpdateUserSCIM/UpdateUserSCIMError";
import { UnauthorizedError as UpdateUserSCIMUnauthorizedError } from "./types/UpdateUserSCIM/UpdateUserSCIMError";
import { ForbiddenError as UpdateUserSCIMForbiddenError } from "./types/UpdateUserSCIM/UpdateUserSCIMError";
import { NotFoundError as UpdateUserSCIMNotFoundError } from "./types/UpdateUserSCIM/UpdateUserSCIMError";
import { ConflictError as UpdateUserSCIMConflictError } from "./types/UpdateUserSCIM/UpdateUserSCIMError";
import { InternalServerError as UpdateUserSCIMInternalServerError } from "./types/UpdateUserSCIM/UpdateUserSCIMError";
import { BadGatewayError as UpdateUserSCIMBadGatewayError } from "./types/UpdateUserSCIM/UpdateUserSCIMError";
import { GatewayTimeoutError as UpdateUserSCIMGatewayTimeoutError } from "./types/UpdateUserSCIM/UpdateUserSCIMError";
import { GenericError as VerifyMfaFactorGenericError } from "./types/VerifyMfaFactor/VerifyMfaFactorError";
import { InvalidParameterError as VerifyMfaFactorInvalidParameterError } from "./types/VerifyMfaFactor/VerifyMfaFactorError";
import { InvalidTokenError as VerifyMfaFactorInvalidTokenError } from "./types/VerifyMfaFactor/VerifyMfaFactorError";
import { InvalidOtpError as VerifyMfaFactorInvalidOtpError } from "./types/VerifyMfaFactor/VerifyMfaFactorError";
import { MfaFactorNotAllowedError as VerifyMfaFactorMfaFactorNotAllowedError } from "./types/VerifyMfaFactor/VerifyMfaFactorError";
import { NotFoundError as VerifyMfaFactorNotFoundError } from "./types/VerifyMfaFactor/VerifyMfaFactorError";
import { InternalServerError as VerifyMfaFactorInternalServerError } from "./types/VerifyMfaFactor/VerifyMfaFactorError";
import { BadGatewayError as VerifyMfaFactorBadGatewayError } from "./types/VerifyMfaFactor/VerifyMfaFactorError";
import { GatewayTimeoutError as VerifyMfaFactorGatewayTimeoutError } from "./types/VerifyMfaFactor/VerifyMfaFactorError";
import { GenericError as VerifyOtpGenericError } from "./types/VerifyOtp/VerifyOtpError";
import { InvalidParameterError as VerifyOtpInvalidParameterError } from "./types/VerifyOtp/VerifyOtpError";
import { InvalidOtpError as VerifyOtpInvalidOtpError } from "./types/VerifyOtp/VerifyOtpError";
import { InvalidTokenError as VerifyOtpInvalidTokenError } from "./types/VerifyOtp/VerifyOtpError";
import { TokenExpiredError as VerifyOtpTokenExpiredError } from "./types/VerifyOtp/VerifyOtpError";
import { NotFoundError as VerifyOtpNotFoundError } from "./types/VerifyOtp/VerifyOtpError";
import { InternalServerError as VerifyOtpInternalServerError } from "./types/VerifyOtp/VerifyOtpError";
import { BadGatewayError as VerifyOtpBadGatewayError } from "./types/VerifyOtp/VerifyOtpError";
import { GatewayTimeoutError as VerifyOtpGatewayTimeoutError } from "./types/VerifyOtp/VerifyOtpError";
import { GenericError as VerifyUserMfaFactorGenericError } from "./types/VerifyUserMfaFactor/VerifyUserMfaFactorError";
import { InvalidParameterError as VerifyUserMfaFactorInvalidParameterError } from "./types/VerifyUserMfaFactor/VerifyUserMfaFactorError";
import { InvalidTokenError as VerifyUserMfaFactorInvalidTokenError } from "./types/VerifyUserMfaFactor/VerifyUserMfaFactorError";
import { InvalidOtpError as VerifyUserMfaFactorInvalidOtpError } from "./types/VerifyUserMfaFactor/VerifyUserMfaFactorError";
import { MfaFactorNotAllowedError as VerifyUserMfaFactorMfaFactorNotAllowedError } from "./types/VerifyUserMfaFactor/VerifyUserMfaFactorError";
import { NotFoundError as VerifyUserMfaFactorNotFoundError } from "./types/VerifyUserMfaFactor/VerifyUserMfaFactorError";
import { InternalServerError as VerifyUserMfaFactorInternalServerError } from "./types/VerifyUserMfaFactor/VerifyUserMfaFactorError";
import { BadGatewayError as VerifyUserMfaFactorBadGatewayError } from "./types/VerifyUserMfaFactor/VerifyUserMfaFactorError";
import { GatewayTimeoutError as VerifyUserMfaFactorGatewayTimeoutError } from "./types/VerifyUserMfaFactor/VerifyUserMfaFactorError";
import { GenericError as DeleteTeamGenericError } from "./types/DeleteTeam/DeleteTeamError";
import { InvalidParameterError as DeleteTeamInvalidParameterError } from "./types/DeleteTeam/DeleteTeamError";
import { UnauthorizedError as DeleteTeamUnauthorizedError } from "./types/DeleteTeam/DeleteTeamError";
import { ForbiddenError as DeleteTeamForbiddenError } from "./types/DeleteTeam/DeleteTeamError";
import { NotFoundError as DeleteTeamNotFoundError } from "./types/DeleteTeam/DeleteTeamError";
import { InternalServerError as DeleteTeamInternalServerError } from "./types/DeleteTeam/DeleteTeamError";
import { BadGatewayError as DeleteTeamBadGatewayError } from "./types/DeleteTeam/DeleteTeamError";
import { GatewayTimeoutError as DeleteTeamGatewayTimeoutError } from "./types/DeleteTeam/DeleteTeamError";
import { GenericError as DeleteUserGenericError } from "./types/DeleteUser/DeleteUserError";
import { InvalidParameterError as DeleteUserInvalidParameterError } from "./types/DeleteUser/DeleteUserError";
import { UnauthorizedError as DeleteUserUnauthorizedError } from "./types/DeleteUser/DeleteUserError";
import { ForbiddenError as DeleteUserForbiddenError } from "./types/DeleteUser/DeleteUserError";
import { NotFoundError as DeleteUserNotFoundError } from "./types/DeleteUser/DeleteUserError";
import { InternalServerError as DeleteUserInternalServerError } from "./types/DeleteUser/DeleteUserError";
import { BadGatewayError as DeleteUserBadGatewayError } from "./types/DeleteUser/DeleteUserError";
import { GatewayTimeoutError as DeleteUserGatewayTimeoutError } from "./types/DeleteUser/DeleteUserError";
import { GenericError as DeleteUserSCIMGenericError } from "./types/DeleteUserSCIM/DeleteUserSCIMError";
import { InvalidParameterError as DeleteUserSCIMInvalidParameterError } from "./types/DeleteUserSCIM/DeleteUserSCIMError";
import { UnauthorizedError as DeleteUserSCIMUnauthorizedError } from "./types/DeleteUserSCIM/DeleteUserSCIMError";
import { ForbiddenError as DeleteUserSCIMForbiddenError } from "./types/DeleteUserSCIM/DeleteUserSCIMError";
import { NotFoundError as DeleteUserSCIMNotFoundError } from "./types/DeleteUserSCIM/DeleteUserSCIMError";
import { InternalServerError as DeleteUserSCIMInternalServerError } from "./types/DeleteUserSCIM/DeleteUserSCIMError";
import { BadGatewayError as DeleteUserSCIMBadGatewayError } from "./types/DeleteUserSCIM/DeleteUserSCIMError";
import { GatewayTimeoutError as DeleteUserSCIMGatewayTimeoutError } from "./types/DeleteUserSCIM/DeleteUserSCIMError";
import { GenericError as DetachGroupRoleGenericError } from "./types/DetachGroupRole/DetachGroupRoleError";
import { InvalidParameterError as DetachGroupRoleInvalidParameterError } from "./types/DetachGroupRole/DetachGroupRoleError";
import { UnauthorizedError as DetachGroupRoleUnauthorizedError } from "./types/DetachGroupRole/DetachGroupRoleError";
import { ForbiddenError as DetachGroupRoleForbiddenError } from "./types/DetachGroupRole/DetachGroupRoleError";
import { NotFoundError as DetachGroupRoleNotFoundError } from "./types/DetachGroupRole/DetachGroupRoleError";
import { InternalServerError as DetachGroupRoleInternalServerError } from "./types/DetachGroupRole/DetachGroupRoleError";
import { BadGatewayError as DetachGroupRoleBadGatewayError } from "./types/DetachGroupRole/DetachGroupRoleError";
import { GatewayTimeoutError as DetachGroupRoleGatewayTimeoutError } from "./types/DetachGroupRole/DetachGroupRoleError";
import { GenericError as DetachGroupUserGenericError } from "./types/DetachGroupUser/DetachGroupUserError";
import { InvalidParameterError as DetachGroupUserInvalidParameterError } from "./types/DetachGroupUser/DetachGroupUserError";
import { UnauthorizedError as DetachGroupUserUnauthorizedError } from "./types/DetachGroupUser/DetachGroupUserError";
import { ForbiddenError as DetachGroupUserForbiddenError } from "./types/DetachGroupUser/DetachGroupUserError";
import { NotFoundError as DetachGroupUserNotFoundError } from "./types/DetachGroupUser/DetachGroupUserError";
import { InternalServerError as DetachGroupUserInternalServerError } from "./types/DetachGroupUser/DetachGroupUserError";
import { BadGatewayError as DetachGroupUserBadGatewayError } from "./types/DetachGroupUser/DetachGroupUserError";
import { GatewayTimeoutError as DetachGroupUserGatewayTimeoutError } from "./types/DetachGroupUser/DetachGroupUserError";
import { GenericError as DetachRolePolicyGenericError } from "./types/DetachRolePolicy/DetachRolePolicyError";
import { InvalidParameterError as DetachRolePolicyInvalidParameterError } from "./types/DetachRolePolicy/DetachRolePolicyError";
import { UnauthorizedError as DetachRolePolicyUnauthorizedError } from "./types/DetachRolePolicy/DetachRolePolicyError";
import { ForbiddenError as DetachRolePolicyForbiddenError } from "./types/DetachRolePolicy/DetachRolePolicyError";
import { NotFoundError as DetachRolePolicyNotFoundError } from "./types/DetachRolePolicy/DetachRolePolicyError";
import { InternalServerError as DetachRolePolicyInternalServerError } from "./types/DetachRolePolicy/DetachRolePolicyError";
import { BadGatewayError as DetachRolePolicyBadGatewayError } from "./types/DetachRolePolicy/DetachRolePolicyError";
import { GatewayTimeoutError as DetachRolePolicyGatewayTimeoutError } from "./types/DetachRolePolicy/DetachRolePolicyError";
import { GenericError as DetachTeamGroupGenericError } from "./types/DetachTeamGroup/DetachTeamGroupError";
import { InvalidParameterError as DetachTeamGroupInvalidParameterError } from "./types/DetachTeamGroup/DetachTeamGroupError";
import { UnauthorizedError as DetachTeamGroupUnauthorizedError } from "./types/DetachTeamGroup/DetachTeamGroupError";
import { ForbiddenError as DetachTeamGroupForbiddenError } from "./types/DetachTeamGroup/DetachTeamGroupError";
import { NotFoundError as DetachTeamGroupNotFoundError } from "./types/DetachTeamGroup/DetachTeamGroupError";
import { InternalServerError as DetachTeamGroupInternalServerError } from "./types/DetachTeamGroup/DetachTeamGroupError";
import { BadGatewayError as DetachTeamGroupBadGatewayError } from "./types/DetachTeamGroup/DetachTeamGroupError";
import { GatewayTimeoutError as DetachTeamGroupGatewayTimeoutError } from "./types/DetachTeamGroup/DetachTeamGroupError";
import { GenericError as DetachTeamGroupRoleGenericError } from "./types/DetachTeamGroupRole/DetachTeamGroupRoleError";
import { InvalidParameterError as DetachTeamGroupRoleInvalidParameterError } from "./types/DetachTeamGroupRole/DetachTeamGroupRoleError";
import { UnauthorizedError as DetachTeamGroupRoleUnauthorizedError } from "./types/DetachTeamGroupRole/DetachTeamGroupRoleError";
import { ForbiddenError as DetachTeamGroupRoleForbiddenError } from "./types/DetachTeamGroupRole/DetachTeamGroupRoleError";
import { NotFoundError as DetachTeamGroupRoleNotFoundError } from "./types/DetachTeamGroupRole/DetachTeamGroupRoleError";
import { InternalServerError as DetachTeamGroupRoleInternalServerError } from "./types/DetachTeamGroupRole/DetachTeamGroupRoleError";
import { BadGatewayError as DetachTeamGroupRoleBadGatewayError } from "./types/DetachTeamGroupRole/DetachTeamGroupRoleError";
import { GatewayTimeoutError as DetachTeamGroupRoleGatewayTimeoutError } from "./types/DetachTeamGroupRole/DetachTeamGroupRoleError";
import { GenericError as DetachTeamGroupUserGenericError } from "./types/DetachTeamGroupUser/DetachTeamGroupUserError";
import { InvalidParameterError as DetachTeamGroupUserInvalidParameterError } from "./types/DetachTeamGroupUser/DetachTeamGroupUserError";
import { UnauthorizedError as DetachTeamGroupUserUnauthorizedError } from "./types/DetachTeamGroupUser/DetachTeamGroupUserError";
import { ForbiddenError as DetachTeamGroupUserForbiddenError } from "./types/DetachTeamGroupUser/DetachTeamGroupUserError";
import { NotFoundError as DetachTeamGroupUserNotFoundError } from "./types/DetachTeamGroupUser/DetachTeamGroupUserError";
import { InternalServerError as DetachTeamGroupUserInternalServerError } from "./types/DetachTeamGroupUser/DetachTeamGroupUserError";
import { BadGatewayError as DetachTeamGroupUserBadGatewayError } from "./types/DetachTeamGroupUser/DetachTeamGroupUserError";
import { GatewayTimeoutError as DetachTeamGroupUserGatewayTimeoutError } from "./types/DetachTeamGroupUser/DetachTeamGroupUserError";
import { GenericError as DetachTeamRoleGenericError } from "./types/DetachTeamRole/DetachTeamRoleError";
import { InvalidParameterError as DetachTeamRoleInvalidParameterError } from "./types/DetachTeamRole/DetachTeamRoleError";
import { UnauthorizedError as DetachTeamRoleUnauthorizedError } from "./types/DetachTeamRole/DetachTeamRoleError";
import { ForbiddenError as DetachTeamRoleForbiddenError } from "./types/DetachTeamRole/DetachTeamRoleError";
import { NotFoundError as DetachTeamRoleNotFoundError } from "./types/DetachTeamRole/DetachTeamRoleError";
import { InternalServerError as DetachTeamRoleInternalServerError } from "./types/DetachTeamRole/DetachTeamRoleError";
import { BadGatewayError as DetachTeamRoleBadGatewayError } from "./types/DetachTeamRole/DetachTeamRoleError";
import { GatewayTimeoutError as DetachTeamRoleGatewayTimeoutError } from "./types/DetachTeamRole/DetachTeamRoleError";
import { GenericError as DetachTeamUserGenericError } from "./types/DetachTeamUser/DetachTeamUserError";
import { InvalidParameterError as DetachTeamUserInvalidParameterError } from "./types/DetachTeamUser/DetachTeamUserError";
import { UnauthorizedError as DetachTeamUserUnauthorizedError } from "./types/DetachTeamUser/DetachTeamUserError";
import { ForbiddenError as DetachTeamUserForbiddenError } from "./types/DetachTeamUser/DetachTeamUserError";
import { NotFoundError as DetachTeamUserNotFoundError } from "./types/DetachTeamUser/DetachTeamUserError";
import { InternalServerError as DetachTeamUserInternalServerError } from "./types/DetachTeamUser/DetachTeamUserError";
import { BadGatewayError as DetachTeamUserBadGatewayError } from "./types/DetachTeamUser/DetachTeamUserError";
import { GatewayTimeoutError as DetachTeamUserGatewayTimeoutError } from "./types/DetachTeamUser/DetachTeamUserError";
import { GenericError as DetachTeamUserRoleGenericError } from "./types/DetachTeamUserRole/DetachTeamUserRoleError";
import { InvalidParameterError as DetachTeamUserRoleInvalidParameterError } from "./types/DetachTeamUserRole/DetachTeamUserRoleError";
import { UnauthorizedError as DetachTeamUserRoleUnauthorizedError } from "./types/DetachTeamUserRole/DetachTeamUserRoleError";
import { ForbiddenError as DetachTeamUserRoleForbiddenError } from "./types/DetachTeamUserRole/DetachTeamUserRoleError";
import { NotFoundError as DetachTeamUserRoleNotFoundError } from "./types/DetachTeamUserRole/DetachTeamUserRoleError";
import { InternalServerError as DetachTeamUserRoleInternalServerError } from "./types/DetachTeamUserRole/DetachTeamUserRoleError";
import { BadGatewayError as DetachTeamUserRoleBadGatewayError } from "./types/DetachTeamUserRole/DetachTeamUserRoleError";
import { GatewayTimeoutError as DetachTeamUserRoleGatewayTimeoutError } from "./types/DetachTeamUserRole/DetachTeamUserRoleError";
import { GenericError as DetachUserRoleGenericError } from "./types/DetachUserRole/DetachUserRoleError";
import { InvalidParameterError as DetachUserRoleInvalidParameterError } from "./types/DetachUserRole/DetachUserRoleError";
import { UnauthorizedError as DetachUserRoleUnauthorizedError } from "./types/DetachUserRole/DetachUserRoleError";
import { ForbiddenError as DetachUserRoleForbiddenError } from "./types/DetachUserRole/DetachUserRoleError";
import { NotFoundError as DetachUserRoleNotFoundError } from "./types/DetachUserRole/DetachUserRoleError";
import { InternalServerError as DetachUserRoleInternalServerError } from "./types/DetachUserRole/DetachUserRoleError";
import { BadGatewayError as DetachUserRoleBadGatewayError } from "./types/DetachUserRole/DetachUserRoleError";
import { GatewayTimeoutError as DetachUserRoleGatewayTimeoutError } from "./types/DetachUserRole/DetachUserRoleError";
import { GenericError as ForgotPasswordGenericError } from "./types/ForgotPassword/ForgotPasswordError";
import { InvalidParameterError as ForgotPasswordInvalidParameterError } from "./types/ForgotPassword/ForgotPasswordError";
import { InvalidIdentityUsernameError as ForgotPasswordInvalidIdentityUsernameError } from "./types/ForgotPassword/ForgotPasswordError";
import { NotFoundError as ForgotPasswordNotFoundError } from "./types/ForgotPassword/ForgotPasswordError";
import { InternalServerError as ForgotPasswordInternalServerError } from "./types/ForgotPassword/ForgotPasswordError";
import { BadGatewayError as ForgotPasswordBadGatewayError } from "./types/ForgotPassword/ForgotPasswordError";
import { GatewayTimeoutError as ForgotPasswordGatewayTimeoutError } from "./types/ForgotPassword/ForgotPasswordError";
import { GenericError as GetAccountGenericError } from "./types/GetAccount/GetAccountError";
import { UnauthorizedError as GetAccountUnauthorizedError } from "./types/GetAccount/GetAccountError";
import { ForbiddenError as GetAccountForbiddenError } from "./types/GetAccount/GetAccountError";
import { NotFoundError as GetAccountNotFoundError } from "./types/GetAccount/GetAccountError";
import { InternalServerError as GetAccountInternalServerError } from "./types/GetAccount/GetAccountError";
import { BadGatewayError as GetAccountBadGatewayError } from "./types/GetAccount/GetAccountError";
import { GatewayTimeoutError as GetAccountGatewayTimeoutError } from "./types/GetAccount/GetAccountError";
import { GenericError as GetGroupGenericError } from "./types/GetGroup/GetGroupError";
import { InvalidParameterError as GetGroupInvalidParameterError } from "./types/GetGroup/GetGroupError";
import { UnauthorizedError as GetGroupUnauthorizedError } from "./types/GetGroup/GetGroupError";
import { ForbiddenError as GetGroupForbiddenError } from "./types/GetGroup/GetGroupError";
import { NotFoundError as GetGroupNotFoundError } from "./types/GetGroup/GetGroupError";
import { InternalServerError as GetGroupInternalServerError } from "./types/GetGroup/GetGroupError";
import { BadGatewayError as GetGroupBadGatewayError } from "./types/GetGroup/GetGroupError";
import { GatewayTimeoutError as GetGroupGatewayTimeoutError } from "./types/GetGroup/GetGroupError";
import { GenericError as GetGroupSCIMGenericError } from "./types/GetGroupSCIM/GetGroupSCIMError";
import { InvalidParameterError as GetGroupSCIMInvalidParameterError } from "./types/GetGroupSCIM/GetGroupSCIMError";
import { UnauthorizedError as GetGroupSCIMUnauthorizedError } from "./types/GetGroupSCIM/GetGroupSCIMError";
import { ForbiddenError as GetGroupSCIMForbiddenError } from "./types/GetGroupSCIM/GetGroupSCIMError";
import { NotFoundError as GetGroupSCIMNotFoundError } from "./types/GetGroupSCIM/GetGroupSCIMError";
import { InternalServerError as GetGroupSCIMInternalServerError } from "./types/GetGroupSCIM/GetGroupSCIMError";
import { BadGatewayError as GetGroupSCIMBadGatewayError } from "./types/GetGroupSCIM/GetGroupSCIMError";
import { GatewayTimeoutError as GetGroupSCIMGatewayTimeoutError } from "./types/GetGroupSCIM/GetGroupSCIMError";
import { GenericError as GetMfaGenericError } from "./types/GetMfa/GetMfaError";
import { UnauthorizedError as GetMfaUnauthorizedError } from "./types/GetMfa/GetMfaError";
import { ForbiddenError as GetMfaForbiddenError } from "./types/GetMfa/GetMfaError";
import { NotFoundError as GetMfaNotFoundError } from "./types/GetMfa/GetMfaError";
import { InternalServerError as GetMfaInternalServerError } from "./types/GetMfa/GetMfaError";
import { BadGatewayError as GetMfaBadGatewayError } from "./types/GetMfa/GetMfaError";
import { GatewayTimeoutError as GetMfaGatewayTimeoutError } from "./types/GetMfa/GetMfaError";
import { GenericError as GetPolicyGenericError } from "./types/GetPolicy/GetPolicyError";
import { InvalidParameterError as GetPolicyInvalidParameterError } from "./types/GetPolicy/GetPolicyError";
import { UnauthorizedError as GetPolicyUnauthorizedError } from "./types/GetPolicy/GetPolicyError";
import { ForbiddenError as GetPolicyForbiddenError } from "./types/GetPolicy/GetPolicyError";
import { NotFoundError as GetPolicyNotFoundError } from "./types/GetPolicy/GetPolicyError";
import { InternalServerError as GetPolicyInternalServerError } from "./types/GetPolicy/GetPolicyError";
import { BadGatewayError as GetPolicyBadGatewayError } from "./types/GetPolicy/GetPolicyError";
import { GatewayTimeoutError as GetPolicyGatewayTimeoutError } from "./types/GetPolicy/GetPolicyError";
import { GenericError as GetProviderGenericError } from "./types/GetProvider/GetProviderError";
import { InvalidParameterError as GetProviderInvalidParameterError } from "./types/GetProvider/GetProviderError";
import { UnauthorizedError as GetProviderUnauthorizedError } from "./types/GetProvider/GetProviderError";
import { ForbiddenError as GetProviderForbiddenError } from "./types/GetProvider/GetProviderError";
import { NotFoundError as GetProviderNotFoundError } from "./types/GetProvider/GetProviderError";
import { InternalServerError as GetProviderInternalServerError } from "./types/GetProvider/GetProviderError";
import { BadGatewayError as GetProviderBadGatewayError } from "./types/GetProvider/GetProviderError";
import { GatewayTimeoutError as GetProviderGatewayTimeoutError } from "./types/GetProvider/GetProviderError";
import { GenericError as GetResourceTypesGenericError } from "./types/GetResourceTypes/GetResourceTypesError";
import { UnauthorizedError as GetResourceTypesUnauthorizedError } from "./types/GetResourceTypes/GetResourceTypesError";
import { ForbiddenError as GetResourceTypesForbiddenError } from "./types/GetResourceTypes/GetResourceTypesError";
import { InternalServerError as GetResourceTypesInternalServerError } from "./types/GetResourceTypes/GetResourceTypesError";
import { BadGatewayError as GetResourceTypesBadGatewayError } from "./types/GetResourceTypes/GetResourceTypesError";
import { GatewayTimeoutError as GetResourceTypesGatewayTimeoutError } from "./types/GetResourceTypes/GetResourceTypesError";
import { GenericError as GetRoleGenericError } from "./types/GetRole/GetRoleError";
import { InvalidParameterError as GetRoleInvalidParameterError } from "./types/GetRole/GetRoleError";
import { UnauthorizedError as GetRoleUnauthorizedError } from "./types/GetRole/GetRoleError";
import { ForbiddenError as GetRoleForbiddenError } from "./types/GetRole/GetRoleError";
import { NotFoundError as GetRoleNotFoundError } from "./types/GetRole/GetRoleError";
import { InternalServerError as GetRoleInternalServerError } from "./types/GetRole/GetRoleError";
import { BadGatewayError as GetRoleBadGatewayError } from "./types/GetRole/GetRoleError";
import { GatewayTimeoutError as GetRoleGatewayTimeoutError } from "./types/GetRole/GetRoleError";
import { GenericError as GetSchemasGenericError } from "./types/GetSchemas/GetSchemasError";
import { UnauthorizedError as GetSchemasUnauthorizedError } from "./types/GetSchemas/GetSchemasError";
import { ForbiddenError as GetSchemasForbiddenError } from "./types/GetSchemas/GetSchemasError";
import { InternalServerError as GetSchemasInternalServerError } from "./types/GetSchemas/GetSchemasError";
import { BadGatewayError as GetSchemasBadGatewayError } from "./types/GetSchemas/GetSchemasError";
import { GatewayTimeoutError as GetSchemasGatewayTimeoutError } from "./types/GetSchemas/GetSchemasError";
import { GenericError as GetSecurityGenericError } from "./types/GetSecurity/GetSecurityError";
import { UnauthorizedError as GetSecurityUnauthorizedError } from "./types/GetSecurity/GetSecurityError";
import { ForbiddenError as GetSecurityForbiddenError } from "./types/GetSecurity/GetSecurityError";
import { NotFoundError as GetSecurityNotFoundError } from "./types/GetSecurity/GetSecurityError";
import { InternalServerError as GetSecurityInternalServerError } from "./types/GetSecurity/GetSecurityError";
import { BadGatewayError as GetSecurityBadGatewayError } from "./types/GetSecurity/GetSecurityError";
import { GatewayTimeoutError as GetSecurityGatewayTimeoutError } from "./types/GetSecurity/GetSecurityError";
import { GenericError as GetServiceProviderConfigGenericError } from "./types/GetServiceProviderConfig/GetServiceProviderConfigError";
import { UnauthorizedError as GetServiceProviderConfigUnauthorizedError } from "./types/GetServiceProviderConfig/GetServiceProviderConfigError";
import { ForbiddenError as GetServiceProviderConfigForbiddenError } from "./types/GetServiceProviderConfig/GetServiceProviderConfigError";
import { InternalServerError as GetServiceProviderConfigInternalServerError } from "./types/GetServiceProviderConfig/GetServiceProviderConfigError";
import { BadGatewayError as GetServiceProviderConfigBadGatewayError } from "./types/GetServiceProviderConfig/GetServiceProviderConfigError";
import { GatewayTimeoutError as GetServiceProviderConfigGatewayTimeoutError } from "./types/GetServiceProviderConfig/GetServiceProviderConfigError";
import { GenericError as GetSigninConfigurationGenericError } from "./types/GetSigninConfiguration/GetSigninConfigurationError";
import { InvalidParameterError as GetSigninConfigurationInvalidParameterError } from "./types/GetSigninConfiguration/GetSigninConfigurationError";
import { NotFoundError as GetSigninConfigurationNotFoundError } from "./types/GetSigninConfiguration/GetSigninConfigurationError";
import { InternalServerError as GetSigninConfigurationInternalServerError } from "./types/GetSigninConfiguration/GetSigninConfigurationError";
import { BadGatewayError as GetSigninConfigurationBadGatewayError } from "./types/GetSigninConfiguration/GetSigninConfigurationError";
import { GatewayTimeoutError as GetSigninConfigurationGatewayTimeoutError } from "./types/GetSigninConfiguration/GetSigninConfigurationError";
import { GenericError as GetTeamGenericError } from "./types/GetTeam/GetTeamError";
import { InvalidParameterError as GetTeamInvalidParameterError } from "./types/GetTeam/GetTeamError";
import { UnauthorizedError as GetTeamUnauthorizedError } from "./types/GetTeam/GetTeamError";
import { ForbiddenError as GetTeamForbiddenError } from "./types/GetTeam/GetTeamError";
import { NotFoundError as GetTeamNotFoundError } from "./types/GetTeam/GetTeamError";
import { InternalServerError as GetTeamInternalServerError } from "./types/GetTeam/GetTeamError";
import { BadGatewayError as GetTeamBadGatewayError } from "./types/GetTeam/GetTeamError";
import { GatewayTimeoutError as GetTeamGatewayTimeoutError } from "./types/GetTeam/GetTeamError";
import { GenericError as GetTeamGroupGenericError } from "./types/GetTeamGroup/GetTeamGroupError";
import { InvalidParameterError as GetTeamGroupInvalidParameterError } from "./types/GetTeamGroup/GetTeamGroupError";
import { UnauthorizedError as GetTeamGroupUnauthorizedError } from "./types/GetTeamGroup/GetTeamGroupError";
import { ForbiddenError as GetTeamGroupForbiddenError } from "./types/GetTeamGroup/GetTeamGroupError";
import { NotFoundError as GetTeamGroupNotFoundError } from "./types/GetTeamGroup/GetTeamGroupError";
import { InternalServerError as GetTeamGroupInternalServerError } from "./types/GetTeamGroup/GetTeamGroupError";
import { BadGatewayError as GetTeamGroupBadGatewayError } from "./types/GetTeamGroup/GetTeamGroupError";
import { GatewayTimeoutError as GetTeamGroupGatewayTimeoutError } from "./types/GetTeamGroup/GetTeamGroupError";
import { GenericError as GetTeamUserGenericError } from "./types/GetTeamUser/GetTeamUserError";
import { InvalidParameterError as GetTeamUserInvalidParameterError } from "./types/GetTeamUser/GetTeamUserError";
import { UnauthorizedError as GetTeamUserUnauthorizedError } from "./types/GetTeamUser/GetTeamUserError";
import { ForbiddenError as GetTeamUserForbiddenError } from "./types/GetTeamUser/GetTeamUserError";
import { NotFoundError as GetTeamUserNotFoundError } from "./types/GetTeamUser/GetTeamUserError";
import { InternalServerError as GetTeamUserInternalServerError } from "./types/GetTeamUser/GetTeamUserError";
import { BadGatewayError as GetTeamUserBadGatewayError } from "./types/GetTeamUser/GetTeamUserError";
import { GatewayTimeoutError as GetTeamUserGatewayTimeoutError } from "./types/GetTeamUser/GetTeamUserError";
import { GenericError as GetUserGenericError } from "./types/GetUser/GetUserError";
import { InvalidParameterError as GetUserInvalidParameterError } from "./types/GetUser/GetUserError";
import { UnauthorizedError as GetUserUnauthorizedError } from "./types/GetUser/GetUserError";
import { ForbiddenError as GetUserForbiddenError } from "./types/GetUser/GetUserError";
import { NotFoundError as GetUserNotFoundError } from "./types/GetUser/GetUserError";
import { InternalServerError as GetUserInternalServerError } from "./types/GetUser/GetUserError";
import { BadGatewayError as GetUserBadGatewayError } from "./types/GetUser/GetUserError";
import { GatewayTimeoutError as GetUserGatewayTimeoutError } from "./types/GetUser/GetUserError";
import { GenericError as GetUserMfaGenericError } from "./types/GetUserMfa/GetUserMfaError";
import { InvalidParameterError as GetUserMfaInvalidParameterError } from "./types/GetUserMfa/GetUserMfaError";
import { UnauthorizedError as GetUserMfaUnauthorizedError } from "./types/GetUserMfa/GetUserMfaError";
import { ForbiddenError as GetUserMfaForbiddenError } from "./types/GetUserMfa/GetUserMfaError";
import { NotFoundError as GetUserMfaNotFoundError } from "./types/GetUserMfa/GetUserMfaError";
import { InternalServerError as GetUserMfaInternalServerError } from "./types/GetUserMfa/GetUserMfaError";
import { BadGatewayError as GetUserMfaBadGatewayError } from "./types/GetUserMfa/GetUserMfaError";
import { GatewayTimeoutError as GetUserMfaGatewayTimeoutError } from "./types/GetUserMfa/GetUserMfaError";
import { GenericError as GetUserSCIMGenericError } from "./types/GetUserSCIM/GetUserSCIMError";
import { InvalidParameterError as GetUserSCIMInvalidParameterError } from "./types/GetUserSCIM/GetUserSCIMError";
import { UnauthorizedError as GetUserSCIMUnauthorizedError } from "./types/GetUserSCIM/GetUserSCIMError";
import { ForbiddenError as GetUserSCIMForbiddenError } from "./types/GetUserSCIM/GetUserSCIMError";
import { NotFoundError as GetUserSCIMNotFoundError } from "./types/GetUserSCIM/GetUserSCIMError";
import { InternalServerError as GetUserSCIMInternalServerError } from "./types/GetUserSCIM/GetUserSCIMError";
import { BadGatewayError as GetUserSCIMBadGatewayError } from "./types/GetUserSCIM/GetUserSCIMError";
import { GatewayTimeoutError as GetUserSCIMGatewayTimeoutError } from "./types/GetUserSCIM/GetUserSCIMError";
import { GenericError as InviteTeamUserGenericError } from "./types/InviteTeamUser/InviteTeamUserError";
import { InvalidParameterError as InviteTeamUserInvalidParameterError } from "./types/InviteTeamUser/InviteTeamUserError";
import { UnauthorizedError as InviteTeamUserUnauthorizedError } from "./types/InviteTeamUser/InviteTeamUserError";
import { ForbiddenError as InviteTeamUserForbiddenError } from "./types/InviteTeamUser/InviteTeamUserError";
import { NotFoundError as InviteTeamUserNotFoundError } from "./types/InviteTeamUser/InviteTeamUserError";
import { InternalServerError as InviteTeamUserInternalServerError } from "./types/InviteTeamUser/InviteTeamUserError";
import { BadGatewayError as InviteTeamUserBadGatewayError } from "./types/InviteTeamUser/InviteTeamUserError";
import { GatewayTimeoutError as InviteTeamUserGatewayTimeoutError } from "./types/InviteTeamUser/InviteTeamUserError";
import { GenericError as InviteUserGenericError } from "./types/InviteUser/InviteUserError";
import { InvalidParameterError as InviteUserInvalidParameterError } from "./types/InviteUser/InviteUserError";
import { UnauthorizedError as InviteUserUnauthorizedError } from "./types/InviteUser/InviteUserError";
import { InvalidEmailError as InviteUserInvalidEmailError } from "./types/InviteUser/InviteUserError";
import { ForbiddenError as InviteUserForbiddenError } from "./types/InviteUser/InviteUserError";
import { NotFoundError as InviteUserNotFoundError } from "./types/InviteUser/InviteUserError";
import { InternalServerError as InviteUserInternalServerError } from "./types/InviteUser/InviteUserError";
import { BadGatewayError as InviteUserBadGatewayError } from "./types/InviteUser/InviteUserError";
import { GatewayTimeoutError as InviteUserGatewayTimeoutError } from "./types/InviteUser/InviteUserError";
import { GenericError as ListGroupRolesGenericError } from "./types/ListGroupRoles/ListGroupRolesError";
import { InvalidParameterError as ListGroupRolesInvalidParameterError } from "./types/ListGroupRoles/ListGroupRolesError";
import { UnauthorizedError as ListGroupRolesUnauthorizedError } from "./types/ListGroupRoles/ListGroupRolesError";
import { ForbiddenError as ListGroupRolesForbiddenError } from "./types/ListGroupRoles/ListGroupRolesError";
import { NotFoundError as ListGroupRolesNotFoundError } from "./types/ListGroupRoles/ListGroupRolesError";
import { InternalServerError as ListGroupRolesInternalServerError } from "./types/ListGroupRoles/ListGroupRolesError";
import { BadGatewayError as ListGroupRolesBadGatewayError } from "./types/ListGroupRoles/ListGroupRolesError";
import { GatewayTimeoutError as ListGroupRolesGatewayTimeoutError } from "./types/ListGroupRoles/ListGroupRolesError";
import { GenericError as ListGroupTeamsGenericError } from "./types/ListGroupTeams/ListGroupTeamsError";
import { InvalidParameterError as ListGroupTeamsInvalidParameterError } from "./types/ListGroupTeams/ListGroupTeamsError";
import { UnauthorizedError as ListGroupTeamsUnauthorizedError } from "./types/ListGroupTeams/ListGroupTeamsError";
import { ForbiddenError as ListGroupTeamsForbiddenError } from "./types/ListGroupTeams/ListGroupTeamsError";
import { NotFoundError as ListGroupTeamsNotFoundError } from "./types/ListGroupTeams/ListGroupTeamsError";
import { InternalServerError as ListGroupTeamsInternalServerError } from "./types/ListGroupTeams/ListGroupTeamsError";
import { BadGatewayError as ListGroupTeamsBadGatewayError } from "./types/ListGroupTeams/ListGroupTeamsError";
import { GatewayTimeoutError as ListGroupTeamsGatewayTimeoutError } from "./types/ListGroupTeams/ListGroupTeamsError";
import { GenericError as ListGroupUsersGenericError } from "./types/ListGroupUsers/ListGroupUsersError";
import { InvalidParameterError as ListGroupUsersInvalidParameterError } from "./types/ListGroupUsers/ListGroupUsersError";
import { UnauthorizedError as ListGroupUsersUnauthorizedError } from "./types/ListGroupUsers/ListGroupUsersError";
import { ForbiddenError as ListGroupUsersForbiddenError } from "./types/ListGroupUsers/ListGroupUsersError";
import { NotFoundError as ListGroupUsersNotFoundError } from "./types/ListGroupUsers/ListGroupUsersError";
import { InternalServerError as ListGroupUsersInternalServerError } from "./types/ListGroupUsers/ListGroupUsersError";
import { BadGatewayError as ListGroupUsersBadGatewayError } from "./types/ListGroupUsers/ListGroupUsersError";
import { GatewayTimeoutError as ListGroupUsersGatewayTimeoutError } from "./types/ListGroupUsers/ListGroupUsersError";
import { GenericError as AcceptInvitationGenericError } from "./types/AcceptInvitation/AcceptInvitationError";
import { InvalidParameterError as AcceptInvitationInvalidParameterError } from "./types/AcceptInvitation/AcceptInvitationError";
import { InvalidInvitationError as AcceptInvitationInvalidInvitationError } from "./types/AcceptInvitation/AcceptInvitationError";
import { InvalidInvitationSecretError as AcceptInvitationInvalidInvitationSecretError } from "./types/AcceptInvitation/AcceptInvitationError";
import { ExpiredInvitationError as AcceptInvitationExpiredInvitationError } from "./types/AcceptInvitation/AcceptInvitationError";
import { NotFoundError as AcceptInvitationNotFoundError } from "./types/AcceptInvitation/AcceptInvitationError";
import { InternalServerError as AcceptInvitationInternalServerError } from "./types/AcceptInvitation/AcceptInvitationError";
import { BadGatewayError as AcceptInvitationBadGatewayError } from "./types/AcceptInvitation/AcceptInvitationError";
import { GatewayTimeoutError as AcceptInvitationGatewayTimeoutError } from "./types/AcceptInvitation/AcceptInvitationError";
import { GenericError as AcceptUserInvitationGenericError } from "./types/AcceptUserInvitation/AcceptUserInvitationError";
import { InvalidParameterError as AcceptUserInvitationInvalidParameterError } from "./types/AcceptUserInvitation/AcceptUserInvitationError";
import { InvalidInvitationError as AcceptUserInvitationInvalidInvitationError } from "./types/AcceptUserInvitation/AcceptUserInvitationError";
import { ExpiredInvitationError as AcceptUserInvitationExpiredInvitationError } from "./types/AcceptUserInvitation/AcceptUserInvitationError";
import { NotFoundError as AcceptUserInvitationNotFoundError } from "./types/AcceptUserInvitation/AcceptUserInvitationError";
import { InternalServerError as AcceptUserInvitationInternalServerError } from "./types/AcceptUserInvitation/AcceptUserInvitationError";
import { BadGatewayError as AcceptUserInvitationBadGatewayError } from "./types/AcceptUserInvitation/AcceptUserInvitationError";
import { GatewayTimeoutError as AcceptUserInvitationGatewayTimeoutError } from "./types/AcceptUserInvitation/AcceptUserInvitationError";
import { GenericError as AttachGroupRoleGenericError } from "./types/AttachGroupRole/AttachGroupRoleError";
import { InvalidParameterError as AttachGroupRoleInvalidParameterError } from "./types/AttachGroupRole/AttachGroupRoleError";
import { UnauthorizedError as AttachGroupRoleUnauthorizedError } from "./types/AttachGroupRole/AttachGroupRoleError";
import { ForbiddenError as AttachGroupRoleForbiddenError } from "./types/AttachGroupRole/AttachGroupRoleError";
import { NotFoundError as AttachGroupRoleNotFoundError } from "./types/AttachGroupRole/AttachGroupRoleError";
import { ConflictError as AttachGroupRoleConflictError } from "./types/AttachGroupRole/AttachGroupRoleError";
import { InternalServerError as AttachGroupRoleInternalServerError } from "./types/AttachGroupRole/AttachGroupRoleError";
import { BadGatewayError as AttachGroupRoleBadGatewayError } from "./types/AttachGroupRole/AttachGroupRoleError";
import { GatewayTimeoutError as AttachGroupRoleGatewayTimeoutError } from "./types/AttachGroupRole/AttachGroupRoleError";
import { GenericError as AttachGroupUserGenericError } from "./types/AttachGroupUser/AttachGroupUserError";
import { InvalidParameterError as AttachGroupUserInvalidParameterError } from "./types/AttachGroupUser/AttachGroupUserError";
import { UnauthorizedError as AttachGroupUserUnauthorizedError } from "./types/AttachGroupUser/AttachGroupUserError";
import { ForbiddenError as AttachGroupUserForbiddenError } from "./types/AttachGroupUser/AttachGroupUserError";
import { NotFoundError as AttachGroupUserNotFoundError } from "./types/AttachGroupUser/AttachGroupUserError";
import { ConflictError as AttachGroupUserConflictError } from "./types/AttachGroupUser/AttachGroupUserError";
import { InternalServerError as AttachGroupUserInternalServerError } from "./types/AttachGroupUser/AttachGroupUserError";
import { BadGatewayError as AttachGroupUserBadGatewayError } from "./types/AttachGroupUser/AttachGroupUserError";
import { GatewayTimeoutError as AttachGroupUserGatewayTimeoutError } from "./types/AttachGroupUser/AttachGroupUserError";
import { GenericError as AttachRolePolicyGenericError } from "./types/AttachRolePolicy/AttachRolePolicyError";
import { InvalidParameterError as AttachRolePolicyInvalidParameterError } from "./types/AttachRolePolicy/AttachRolePolicyError";
import { UnauthorizedError as AttachRolePolicyUnauthorizedError } from "./types/AttachRolePolicy/AttachRolePolicyError";
import { ForbiddenError as AttachRolePolicyForbiddenError } from "./types/AttachRolePolicy/AttachRolePolicyError";
import { NotFoundError as AttachRolePolicyNotFoundError } from "./types/AttachRolePolicy/AttachRolePolicyError";
import { ConflictError as AttachRolePolicyConflictError } from "./types/AttachRolePolicy/AttachRolePolicyError";
import { InternalServerError as AttachRolePolicyInternalServerError } from "./types/AttachRolePolicy/AttachRolePolicyError";
import { BadGatewayError as AttachRolePolicyBadGatewayError } from "./types/AttachRolePolicy/AttachRolePolicyError";
import { GatewayTimeoutError as AttachRolePolicyGatewayTimeoutError } from "./types/AttachRolePolicy/AttachRolePolicyError";
import { GenericError as AttachTeamGroupGenericError } from "./types/AttachTeamGroup/AttachTeamGroupError";
import { InvalidParameterError as AttachTeamGroupInvalidParameterError } from "./types/AttachTeamGroup/AttachTeamGroupError";
import { UnauthorizedError as AttachTeamGroupUnauthorizedError } from "./types/AttachTeamGroup/AttachTeamGroupError";
import { ForbiddenError as AttachTeamGroupForbiddenError } from "./types/AttachTeamGroup/AttachTeamGroupError";
import { NotFoundError as AttachTeamGroupNotFoundError } from "./types/AttachTeamGroup/AttachTeamGroupError";
import { ConflictError as AttachTeamGroupConflictError } from "./types/AttachTeamGroup/AttachTeamGroupError";
import { InternalServerError as AttachTeamGroupInternalServerError } from "./types/AttachTeamGroup/AttachTeamGroupError";
import { BadGatewayError as AttachTeamGroupBadGatewayError } from "./types/AttachTeamGroup/AttachTeamGroupError";
import { GatewayTimeoutError as AttachTeamGroupGatewayTimeoutError } from "./types/AttachTeamGroup/AttachTeamGroupError";
import { GenericError as AttachTeamGroupRoleGenericError } from "./types/AttachTeamGroupRole/AttachTeamGroupRoleError";
import { InvalidParameterError as AttachTeamGroupRoleInvalidParameterError } from "./types/AttachTeamGroupRole/AttachTeamGroupRoleError";
import { UnauthorizedError as AttachTeamGroupRoleUnauthorizedError } from "./types/AttachTeamGroupRole/AttachTeamGroupRoleError";
import { ForbiddenError as AttachTeamGroupRoleForbiddenError } from "./types/AttachTeamGroupRole/AttachTeamGroupRoleError";
import { NotFoundError as AttachTeamGroupRoleNotFoundError } from "./types/AttachTeamGroupRole/AttachTeamGroupRoleError";
import { ConflictError as AttachTeamGroupRoleConflictError } from "./types/AttachTeamGroupRole/AttachTeamGroupRoleError";
import { InternalServerError as AttachTeamGroupRoleInternalServerError } from "./types/AttachTeamGroupRole/AttachTeamGroupRoleError";
import { BadGatewayError as AttachTeamGroupRoleBadGatewayError } from "./types/AttachTeamGroupRole/AttachTeamGroupRoleError";
import { GatewayTimeoutError as AttachTeamGroupRoleGatewayTimeoutError } from "./types/AttachTeamGroupRole/AttachTeamGroupRoleError";
import { GenericError as AttachTeamGroupUserGenericError } from "./types/AttachTeamGroupUser/AttachTeamGroupUserError";
import { InvalidParameterError as AttachTeamGroupUserInvalidParameterError } from "./types/AttachTeamGroupUser/AttachTeamGroupUserError";
import { UnauthorizedError as AttachTeamGroupUserUnauthorizedError } from "./types/AttachTeamGroupUser/AttachTeamGroupUserError";
import { ForbiddenError as AttachTeamGroupUserForbiddenError } from "./types/AttachTeamGroupUser/AttachTeamGroupUserError";
import { NotFoundError as AttachTeamGroupUserNotFoundError } from "./types/AttachTeamGroupUser/AttachTeamGroupUserError";
import { ConflictError as AttachTeamGroupUserConflictError } from "./types/AttachTeamGroupUser/AttachTeamGroupUserError";
import { InternalServerError as AttachTeamGroupUserInternalServerError } from "./types/AttachTeamGroupUser/AttachTeamGroupUserError";
import { BadGatewayError as AttachTeamGroupUserBadGatewayError } from "./types/AttachTeamGroupUser/AttachTeamGroupUserError";
import { GatewayTimeoutError as AttachTeamGroupUserGatewayTimeoutError } from "./types/AttachTeamGroupUser/AttachTeamGroupUserError";
import { GenericError as AttachTeamRoleGenericError } from "./types/AttachTeamRole/AttachTeamRoleError";
import { InvalidParameterError as AttachTeamRoleInvalidParameterError } from "./types/AttachTeamRole/AttachTeamRoleError";
import { UnauthorizedError as AttachTeamRoleUnauthorizedError } from "./types/AttachTeamRole/AttachTeamRoleError";
import { ForbiddenError as AttachTeamRoleForbiddenError } from "./types/AttachTeamRole/AttachTeamRoleError";
import { NotFoundError as AttachTeamRoleNotFoundError } from "./types/AttachTeamRole/AttachTeamRoleError";
import { ConflictError as AttachTeamRoleConflictError } from "./types/AttachTeamRole/AttachTeamRoleError";
import { InternalServerError as AttachTeamRoleInternalServerError } from "./types/AttachTeamRole/AttachTeamRoleError";
import { BadGatewayError as AttachTeamRoleBadGatewayError } from "./types/AttachTeamRole/AttachTeamRoleError";
import { GatewayTimeoutError as AttachTeamRoleGatewayTimeoutError } from "./types/AttachTeamRole/AttachTeamRoleError";
import { GenericError as AttachTeamUserGenericError } from "./types/AttachTeamUser/AttachTeamUserError";
import { InvalidParameterError as AttachTeamUserInvalidParameterError } from "./types/AttachTeamUser/AttachTeamUserError";
import { UnauthorizedError as AttachTeamUserUnauthorizedError } from "./types/AttachTeamUser/AttachTeamUserError";
import { ForbiddenError as AttachTeamUserForbiddenError } from "./types/AttachTeamUser/AttachTeamUserError";
import { NotFoundError as AttachTeamUserNotFoundError } from "./types/AttachTeamUser/AttachTeamUserError";
import { ConflictError as AttachTeamUserConflictError } from "./types/AttachTeamUser/AttachTeamUserError";
import { InternalServerError as AttachTeamUserInternalServerError } from "./types/AttachTeamUser/AttachTeamUserError";
import { BadGatewayError as AttachTeamUserBadGatewayError } from "./types/AttachTeamUser/AttachTeamUserError";
import { GatewayTimeoutError as AttachTeamUserGatewayTimeoutError } from "./types/AttachTeamUser/AttachTeamUserError";
import { GenericError as AttachTeamUserRoleGenericError } from "./types/AttachTeamUserRole/AttachTeamUserRoleError";
import { InvalidParameterError as AttachTeamUserRoleInvalidParameterError } from "./types/AttachTeamUserRole/AttachTeamUserRoleError";
import { UnauthorizedError as AttachTeamUserRoleUnauthorizedError } from "./types/AttachTeamUserRole/AttachTeamUserRoleError";
import { ForbiddenError as AttachTeamUserRoleForbiddenError } from "./types/AttachTeamUserRole/AttachTeamUserRoleError";
import { NotFoundError as AttachTeamUserRoleNotFoundError } from "./types/AttachTeamUserRole/AttachTeamUserRoleError";
import { ConflictError as AttachTeamUserRoleConflictError } from "./types/AttachTeamUserRole/AttachTeamUserRoleError";
import { InternalServerError as AttachTeamUserRoleInternalServerError } from "./types/AttachTeamUserRole/AttachTeamUserRoleError";
import { BadGatewayError as AttachTeamUserRoleBadGatewayError } from "./types/AttachTeamUserRole/AttachTeamUserRoleError";
import { GatewayTimeoutError as AttachTeamUserRoleGatewayTimeoutError } from "./types/AttachTeamUserRole/AttachTeamUserRoleError";
import { GenericError as AttachUserRoleGenericError } from "./types/AttachUserRole/AttachUserRoleError";
import { InvalidParameterError as AttachUserRoleInvalidParameterError } from "./types/AttachUserRole/AttachUserRoleError";
import { UnauthorizedError as AttachUserRoleUnauthorizedError } from "./types/AttachUserRole/AttachUserRoleError";
import { ForbiddenError as AttachUserRoleForbiddenError } from "./types/AttachUserRole/AttachUserRoleError";
import { NotFoundError as AttachUserRoleNotFoundError } from "./types/AttachUserRole/AttachUserRoleError";
import { ConflictError as AttachUserRoleConflictError } from "./types/AttachUserRole/AttachUserRoleError";
import { InternalServerError as AttachUserRoleInternalServerError } from "./types/AttachUserRole/AttachUserRoleError";
import { BadGatewayError as AttachUserRoleBadGatewayError } from "./types/AttachUserRole/AttachUserRoleError";
import { GatewayTimeoutError as AttachUserRoleGatewayTimeoutError } from "./types/AttachUserRole/AttachUserRoleError";
import { GenericError as ChangePasswordGenericError } from "./types/ChangePassword/ChangePasswordError";
import { InvalidParameterError as ChangePasswordInvalidParameterError } from "./types/ChangePassword/ChangePasswordError";
import { InvalidSecretError as ChangePasswordInvalidSecretError } from "./types/ChangePassword/ChangePasswordError";
import { ExpiredSecretError as ChangePasswordExpiredSecretError } from "./types/ChangePassword/ChangePasswordError";
import { NotFoundError as ChangePasswordNotFoundError } from "./types/ChangePassword/ChangePasswordError";
import { InternalServerError as ChangePasswordInternalServerError } from "./types/ChangePassword/ChangePasswordError";
import { BadGatewayError as ChangePasswordBadGatewayError } from "./types/ChangePassword/ChangePasswordError";
import { GatewayTimeoutError as ChangePasswordGatewayTimeoutError } from "./types/ChangePassword/ChangePasswordError";
import { GenericError as CreateAccountGenericError } from "./types/CreateAccount/CreateAccountError";
import { InvalidParameterError as CreateAccountInvalidParameterError } from "./types/CreateAccount/CreateAccountError";
import { NotFoundError as CreateAccountNotFoundError } from "./types/CreateAccount/CreateAccountError";
import { ConflictError as CreateAccountConflictError } from "./types/CreateAccount/CreateAccountError";
import { InternalServerError as CreateAccountInternalServerError } from "./types/CreateAccount/CreateAccountError";
import { BadGatewayError as CreateAccountBadGatewayError } from "./types/CreateAccount/CreateAccountError";
import { GatewayTimeoutError as CreateAccountGatewayTimeoutError } from "./types/CreateAccount/CreateAccountError";
import { GenericError as CreateGroupGenericError } from "./types/CreateGroup/CreateGroupError";
import { InvalidParameterError as CreateGroupInvalidParameterError } from "./types/CreateGroup/CreateGroupError";
import { UnauthorizedError as CreateGroupUnauthorizedError } from "./types/CreateGroup/CreateGroupError";
import { ForbiddenError as CreateGroupForbiddenError } from "./types/CreateGroup/CreateGroupError";
import { ConflictError as CreateGroupConflictError } from "./types/CreateGroup/CreateGroupError";
import { InternalServerError as CreateGroupInternalServerError } from "./types/CreateGroup/CreateGroupError";
import { BadGatewayError as CreateGroupBadGatewayError } from "./types/CreateGroup/CreateGroupError";
import { GatewayTimeoutError as CreateGroupGatewayTimeoutError } from "./types/CreateGroup/CreateGroupError";
import { GenericError as CreateGroupSCIMGenericError } from "./types/CreateGroupSCIM/CreateGroupSCIMError";
import { InvalidParameterError as CreateGroupSCIMInvalidParameterError } from "./types/CreateGroupSCIM/CreateGroupSCIMError";
import { UnauthorizedError as CreateGroupSCIMUnauthorizedError } from "./types/CreateGroupSCIM/CreateGroupSCIMError";
import { ForbiddenError as CreateGroupSCIMForbiddenError } from "./types/CreateGroupSCIM/CreateGroupSCIMError";
import { NotFoundError as CreateGroupSCIMNotFoundError } from "./types/CreateGroupSCIM/CreateGroupSCIMError";
import { ConflictError as CreateGroupSCIMConflictError } from "./types/CreateGroupSCIM/CreateGroupSCIMError";
import { InternalServerError as CreateGroupSCIMInternalServerError } from "./types/CreateGroupSCIM/CreateGroupSCIMError";
import { BadGatewayError as CreateGroupSCIMBadGatewayError } from "./types/CreateGroupSCIM/CreateGroupSCIMError";
import { GatewayTimeoutError as CreateGroupSCIMGatewayTimeoutError } from "./types/CreateGroupSCIM/CreateGroupSCIMError";
import { GenericError as CreateMfaFactorSecretGenericError } from "./types/CreateMfaFactorSecret/CreateMfaFactorSecretError";
import { InvalidParameterError as CreateMfaFactorSecretInvalidParameterError } from "./types/CreateMfaFactorSecret/CreateMfaFactorSecretError";
import { InvalidTokenError as CreateMfaFactorSecretInvalidTokenError } from "./types/CreateMfaFactorSecret/CreateMfaFactorSecretError";
import { MfaFactorNotAllowedError as CreateMfaFactorSecretMfaFactorNotAllowedError } from "./types/CreateMfaFactorSecret/CreateMfaFactorSecretError";
import { NotFoundError as CreateMfaFactorSecretNotFoundError } from "./types/CreateMfaFactorSecret/CreateMfaFactorSecretError";
import { InternalServerError as CreateMfaFactorSecretInternalServerError } from "./types/CreateMfaFactorSecret/CreateMfaFactorSecretError";
import { BadGatewayError as CreateMfaFactorSecretBadGatewayError } from "./types/CreateMfaFactorSecret/CreateMfaFactorSecretError";
import { GatewayTimeoutError as CreateMfaFactorSecretGatewayTimeoutError } from "./types/CreateMfaFactorSecret/CreateMfaFactorSecretError";
import { GenericError as CreatePolicyGenericError } from "./types/CreatePolicy/CreatePolicyError";
import { InvalidParameterError as CreatePolicyInvalidParameterError } from "./types/CreatePolicy/CreatePolicyError";
import { UnauthorizedError as CreatePolicyUnauthorizedError } from "./types/CreatePolicy/CreatePolicyError";
import { ForbiddenError as CreatePolicyForbiddenError } from "./types/CreatePolicy/CreatePolicyError";
import { ConflictError as CreatePolicyConflictError } from "./types/CreatePolicy/CreatePolicyError";
import { InternalServerError as CreatePolicyInternalServerError } from "./types/CreatePolicy/CreatePolicyError";
import { BadGatewayError as CreatePolicyBadGatewayError } from "./types/CreatePolicy/CreatePolicyError";
import { GatewayTimeoutError as CreatePolicyGatewayTimeoutError } from "./types/CreatePolicy/CreatePolicyError";
import { GenericError as CreateProviderGenericError } from "./types/CreateProvider/CreateProviderError";
import { InvalidParameterError as CreateProviderInvalidParameterError } from "./types/CreateProvider/CreateProviderError";
import { UnauthorizedError as CreateProviderUnauthorizedError } from "./types/CreateProvider/CreateProviderError";
import { InvalidCertificateError as CreateProviderInvalidCertificateError } from "./types/CreateProvider/CreateProviderError";
import { ForbiddenError as CreateProviderForbiddenError } from "./types/CreateProvider/CreateProviderError";
import { ConflictError as CreateProviderConflictError } from "./types/CreateProvider/CreateProviderError";
import { InternalServerError as CreateProviderInternalServerError } from "./types/CreateProvider/CreateProviderError";
import { BadGatewayError as CreateProviderBadGatewayError } from "./types/CreateProvider/CreateProviderError";
import { GatewayTimeoutError as CreateProviderGatewayTimeoutError } from "./types/CreateProvider/CreateProviderError";
import { GenericError as CreateRoleGenericError } from "./types/CreateRole/CreateRoleError";
import { InvalidParameterError as CreateRoleInvalidParameterError } from "./types/CreateRole/CreateRoleError";
import { UnauthorizedError as CreateRoleUnauthorizedError } from "./types/CreateRole/CreateRoleError";
import { ForbiddenError as CreateRoleForbiddenError } from "./types/CreateRole/CreateRoleError";
import { ConflictError as CreateRoleConflictError } from "./types/CreateRole/CreateRoleError";
import { InternalServerError as CreateRoleInternalServerError } from "./types/CreateRole/CreateRoleError";
import { BadGatewayError as CreateRoleBadGatewayError } from "./types/CreateRole/CreateRoleError";
import { GatewayTimeoutError as CreateRoleGatewayTimeoutError } from "./types/CreateRole/CreateRoleError";
import { GenericError as CreateTeamGenericError } from "./types/CreateTeam/CreateTeamError";
import { InvalidParameterError as CreateTeamInvalidParameterError } from "./types/CreateTeam/CreateTeamError";
import { UnauthorizedError as CreateTeamUnauthorizedError } from "./types/CreateTeam/CreateTeamError";
import { ForbiddenError as CreateTeamForbiddenError } from "./types/CreateTeam/CreateTeamError";
import { ConflictError as CreateTeamConflictError } from "./types/CreateTeam/CreateTeamError";
import { InternalServerError as CreateTeamInternalServerError } from "./types/CreateTeam/CreateTeamError";
import { BadGatewayError as CreateTeamBadGatewayError } from "./types/CreateTeam/CreateTeamError";
import { GatewayTimeoutError as CreateTeamGatewayTimeoutError } from "./types/CreateTeam/CreateTeamError";
import { GenericError as CreateTokenGenericError } from "./types/CreateToken/CreateTokenError";
import { InvalidParameterError as CreateTokenInvalidParameterError } from "./types/CreateToken/CreateTokenError";
import { InvalidCredentialsError as CreateTokenInvalidCredentialsError } from "./types/CreateToken/CreateTokenError";
import { PasswordRevokedError as CreateTokenPasswordRevokedError } from "./types/CreateToken/CreateTokenError";
import { IdentityDisabledError as CreateTokenIdentityDisabledError } from "./types/CreateToken/CreateTokenError";
import { InvalidAuthenticationModeError as CreateTokenInvalidAuthenticationModeError } from "./types/CreateToken/CreateTokenError";
import { MfaRequiredError as CreateTokenMfaRequiredError } from "./types/CreateToken/CreateTokenError";
import { NotFoundError as CreateTokenNotFoundError } from "./types/CreateToken/CreateTokenError";
import { ConflictError as CreateTokenConflictError } from "./types/CreateToken/CreateTokenError";
import { InternalServerError as CreateTokenInternalServerError } from "./types/CreateToken/CreateTokenError";
import { BadGatewayError as CreateTokenBadGatewayError } from "./types/CreateToken/CreateTokenError";
import { GatewayTimeoutError as CreateTokenGatewayTimeoutError } from "./types/CreateToken/CreateTokenError";
import { GenericError as CreateUserGenericError } from "./types/CreateUser/CreateUserError";
import { InvalidParameterError as CreateUserInvalidParameterError } from "./types/CreateUser/CreateUserError";
import { UnauthorizedError as CreateUserUnauthorizedError } from "./types/CreateUser/CreateUserError";
import { InvalidSubscriptionError as CreateUserInvalidSubscriptionError } from "./types/CreateUser/CreateUserError";
import { ForbiddenError as CreateUserForbiddenError } from "./types/CreateUser/CreateUserError";
import { ConflictError as CreateUserConflictError } from "./types/CreateUser/CreateUserError";
import { InternalServerError as CreateUserInternalServerError } from "./types/CreateUser/CreateUserError";
import { BadGatewayError as CreateUserBadGatewayError } from "./types/CreateUser/CreateUserError";
import { GatewayTimeoutError as CreateUserGatewayTimeoutError } from "./types/CreateUser/CreateUserError";
import { GenericError as CreateUserMfaFactorSecretGenericError } from "./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError";
import { InvalidParameterError as CreateUserMfaFactorSecretInvalidParameterError } from "./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError";
import { InvalidTokenError as CreateUserMfaFactorSecretInvalidTokenError } from "./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError";
import { MfaFactorNotAllowedError as CreateUserMfaFactorSecretMfaFactorNotAllowedError } from "./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError";
import { NotFoundError as CreateUserMfaFactorSecretNotFoundError } from "./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError";
import { InternalServerError as CreateUserMfaFactorSecretInternalServerError } from "./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError";
import { BadGatewayError as CreateUserMfaFactorSecretBadGatewayError } from "./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError";
import { GatewayTimeoutError as CreateUserMfaFactorSecretGatewayTimeoutError } from "./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError";
import { GenericError as CreateUserSCIMGenericError } from "./types/CreateUserSCIM/CreateUserSCIMError";
import { InvalidParameterError as CreateUserSCIMInvalidParameterError } from "./types/CreateUserSCIM/CreateUserSCIMError";
import { UnauthorizedError as CreateUserSCIMUnauthorizedError } from "./types/CreateUserSCIM/CreateUserSCIMError";
import { ForbiddenError as CreateUserSCIMForbiddenError } from "./types/CreateUserSCIM/CreateUserSCIMError";
import { NotFoundError as CreateUserSCIMNotFoundError } from "./types/CreateUserSCIM/CreateUserSCIMError";
import { ConflictError as CreateUserSCIMConflictError } from "./types/CreateUserSCIM/CreateUserSCIMError";
import { InternalServerError as CreateUserSCIMInternalServerError } from "./types/CreateUserSCIM/CreateUserSCIMError";
import { BadGatewayError as CreateUserSCIMBadGatewayError } from "./types/CreateUserSCIM/CreateUserSCIMError";
import { GatewayTimeoutError as CreateUserSCIMGatewayTimeoutError } from "./types/CreateUserSCIM/CreateUserSCIMError";
import { GenericError as CreateUserTokenGenericError } from "./types/CreateUserToken/CreateUserTokenError";
import { InvalidParameterError as CreateUserTokenInvalidParameterError } from "./types/CreateUserToken/CreateUserTokenError";
import { UnauthorizedError as CreateUserTokenUnauthorizedError } from "./types/CreateUserToken/CreateUserTokenError";
import { IdentityDisabledError as CreateUserTokenIdentityDisabledError } from "./types/CreateUserToken/CreateUserTokenError";
import { ForbiddenError as CreateUserTokenForbiddenError } from "./types/CreateUserToken/CreateUserTokenError";
import { NotFoundError as CreateUserTokenNotFoundError } from "./types/CreateUserToken/CreateUserTokenError";
import { ConflictError as CreateUserTokenConflictError } from "./types/CreateUserToken/CreateUserTokenError";
import { InternalServerError as CreateUserTokenInternalServerError } from "./types/CreateUserToken/CreateUserTokenError";
import { BadGatewayError as CreateUserTokenBadGatewayError } from "./types/CreateUserToken/CreateUserTokenError";
import { GatewayTimeoutError as CreateUserTokenGatewayTimeoutError } from "./types/CreateUserToken/CreateUserTokenError";
import { GenericError as DeleteAccountGenericError } from "./types/DeleteAccount/DeleteAccountError";
import { UnauthorizedError as DeleteAccountUnauthorizedError } from "./types/DeleteAccount/DeleteAccountError";
import { ForbiddenError as DeleteAccountForbiddenError } from "./types/DeleteAccount/DeleteAccountError";
import { NotFoundError as DeleteAccountNotFoundError } from "./types/DeleteAccount/DeleteAccountError";
import { InternalServerError as DeleteAccountInternalServerError } from "./types/DeleteAccount/DeleteAccountError";
import { BadGatewayError as DeleteAccountBadGatewayError } from "./types/DeleteAccount/DeleteAccountError";
import { GatewayTimeoutError as DeleteAccountGatewayTimeoutError } from "./types/DeleteAccount/DeleteAccountError";
import { GenericError as DeleteGroupGenericError } from "./types/DeleteGroup/DeleteGroupError";
import { InvalidParameterError as DeleteGroupInvalidParameterError } from "./types/DeleteGroup/DeleteGroupError";
import { UnauthorizedError as DeleteGroupUnauthorizedError } from "./types/DeleteGroup/DeleteGroupError";
import { ForbiddenError as DeleteGroupForbiddenError } from "./types/DeleteGroup/DeleteGroupError";
import { NotFoundError as DeleteGroupNotFoundError } from "./types/DeleteGroup/DeleteGroupError";
import { InternalServerError as DeleteGroupInternalServerError } from "./types/DeleteGroup/DeleteGroupError";
import { BadGatewayError as DeleteGroupBadGatewayError } from "./types/DeleteGroup/DeleteGroupError";
import { GatewayTimeoutError as DeleteGroupGatewayTimeoutError } from "./types/DeleteGroup/DeleteGroupError";
import { GenericError as DeleteGroupSCIMGenericError } from "./types/DeleteGroupSCIM/DeleteGroupSCIMError";
import { InvalidParameterError as DeleteGroupSCIMInvalidParameterError } from "./types/DeleteGroupSCIM/DeleteGroupSCIMError";
import { UnauthorizedError as DeleteGroupSCIMUnauthorizedError } from "./types/DeleteGroupSCIM/DeleteGroupSCIMError";
import { ForbiddenError as DeleteGroupSCIMForbiddenError } from "./types/DeleteGroupSCIM/DeleteGroupSCIMError";
import { NotFoundError as DeleteGroupSCIMNotFoundError } from "./types/DeleteGroupSCIM/DeleteGroupSCIMError";
import { InternalServerError as DeleteGroupSCIMInternalServerError } from "./types/DeleteGroupSCIM/DeleteGroupSCIMError";
import { BadGatewayError as DeleteGroupSCIMBadGatewayError } from "./types/DeleteGroupSCIM/DeleteGroupSCIMError";
import { GatewayTimeoutError as DeleteGroupSCIMGatewayTimeoutError } from "./types/DeleteGroupSCIM/DeleteGroupSCIMError";
import { GenericError as DeletePolicyGenericError } from "./types/DeletePolicy/DeletePolicyError";
import { InvalidParameterError as DeletePolicyInvalidParameterError } from "./types/DeletePolicy/DeletePolicyError";
import { UnauthorizedError as DeletePolicyUnauthorizedError } from "./types/DeletePolicy/DeletePolicyError";
import { ForbiddenError as DeletePolicyForbiddenError } from "./types/DeletePolicy/DeletePolicyError";
import { NotFoundError as DeletePolicyNotFoundError } from "./types/DeletePolicy/DeletePolicyError";
import { InternalServerError as DeletePolicyInternalServerError } from "./types/DeletePolicy/DeletePolicyError";
import { BadGatewayError as DeletePolicyBadGatewayError } from "./types/DeletePolicy/DeletePolicyError";
import { GatewayTimeoutError as DeletePolicyGatewayTimeoutError } from "./types/DeletePolicy/DeletePolicyError";
import { GenericError as DeleteProviderGenericError } from "./types/DeleteProvider/DeleteProviderError";
import { InvalidParameterError as DeleteProviderInvalidParameterError } from "./types/DeleteProvider/DeleteProviderError";
import { UnauthorizedError as DeleteProviderUnauthorizedError } from "./types/DeleteProvider/DeleteProviderError";
import { ForbiddenError as DeleteProviderForbiddenError } from "./types/DeleteProvider/DeleteProviderError";
import { NotFoundError as DeleteProviderNotFoundError } from "./types/DeleteProvider/DeleteProviderError";
import { InternalServerError as DeleteProviderInternalServerError } from "./types/DeleteProvider/DeleteProviderError";
import { BadGatewayError as DeleteProviderBadGatewayError } from "./types/DeleteProvider/DeleteProviderError";
import { GatewayTimeoutError as DeleteProviderGatewayTimeoutError } from "./types/DeleteProvider/DeleteProviderError";
import { GenericError as DeleteRoleGenericError } from "./types/DeleteRole/DeleteRoleError";
import { InvalidParameterError as DeleteRoleInvalidParameterError } from "./types/DeleteRole/DeleteRoleError";
import { UnauthorizedError as DeleteRoleUnauthorizedError } from "./types/DeleteRole/DeleteRoleError";
import { ForbiddenError as DeleteRoleForbiddenError } from "./types/DeleteRole/DeleteRoleError";
import { NotFoundError as DeleteRoleNotFoundError } from "./types/DeleteRole/DeleteRoleError";
import { InternalServerError as DeleteRoleInternalServerError } from "./types/DeleteRole/DeleteRoleError";
import { BadGatewayError as DeleteRoleBadGatewayError } from "./types/DeleteRole/DeleteRoleError";
import { GatewayTimeoutError as DeleteRoleGatewayTimeoutError } from "./types/DeleteRole/DeleteRoleError";
import { GenericError as DecodeTokenGenericError } from "./types/DecodeToken/DecodeTokenError";
import { FailedToDecodeTokenError as DecodeTokenFailedToDecodeTokenError } from "./types/DecodeToken/DecodeTokenError";
export const errors = {
    ListGroups: {
        UnauthorizedError: ListGroupsUnauthorizedError,
        ForbiddenError: ListGroupsForbiddenError,
        NotFoundError: ListGroupsNotFoundError,
        InternalServerError: ListGroupsInternalServerError,
        BadGatewayError: ListGroupsBadGatewayError,
        GatewayTimeoutError: ListGroupsGatewayTimeoutError,
        GenericError: ListGroupsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListGroupsSCIM: {
        InvalidParameterError: ListGroupsSCIMInvalidParameterError,
        UnauthorizedError: ListGroupsSCIMUnauthorizedError,
        ForbiddenError: ListGroupsSCIMForbiddenError,
        InternalServerError: ListGroupsSCIMInternalServerError,
        BadGatewayError: ListGroupsSCIMBadGatewayError,
        GatewayTimeoutError: ListGroupsSCIMGatewayTimeoutError,
        GenericError: ListGroupsSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListPolicies: {
        UnauthorizedError: ListPoliciesUnauthorizedError,
        ForbiddenError: ListPoliciesForbiddenError,
        InternalServerError: ListPoliciesInternalServerError,
        BadGatewayError: ListPoliciesBadGatewayError,
        GatewayTimeoutError: ListPoliciesGatewayTimeoutError,
        GenericError: ListPoliciesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListProviders: {
        UnauthorizedError: ListProvidersUnauthorizedError,
        ForbiddenError: ListProvidersForbiddenError,
        InternalServerError: ListProvidersInternalServerError,
        BadGatewayError: ListProvidersBadGatewayError,
        GatewayTimeoutError: ListProvidersGatewayTimeoutError,
        GenericError: ListProvidersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListRoles: {
        UnauthorizedError: ListRolesUnauthorizedError,
        ForbiddenError: ListRolesForbiddenError,
        InternalServerError: ListRolesInternalServerError,
        BadGatewayError: ListRolesBadGatewayError,
        GatewayTimeoutError: ListRolesGatewayTimeoutError,
        GenericError: ListRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamGroupRoles: {
        InvalidParameterError: ListTeamGroupRolesInvalidParameterError,
        UnauthorizedError: ListTeamGroupRolesUnauthorizedError,
        ForbiddenError: ListTeamGroupRolesForbiddenError,
        NotFoundError: ListTeamGroupRolesNotFoundError,
        InternalServerError: ListTeamGroupRolesInternalServerError,
        BadGatewayError: ListTeamGroupRolesBadGatewayError,
        GatewayTimeoutError: ListTeamGroupRolesGatewayTimeoutError,
        GenericError: ListTeamGroupRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamGroupUsers: {
        InvalidParameterError: ListTeamGroupUsersInvalidParameterError,
        UnauthorizedError: ListTeamGroupUsersUnauthorizedError,
        ForbiddenError: ListTeamGroupUsersForbiddenError,
        NotFoundError: ListTeamGroupUsersNotFoundError,
        InternalServerError: ListTeamGroupUsersInternalServerError,
        BadGatewayError: ListTeamGroupUsersBadGatewayError,
        GatewayTimeoutError: ListTeamGroupUsersGatewayTimeoutError,
        GenericError: ListTeamGroupUsersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamGroups: {
        InvalidParameterError: ListTeamGroupsInvalidParameterError,
        UnauthorizedError: ListTeamGroupsUnauthorizedError,
        ForbiddenError: ListTeamGroupsForbiddenError,
        NotFoundError: ListTeamGroupsNotFoundError,
        InternalServerError: ListTeamGroupsInternalServerError,
        BadGatewayError: ListTeamGroupsBadGatewayError,
        GatewayTimeoutError: ListTeamGroupsGatewayTimeoutError,
        GenericError: ListTeamGroupsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamRoles: {
        InvalidParameterError: ListTeamRolesInvalidParameterError,
        UnauthorizedError: ListTeamRolesUnauthorizedError,
        ForbiddenError: ListTeamRolesForbiddenError,
        NotFoundError: ListTeamRolesNotFoundError,
        InternalServerError: ListTeamRolesInternalServerError,
        BadGatewayError: ListTeamRolesBadGatewayError,
        GatewayTimeoutError: ListTeamRolesGatewayTimeoutError,
        GenericError: ListTeamRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUserGroups: {
        InvalidParameterError: ListTeamUserGroupsInvalidParameterError,
        UnauthorizedError: ListTeamUserGroupsUnauthorizedError,
        ForbiddenError: ListTeamUserGroupsForbiddenError,
        NotFoundError: ListTeamUserGroupsNotFoundError,
        InternalServerError: ListTeamUserGroupsInternalServerError,
        BadGatewayError: ListTeamUserGroupsBadGatewayError,
        GatewayTimeoutError: ListTeamUserGroupsGatewayTimeoutError,
        GenericError: ListTeamUserGroupsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUserRoles: {
        InvalidParameterError: ListTeamUserRolesInvalidParameterError,
        UnauthorizedError: ListTeamUserRolesUnauthorizedError,
        ForbiddenError: ListTeamUserRolesForbiddenError,
        NotFoundError: ListTeamUserRolesNotFoundError,
        InternalServerError: ListTeamUserRolesInternalServerError,
        BadGatewayError: ListTeamUserRolesBadGatewayError,
        GatewayTimeoutError: ListTeamUserRolesGatewayTimeoutError,
        GenericError: ListTeamUserRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUsers: {
        InvalidParameterError: ListTeamUsersInvalidParameterError,
        UnauthorizedError: ListTeamUsersUnauthorizedError,
        ForbiddenError: ListTeamUsersForbiddenError,
        NotFoundError: ListTeamUsersNotFoundError,
        InternalServerError: ListTeamUsersInternalServerError,
        BadGatewayError: ListTeamUsersBadGatewayError,
        GatewayTimeoutError: ListTeamUsersGatewayTimeoutError,
        GenericError: ListTeamUsersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeams: {
        UnauthorizedError: ListTeamsUnauthorizedError,
        ForbiddenError: ListTeamsForbiddenError,
        InternalServerError: ListTeamsInternalServerError,
        BadGatewayError: ListTeamsBadGatewayError,
        GatewayTimeoutError: ListTeamsGatewayTimeoutError,
        GenericError: ListTeamsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserGroups: {
        InvalidParameterError: ListUserGroupsInvalidParameterError,
        UnauthorizedError: ListUserGroupsUnauthorizedError,
        ForbiddenError: ListUserGroupsForbiddenError,
        NotFoundError: ListUserGroupsNotFoundError,
        InternalServerError: ListUserGroupsInternalServerError,
        BadGatewayError: ListUserGroupsBadGatewayError,
        GatewayTimeoutError: ListUserGroupsGatewayTimeoutError,
        GenericError: ListUserGroupsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserGroupsRoles: {
        InvalidParameterError: ListUserGroupsRolesInvalidParameterError,
        UnauthorizedError: ListUserGroupsRolesUnauthorizedError,
        ForbiddenError: ListUserGroupsRolesForbiddenError,
        NotFoundError: ListUserGroupsRolesNotFoundError,
        InternalServerError: ListUserGroupsRolesInternalServerError,
        BadGatewayError: ListUserGroupsRolesBadGatewayError,
        GatewayTimeoutError: ListUserGroupsRolesGatewayTimeoutError,
        GenericError: ListUserGroupsRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserGroupsTeams: {
        InvalidParameterError: ListUserGroupsTeamsInvalidParameterError,
        UnauthorizedError: ListUserGroupsTeamsUnauthorizedError,
        ForbiddenError: ListUserGroupsTeamsForbiddenError,
        NotFoundError: ListUserGroupsTeamsNotFoundError,
        InternalServerError: ListUserGroupsTeamsInternalServerError,
        BadGatewayError: ListUserGroupsTeamsBadGatewayError,
        GatewayTimeoutError: ListUserGroupsTeamsGatewayTimeoutError,
        GenericError: ListUserGroupsTeamsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserRoles: {
        InvalidParameterError: ListUserRolesInvalidParameterError,
        UnauthorizedError: ListUserRolesUnauthorizedError,
        ForbiddenError: ListUserRolesForbiddenError,
        NotFoundError: ListUserRolesNotFoundError,
        InternalServerError: ListUserRolesInternalServerError,
        BadGatewayError: ListUserRolesBadGatewayError,
        GatewayTimeoutError: ListUserRolesGatewayTimeoutError,
        GenericError: ListUserRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserTeams: {
        InvalidParameterError: ListUserTeamsInvalidParameterError,
        UnauthorizedError: ListUserTeamsUnauthorizedError,
        ForbiddenError: ListUserTeamsForbiddenError,
        NotFoundError: ListUserTeamsNotFoundError,
        InternalServerError: ListUserTeamsInternalServerError,
        BadGatewayError: ListUserTeamsBadGatewayError,
        GatewayTimeoutError: ListUserTeamsGatewayTimeoutError,
        GenericError: ListUserTeamsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUsers: {
        UnauthorizedError: ListUsersUnauthorizedError,
        ForbiddenError: ListUsersForbiddenError,
        InternalServerError: ListUsersInternalServerError,
        BadGatewayError: ListUsersBadGatewayError,
        GatewayTimeoutError: ListUsersGatewayTimeoutError,
        GenericError: ListUsersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUsersSCIM: {
        InvalidParameterError: ListUsersSCIMInvalidParameterError,
        UnauthorizedError: ListUsersSCIMUnauthorizedError,
        ForbiddenError: ListUsersSCIMForbiddenError,
        InternalServerError: ListUsersSCIMInternalServerError,
        BadGatewayError: ListUsersSCIMBadGatewayError,
        GatewayTimeoutError: ListUsersSCIMGatewayTimeoutError,
        GenericError: ListUsersSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    PatchGroupSCIM: {
        InvalidParameterError: PatchGroupSCIMInvalidParameterError,
        UnauthorizedError: PatchGroupSCIMUnauthorizedError,
        ForbiddenError: PatchGroupSCIMForbiddenError,
        NotFoundError: PatchGroupSCIMNotFoundError,
        InternalServerError: PatchGroupSCIMInternalServerError,
        BadGatewayError: PatchGroupSCIMBadGatewayError,
        GatewayTimeoutError: PatchGroupSCIMGatewayTimeoutError,
        GenericError: PatchGroupSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    PatchUserSCIM: {
        InvalidParameterError: PatchUserSCIMInvalidParameterError,
        UnauthorizedError: PatchUserSCIMUnauthorizedError,
        ForbiddenError: PatchUserSCIMForbiddenError,
        NotFoundError: PatchUserSCIMNotFoundError,
        ConflictError: PatchUserSCIMConflictError,
        InternalServerError: PatchUserSCIMInternalServerError,
        BadGatewayError: PatchUserSCIMBadGatewayError,
        GatewayTimeoutError: PatchUserSCIMGatewayTimeoutError,
        GenericError: PatchUserSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    RenewToken: {
        InvalidParameterError: RenewTokenInvalidParameterError,
        PasswordRevokedError: RenewTokenPasswordRevokedError,
        IdentityDisabledError: RenewTokenIdentityDisabledError,
        NotAllowedError: RenewTokenNotAllowedError,
        InvalidRefreshTokenError: RenewTokenInvalidRefreshTokenError,
        NotFoundError: RenewTokenNotFoundError,
        InternalServerError: RenewTokenInternalServerError,
        BadGatewayError: RenewTokenBadGatewayError,
        GatewayTimeoutError: RenewTokenGatewayTimeoutError,
        GenericError: RenewTokenGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ResetMfaFactor: {
        InvalidParameterError: ResetMfaFactorInvalidParameterError,
        UnauthorizedError: ResetMfaFactorUnauthorizedError,
        ForbiddenError: ResetMfaFactorForbiddenError,
        NotFoundError: ResetMfaFactorNotFoundError,
        InternalServerError: ResetMfaFactorInternalServerError,
        BadGatewayError: ResetMfaFactorBadGatewayError,
        GatewayTimeoutError: ResetMfaFactorGatewayTimeoutError,
        GenericError: ResetMfaFactorGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ResetPassword: {
        InvalidParameterError: ResetPasswordInvalidParameterError,
        InvalidSecretError: ResetPasswordInvalidSecretError,
        ExpiredSecretError: ResetPasswordExpiredSecretError,
        NotFoundError: ResetPasswordNotFoundError,
        InternalServerError: ResetPasswordInternalServerError,
        BadGatewayError: ResetPasswordBadGatewayError,
        GatewayTimeoutError: ResetPasswordGatewayTimeoutError,
        GenericError: ResetPasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ResetUserMfaFactor: {
        InvalidParameterError: ResetUserMfaFactorInvalidParameterError,
        UnauthorizedError: ResetUserMfaFactorUnauthorizedError,
        ForbiddenError: ResetUserMfaFactorForbiddenError,
        NotFoundError: ResetUserMfaFactorNotFoundError,
        InternalServerError: ResetUserMfaFactorInternalServerError,
        BadGatewayError: ResetUserMfaFactorBadGatewayError,
        GatewayTimeoutError: ResetUserMfaFactorGatewayTimeoutError,
        GenericError: ResetUserMfaFactorGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    RotateKey: {
        UnauthorizedError: RotateKeyUnauthorizedError,
        ForbiddenError: RotateKeyForbiddenError,
        NotFoundError: RotateKeyNotFoundError,
        InternalServerError: RotateKeyInternalServerError,
        BadGatewayError: RotateKeyBadGatewayError,
        GatewayTimeoutError: RotateKeyGatewayTimeoutError,
        GenericError: RotateKeyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    RotateUserKey: {
        InvalidParameterError: RotateUserKeyInvalidParameterError,
        UnauthorizedError: RotateUserKeyUnauthorizedError,
        ForbiddenError: RotateUserKeyForbiddenError,
        NotFoundError: RotateUserKeyNotFoundError,
        InternalServerError: RotateUserKeyInternalServerError,
        BadGatewayError: RotateUserKeyBadGatewayError,
        GatewayTimeoutError: RotateUserKeyGatewayTimeoutError,
        GenericError: RotateUserKeyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    SamlSignon: {
        InvalidParameterError: SamlSignonInvalidParameterError,
        UserNotAllowedToSignonError: SamlSignonUserNotAllowedToSignonError,
        InvalidAudienceUriError: SamlSignonInvalidAudienceUriError,
        NotFoundError: SamlSignonNotFoundError,
        ConflictError: SamlSignonConflictError,
        InternalServerError: SamlSignonInternalServerError,
        BadGatewayError: SamlSignonBadGatewayError,
        GatewayTimeoutError: SamlSignonGatewayTimeoutError,
        GenericError: SamlSignonGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    SendOtp: {
        InvalidParameterError: SendOtpInvalidParameterError,
        InvalidTokenError: SendOtpInvalidTokenError,
        MfaFactorNotAllowedError: SendOtpMfaFactorNotAllowedError,
        ConflictError: SendOtpConflictError,
        InternalServerError: SendOtpInternalServerError,
        BadGatewayError: SendOtpBadGatewayError,
        GatewayTimeoutError: SendOtpGatewayTimeoutError,
        GenericError: SendOtpGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    SsoSignin: {
        InvalidParameterError: SsoSigninInvalidParameterError,
        NotFoundError: SsoSigninNotFoundError,
        ConflictError: SsoSigninConflictError,
        InternalServerError: SsoSigninInternalServerError,
        BadGatewayError: SsoSigninBadGatewayError,
        GatewayTimeoutError: SsoSigninGatewayTimeoutError,
        GenericError: SsoSigninGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateAccount: {
        InvalidParameterError: UpdateAccountInvalidParameterError,
        UnauthorizedError: UpdateAccountUnauthorizedError,
        ForbiddenError: UpdateAccountForbiddenError,
        NotFoundError: UpdateAccountNotFoundError,
        ConflictError: UpdateAccountConflictError,
        InternalServerError: UpdateAccountInternalServerError,
        BadGatewayError: UpdateAccountBadGatewayError,
        GatewayTimeoutError: UpdateAccountGatewayTimeoutError,
        GenericError: UpdateAccountGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateGroup: {
        InvalidParameterError: UpdateGroupInvalidParameterError,
        UnauthorizedError: UpdateGroupUnauthorizedError,
        ForbiddenError: UpdateGroupForbiddenError,
        NotFoundError: UpdateGroupNotFoundError,
        InternalServerError: UpdateGroupInternalServerError,
        BadGatewayError: UpdateGroupBadGatewayError,
        GatewayTimeoutError: UpdateGroupGatewayTimeoutError,
        GenericError: UpdateGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateGroupSCIM: {
        InvalidParameterError: UpdateGroupSCIMInvalidParameterError,
        UnauthorizedError: UpdateGroupSCIMUnauthorizedError,
        ForbiddenError: UpdateGroupSCIMForbiddenError,
        NotFoundError: UpdateGroupSCIMNotFoundError,
        InternalServerError: UpdateGroupSCIMInternalServerError,
        BadGatewayError: UpdateGroupSCIMBadGatewayError,
        GatewayTimeoutError: UpdateGroupSCIMGatewayTimeoutError,
        GenericError: UpdateGroupSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateManagedPolicy: {
        InvalidParameterError: UpdateManagedPolicyInvalidParameterError,
        UnauthorizedError: UpdateManagedPolicyUnauthorizedError,
        ForbiddenError: UpdateManagedPolicyForbiddenError,
        NotFoundError: UpdateManagedPolicyNotFoundError,
        InternalServerError: UpdateManagedPolicyInternalServerError,
        BadGatewayError: UpdateManagedPolicyBadGatewayError,
        GatewayTimeoutError: UpdateManagedPolicyGatewayTimeoutError,
        GenericError: UpdateManagedPolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateMfa: {
        InvalidParameterError: UpdateMfaInvalidParameterError,
        UnauthorizedError: UpdateMfaUnauthorizedError,
        MfaFactorNotVerifiedError: UpdateMfaMfaFactorNotVerifiedError,
        ForbiddenError: UpdateMfaForbiddenError,
        NotFoundError: UpdateMfaNotFoundError,
        InternalServerError: UpdateMfaInternalServerError,
        BadGatewayError: UpdateMfaBadGatewayError,
        GatewayTimeoutError: UpdateMfaGatewayTimeoutError,
        GenericError: UpdateMfaGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdatePassword: {
        InvalidParameterError: UpdatePasswordInvalidParameterError,
        UnauthorizedError: UpdatePasswordUnauthorizedError,
        InvalidAuthenticationModeError: UpdatePasswordInvalidAuthenticationModeError,
        PasswordDoesNotMatchError: UpdatePasswordPasswordDoesNotMatchError,
        ForbiddenError: UpdatePasswordForbiddenError,
        NotFoundError: UpdatePasswordNotFoundError,
        InternalServerError: UpdatePasswordInternalServerError,
        BadGatewayError: UpdatePasswordBadGatewayError,
        GatewayTimeoutError: UpdatePasswordGatewayTimeoutError,
        GenericError: UpdatePasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdatePolicy: {
        InvalidParameterError: UpdatePolicyInvalidParameterError,
        UnauthorizedError: UpdatePolicyUnauthorizedError,
        ForbiddenError: UpdatePolicyForbiddenError,
        NotFoundError: UpdatePolicyNotFoundError,
        InternalServerError: UpdatePolicyInternalServerError,
        BadGatewayError: UpdatePolicyBadGatewayError,
        GatewayTimeoutError: UpdatePolicyGatewayTimeoutError,
        GenericError: UpdatePolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateProvider: {
        InvalidParameterError: UpdateProviderInvalidParameterError,
        UnauthorizedError: UpdateProviderUnauthorizedError,
        InvalidCertificateError: UpdateProviderInvalidCertificateError,
        ForbiddenError: UpdateProviderForbiddenError,
        NotFoundError: UpdateProviderNotFoundError,
        InternalServerError: UpdateProviderInternalServerError,
        BadGatewayError: UpdateProviderBadGatewayError,
        GatewayTimeoutError: UpdateProviderGatewayTimeoutError,
        GenericError: UpdateProviderGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateRole: {
        InvalidParameterError: UpdateRoleInvalidParameterError,
        UnauthorizedError: UpdateRoleUnauthorizedError,
        ForbiddenError: UpdateRoleForbiddenError,
        NotFoundError: UpdateRoleNotFoundError,
        InternalServerError: UpdateRoleInternalServerError,
        BadGatewayError: UpdateRoleBadGatewayError,
        GatewayTimeoutError: UpdateRoleGatewayTimeoutError,
        GenericError: UpdateRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateSecurity: {
        InvalidParameterError: UpdateSecurityInvalidParameterError,
        UnauthorizedError: UpdateSecurityUnauthorizedError,
        ForbiddenError: UpdateSecurityForbiddenError,
        NotFoundError: UpdateSecurityNotFoundError,
        InternalServerError: UpdateSecurityInternalServerError,
        BadGatewayError: UpdateSecurityBadGatewayError,
        GatewayTimeoutError: UpdateSecurityGatewayTimeoutError,
        GenericError: UpdateSecurityGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTeam: {
        InvalidParameterError: UpdateTeamInvalidParameterError,
        UnauthorizedError: UpdateTeamUnauthorizedError,
        ForbiddenError: UpdateTeamForbiddenError,
        NotFoundError: UpdateTeamNotFoundError,
        InternalServerError: UpdateTeamInternalServerError,
        BadGatewayError: UpdateTeamBadGatewayError,
        GatewayTimeoutError: UpdateTeamGatewayTimeoutError,
        GenericError: UpdateTeamGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTeamGroup: {
        InvalidParameterError: UpdateTeamGroupInvalidParameterError,
        UnauthorizedError: UpdateTeamGroupUnauthorizedError,
        ForbiddenError: UpdateTeamGroupForbiddenError,
        NotFoundError: UpdateTeamGroupNotFoundError,
        InternalServerError: UpdateTeamGroupInternalServerError,
        BadGatewayError: UpdateTeamGroupBadGatewayError,
        GatewayTimeoutError: UpdateTeamGroupGatewayTimeoutError,
        GenericError: UpdateTeamGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTeamUser: {
        InvalidParameterError: UpdateTeamUserInvalidParameterError,
        UnauthorizedError: UpdateTeamUserUnauthorizedError,
        InvalidSubscriptionError: UpdateTeamUserInvalidSubscriptionError,
        ForbiddenToUpdateProvisionedUserError: UpdateTeamUserForbiddenToUpdateProvisionedUserError,
        ForbiddenError: UpdateTeamUserForbiddenError,
        NotFoundError: UpdateTeamUserNotFoundError,
        ConflictError: UpdateTeamUserConflictError,
        InternalServerError: UpdateTeamUserInternalServerError,
        BadGatewayError: UpdateTeamUserBadGatewayError,
        GatewayTimeoutError: UpdateTeamUserGatewayTimeoutError,
        GenericError: UpdateTeamUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateUser: {
        InvalidParameterError: UpdateUserInvalidParameterError,
        UnauthorizedError: UpdateUserUnauthorizedError,
        ForbiddenToUpdateProvisionedUserError: UpdateUserForbiddenToUpdateProvisionedUserError,
        InvalidSubscriptionError: UpdateUserInvalidSubscriptionError,
        ForbiddenError: UpdateUserForbiddenError,
        NotFoundError: UpdateUserNotFoundError,
        InternalServerError: UpdateUserInternalServerError,
        BadGatewayError: UpdateUserBadGatewayError,
        GatewayTimeoutError: UpdateUserGatewayTimeoutError,
        GenericError: UpdateUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateUserMfa: {
        InvalidParameterError: UpdateUserMfaInvalidParameterError,
        UnauthorizedError: UpdateUserMfaUnauthorizedError,
        MfaFactorNotVerifiedError: UpdateUserMfaMfaFactorNotVerifiedError,
        ForbiddenError: UpdateUserMfaForbiddenError,
        NotFoundError: UpdateUserMfaNotFoundError,
        InternalServerError: UpdateUserMfaInternalServerError,
        BadGatewayError: UpdateUserMfaBadGatewayError,
        GatewayTimeoutError: UpdateUserMfaGatewayTimeoutError,
        GenericError: UpdateUserMfaGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateUserSCIM: {
        InvalidParameterError: UpdateUserSCIMInvalidParameterError,
        UnauthorizedError: UpdateUserSCIMUnauthorizedError,
        ForbiddenError: UpdateUserSCIMForbiddenError,
        NotFoundError: UpdateUserSCIMNotFoundError,
        ConflictError: UpdateUserSCIMConflictError,
        InternalServerError: UpdateUserSCIMInternalServerError,
        BadGatewayError: UpdateUserSCIMBadGatewayError,
        GatewayTimeoutError: UpdateUserSCIMGatewayTimeoutError,
        GenericError: UpdateUserSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    VerifyMfaFactor: {
        InvalidParameterError: VerifyMfaFactorInvalidParameterError,
        InvalidTokenError: VerifyMfaFactorInvalidTokenError,
        InvalidOtpError: VerifyMfaFactorInvalidOtpError,
        MfaFactorNotAllowedError: VerifyMfaFactorMfaFactorNotAllowedError,
        NotFoundError: VerifyMfaFactorNotFoundError,
        InternalServerError: VerifyMfaFactorInternalServerError,
        BadGatewayError: VerifyMfaFactorBadGatewayError,
        GatewayTimeoutError: VerifyMfaFactorGatewayTimeoutError,
        GenericError: VerifyMfaFactorGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    VerifyOtp: {
        InvalidParameterError: VerifyOtpInvalidParameterError,
        InvalidOtpError: VerifyOtpInvalidOtpError,
        InvalidTokenError: VerifyOtpInvalidTokenError,
        TokenExpiredError: VerifyOtpTokenExpiredError,
        NotFoundError: VerifyOtpNotFoundError,
        InternalServerError: VerifyOtpInternalServerError,
        BadGatewayError: VerifyOtpBadGatewayError,
        GatewayTimeoutError: VerifyOtpGatewayTimeoutError,
        GenericError: VerifyOtpGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    VerifyUserMfaFactor: {
        InvalidParameterError: VerifyUserMfaFactorInvalidParameterError,
        InvalidTokenError: VerifyUserMfaFactorInvalidTokenError,
        InvalidOtpError: VerifyUserMfaFactorInvalidOtpError,
        MfaFactorNotAllowedError: VerifyUserMfaFactorMfaFactorNotAllowedError,
        NotFoundError: VerifyUserMfaFactorNotFoundError,
        InternalServerError: VerifyUserMfaFactorInternalServerError,
        BadGatewayError: VerifyUserMfaFactorBadGatewayError,
        GatewayTimeoutError: VerifyUserMfaFactorGatewayTimeoutError,
        GenericError: VerifyUserMfaFactorGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTeam: {
        InvalidParameterError: DeleteTeamInvalidParameterError,
        UnauthorizedError: DeleteTeamUnauthorizedError,
        ForbiddenError: DeleteTeamForbiddenError,
        NotFoundError: DeleteTeamNotFoundError,
        InternalServerError: DeleteTeamInternalServerError,
        BadGatewayError: DeleteTeamBadGatewayError,
        GatewayTimeoutError: DeleteTeamGatewayTimeoutError,
        GenericError: DeleteTeamGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteUser: {
        InvalidParameterError: DeleteUserInvalidParameterError,
        UnauthorizedError: DeleteUserUnauthorizedError,
        ForbiddenError: DeleteUserForbiddenError,
        NotFoundError: DeleteUserNotFoundError,
        InternalServerError: DeleteUserInternalServerError,
        BadGatewayError: DeleteUserBadGatewayError,
        GatewayTimeoutError: DeleteUserGatewayTimeoutError,
        GenericError: DeleteUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteUserSCIM: {
        InvalidParameterError: DeleteUserSCIMInvalidParameterError,
        UnauthorizedError: DeleteUserSCIMUnauthorizedError,
        ForbiddenError: DeleteUserSCIMForbiddenError,
        NotFoundError: DeleteUserSCIMNotFoundError,
        InternalServerError: DeleteUserSCIMInternalServerError,
        BadGatewayError: DeleteUserSCIMBadGatewayError,
        GatewayTimeoutError: DeleteUserSCIMGatewayTimeoutError,
        GenericError: DeleteUserSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachGroupRole: {
        InvalidParameterError: DetachGroupRoleInvalidParameterError,
        UnauthorizedError: DetachGroupRoleUnauthorizedError,
        ForbiddenError: DetachGroupRoleForbiddenError,
        NotFoundError: DetachGroupRoleNotFoundError,
        InternalServerError: DetachGroupRoleInternalServerError,
        BadGatewayError: DetachGroupRoleBadGatewayError,
        GatewayTimeoutError: DetachGroupRoleGatewayTimeoutError,
        GenericError: DetachGroupRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachGroupUser: {
        InvalidParameterError: DetachGroupUserInvalidParameterError,
        UnauthorizedError: DetachGroupUserUnauthorizedError,
        ForbiddenError: DetachGroupUserForbiddenError,
        NotFoundError: DetachGroupUserNotFoundError,
        InternalServerError: DetachGroupUserInternalServerError,
        BadGatewayError: DetachGroupUserBadGatewayError,
        GatewayTimeoutError: DetachGroupUserGatewayTimeoutError,
        GenericError: DetachGroupUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachRolePolicy: {
        InvalidParameterError: DetachRolePolicyInvalidParameterError,
        UnauthorizedError: DetachRolePolicyUnauthorizedError,
        ForbiddenError: DetachRolePolicyForbiddenError,
        NotFoundError: DetachRolePolicyNotFoundError,
        InternalServerError: DetachRolePolicyInternalServerError,
        BadGatewayError: DetachRolePolicyBadGatewayError,
        GatewayTimeoutError: DetachRolePolicyGatewayTimeoutError,
        GenericError: DetachRolePolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachTeamGroup: {
        InvalidParameterError: DetachTeamGroupInvalidParameterError,
        UnauthorizedError: DetachTeamGroupUnauthorizedError,
        ForbiddenError: DetachTeamGroupForbiddenError,
        NotFoundError: DetachTeamGroupNotFoundError,
        InternalServerError: DetachTeamGroupInternalServerError,
        BadGatewayError: DetachTeamGroupBadGatewayError,
        GatewayTimeoutError: DetachTeamGroupGatewayTimeoutError,
        GenericError: DetachTeamGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachTeamGroupRole: {
        InvalidParameterError: DetachTeamGroupRoleInvalidParameterError,
        UnauthorizedError: DetachTeamGroupRoleUnauthorizedError,
        ForbiddenError: DetachTeamGroupRoleForbiddenError,
        NotFoundError: DetachTeamGroupRoleNotFoundError,
        InternalServerError: DetachTeamGroupRoleInternalServerError,
        BadGatewayError: DetachTeamGroupRoleBadGatewayError,
        GatewayTimeoutError: DetachTeamGroupRoleGatewayTimeoutError,
        GenericError: DetachTeamGroupRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachTeamGroupUser: {
        InvalidParameterError: DetachTeamGroupUserInvalidParameterError,
        UnauthorizedError: DetachTeamGroupUserUnauthorizedError,
        ForbiddenError: DetachTeamGroupUserForbiddenError,
        NotFoundError: DetachTeamGroupUserNotFoundError,
        InternalServerError: DetachTeamGroupUserInternalServerError,
        BadGatewayError: DetachTeamGroupUserBadGatewayError,
        GatewayTimeoutError: DetachTeamGroupUserGatewayTimeoutError,
        GenericError: DetachTeamGroupUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachTeamRole: {
        InvalidParameterError: DetachTeamRoleInvalidParameterError,
        UnauthorizedError: DetachTeamRoleUnauthorizedError,
        ForbiddenError: DetachTeamRoleForbiddenError,
        NotFoundError: DetachTeamRoleNotFoundError,
        InternalServerError: DetachTeamRoleInternalServerError,
        BadGatewayError: DetachTeamRoleBadGatewayError,
        GatewayTimeoutError: DetachTeamRoleGatewayTimeoutError,
        GenericError: DetachTeamRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachTeamUser: {
        InvalidParameterError: DetachTeamUserInvalidParameterError,
        UnauthorizedError: DetachTeamUserUnauthorizedError,
        ForbiddenError: DetachTeamUserForbiddenError,
        NotFoundError: DetachTeamUserNotFoundError,
        InternalServerError: DetachTeamUserInternalServerError,
        BadGatewayError: DetachTeamUserBadGatewayError,
        GatewayTimeoutError: DetachTeamUserGatewayTimeoutError,
        GenericError: DetachTeamUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachTeamUserRole: {
        InvalidParameterError: DetachTeamUserRoleInvalidParameterError,
        UnauthorizedError: DetachTeamUserRoleUnauthorizedError,
        ForbiddenError: DetachTeamUserRoleForbiddenError,
        NotFoundError: DetachTeamUserRoleNotFoundError,
        InternalServerError: DetachTeamUserRoleInternalServerError,
        BadGatewayError: DetachTeamUserRoleBadGatewayError,
        GatewayTimeoutError: DetachTeamUserRoleGatewayTimeoutError,
        GenericError: DetachTeamUserRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachUserRole: {
        InvalidParameterError: DetachUserRoleInvalidParameterError,
        UnauthorizedError: DetachUserRoleUnauthorizedError,
        ForbiddenError: DetachUserRoleForbiddenError,
        NotFoundError: DetachUserRoleNotFoundError,
        InternalServerError: DetachUserRoleInternalServerError,
        BadGatewayError: DetachUserRoleBadGatewayError,
        GatewayTimeoutError: DetachUserRoleGatewayTimeoutError,
        GenericError: DetachUserRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ForgotPassword: {
        InvalidParameterError: ForgotPasswordInvalidParameterError,
        InvalidIdentityUsernameError: ForgotPasswordInvalidIdentityUsernameError,
        NotFoundError: ForgotPasswordNotFoundError,
        InternalServerError: ForgotPasswordInternalServerError,
        BadGatewayError: ForgotPasswordBadGatewayError,
        GatewayTimeoutError: ForgotPasswordGatewayTimeoutError,
        GenericError: ForgotPasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccount: {
        UnauthorizedError: GetAccountUnauthorizedError,
        ForbiddenError: GetAccountForbiddenError,
        NotFoundError: GetAccountNotFoundError,
        InternalServerError: GetAccountInternalServerError,
        BadGatewayError: GetAccountBadGatewayError,
        GatewayTimeoutError: GetAccountGatewayTimeoutError,
        GenericError: GetAccountGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetGroup: {
        InvalidParameterError: GetGroupInvalidParameterError,
        UnauthorizedError: GetGroupUnauthorizedError,
        ForbiddenError: GetGroupForbiddenError,
        NotFoundError: GetGroupNotFoundError,
        InternalServerError: GetGroupInternalServerError,
        BadGatewayError: GetGroupBadGatewayError,
        GatewayTimeoutError: GetGroupGatewayTimeoutError,
        GenericError: GetGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetGroupSCIM: {
        InvalidParameterError: GetGroupSCIMInvalidParameterError,
        UnauthorizedError: GetGroupSCIMUnauthorizedError,
        ForbiddenError: GetGroupSCIMForbiddenError,
        NotFoundError: GetGroupSCIMNotFoundError,
        InternalServerError: GetGroupSCIMInternalServerError,
        BadGatewayError: GetGroupSCIMBadGatewayError,
        GatewayTimeoutError: GetGroupSCIMGatewayTimeoutError,
        GenericError: GetGroupSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetMfa: {
        UnauthorizedError: GetMfaUnauthorizedError,
        ForbiddenError: GetMfaForbiddenError,
        NotFoundError: GetMfaNotFoundError,
        InternalServerError: GetMfaInternalServerError,
        BadGatewayError: GetMfaBadGatewayError,
        GatewayTimeoutError: GetMfaGatewayTimeoutError,
        GenericError: GetMfaGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetPolicy: {
        InvalidParameterError: GetPolicyInvalidParameterError,
        UnauthorizedError: GetPolicyUnauthorizedError,
        ForbiddenError: GetPolicyForbiddenError,
        NotFoundError: GetPolicyNotFoundError,
        InternalServerError: GetPolicyInternalServerError,
        BadGatewayError: GetPolicyBadGatewayError,
        GatewayTimeoutError: GetPolicyGatewayTimeoutError,
        GenericError: GetPolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetProvider: {
        InvalidParameterError: GetProviderInvalidParameterError,
        UnauthorizedError: GetProviderUnauthorizedError,
        ForbiddenError: GetProviderForbiddenError,
        NotFoundError: GetProviderNotFoundError,
        InternalServerError: GetProviderInternalServerError,
        BadGatewayError: GetProviderBadGatewayError,
        GatewayTimeoutError: GetProviderGatewayTimeoutError,
        GenericError: GetProviderGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetResourceTypes: {
        UnauthorizedError: GetResourceTypesUnauthorizedError,
        ForbiddenError: GetResourceTypesForbiddenError,
        InternalServerError: GetResourceTypesInternalServerError,
        BadGatewayError: GetResourceTypesBadGatewayError,
        GatewayTimeoutError: GetResourceTypesGatewayTimeoutError,
        GenericError: GetResourceTypesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetRole: {
        InvalidParameterError: GetRoleInvalidParameterError,
        UnauthorizedError: GetRoleUnauthorizedError,
        ForbiddenError: GetRoleForbiddenError,
        NotFoundError: GetRoleNotFoundError,
        InternalServerError: GetRoleInternalServerError,
        BadGatewayError: GetRoleBadGatewayError,
        GatewayTimeoutError: GetRoleGatewayTimeoutError,
        GenericError: GetRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetSchemas: {
        UnauthorizedError: GetSchemasUnauthorizedError,
        ForbiddenError: GetSchemasForbiddenError,
        InternalServerError: GetSchemasInternalServerError,
        BadGatewayError: GetSchemasBadGatewayError,
        GatewayTimeoutError: GetSchemasGatewayTimeoutError,
        GenericError: GetSchemasGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetSecurity: {
        UnauthorizedError: GetSecurityUnauthorizedError,
        ForbiddenError: GetSecurityForbiddenError,
        NotFoundError: GetSecurityNotFoundError,
        InternalServerError: GetSecurityInternalServerError,
        BadGatewayError: GetSecurityBadGatewayError,
        GatewayTimeoutError: GetSecurityGatewayTimeoutError,
        GenericError: GetSecurityGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetServiceProviderConfig: {
        UnauthorizedError: GetServiceProviderConfigUnauthorizedError,
        ForbiddenError: GetServiceProviderConfigForbiddenError,
        InternalServerError: GetServiceProviderConfigInternalServerError,
        BadGatewayError: GetServiceProviderConfigBadGatewayError,
        GatewayTimeoutError: GetServiceProviderConfigGatewayTimeoutError,
        GenericError: GetServiceProviderConfigGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetSigninConfiguration: {
        InvalidParameterError: GetSigninConfigurationInvalidParameterError,
        NotFoundError: GetSigninConfigurationNotFoundError,
        InternalServerError: GetSigninConfigurationInternalServerError,
        BadGatewayError: GetSigninConfigurationBadGatewayError,
        GatewayTimeoutError: GetSigninConfigurationGatewayTimeoutError,
        GenericError: GetSigninConfigurationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeam: {
        InvalidParameterError: GetTeamInvalidParameterError,
        UnauthorizedError: GetTeamUnauthorizedError,
        ForbiddenError: GetTeamForbiddenError,
        NotFoundError: GetTeamNotFoundError,
        InternalServerError: GetTeamInternalServerError,
        BadGatewayError: GetTeamBadGatewayError,
        GatewayTimeoutError: GetTeamGatewayTimeoutError,
        GenericError: GetTeamGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamGroup: {
        InvalidParameterError: GetTeamGroupInvalidParameterError,
        UnauthorizedError: GetTeamGroupUnauthorizedError,
        ForbiddenError: GetTeamGroupForbiddenError,
        NotFoundError: GetTeamGroupNotFoundError,
        InternalServerError: GetTeamGroupInternalServerError,
        BadGatewayError: GetTeamGroupBadGatewayError,
        GatewayTimeoutError: GetTeamGroupGatewayTimeoutError,
        GenericError: GetTeamGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUser: {
        InvalidParameterError: GetTeamUserInvalidParameterError,
        UnauthorizedError: GetTeamUserUnauthorizedError,
        ForbiddenError: GetTeamUserForbiddenError,
        NotFoundError: GetTeamUserNotFoundError,
        InternalServerError: GetTeamUserInternalServerError,
        BadGatewayError: GetTeamUserBadGatewayError,
        GatewayTimeoutError: GetTeamUserGatewayTimeoutError,
        GenericError: GetTeamUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUser: {
        InvalidParameterError: GetUserInvalidParameterError,
        UnauthorizedError: GetUserUnauthorizedError,
        ForbiddenError: GetUserForbiddenError,
        NotFoundError: GetUserNotFoundError,
        InternalServerError: GetUserInternalServerError,
        BadGatewayError: GetUserBadGatewayError,
        GatewayTimeoutError: GetUserGatewayTimeoutError,
        GenericError: GetUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserMfa: {
        InvalidParameterError: GetUserMfaInvalidParameterError,
        UnauthorizedError: GetUserMfaUnauthorizedError,
        ForbiddenError: GetUserMfaForbiddenError,
        NotFoundError: GetUserMfaNotFoundError,
        InternalServerError: GetUserMfaInternalServerError,
        BadGatewayError: GetUserMfaBadGatewayError,
        GatewayTimeoutError: GetUserMfaGatewayTimeoutError,
        GenericError: GetUserMfaGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserSCIM: {
        InvalidParameterError: GetUserSCIMInvalidParameterError,
        UnauthorizedError: GetUserSCIMUnauthorizedError,
        ForbiddenError: GetUserSCIMForbiddenError,
        NotFoundError: GetUserSCIMNotFoundError,
        InternalServerError: GetUserSCIMInternalServerError,
        BadGatewayError: GetUserSCIMBadGatewayError,
        GatewayTimeoutError: GetUserSCIMGatewayTimeoutError,
        GenericError: GetUserSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InviteTeamUser: {
        InvalidParameterError: InviteTeamUserInvalidParameterError,
        UnauthorizedError: InviteTeamUserUnauthorizedError,
        ForbiddenError: InviteTeamUserForbiddenError,
        NotFoundError: InviteTeamUserNotFoundError,
        InternalServerError: InviteTeamUserInternalServerError,
        BadGatewayError: InviteTeamUserBadGatewayError,
        GatewayTimeoutError: InviteTeamUserGatewayTimeoutError,
        GenericError: InviteTeamUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InviteUser: {
        InvalidParameterError: InviteUserInvalidParameterError,
        UnauthorizedError: InviteUserUnauthorizedError,
        InvalidEmailError: InviteUserInvalidEmailError,
        ForbiddenError: InviteUserForbiddenError,
        NotFoundError: InviteUserNotFoundError,
        InternalServerError: InviteUserInternalServerError,
        BadGatewayError: InviteUserBadGatewayError,
        GatewayTimeoutError: InviteUserGatewayTimeoutError,
        GenericError: InviteUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListGroupRoles: {
        InvalidParameterError: ListGroupRolesInvalidParameterError,
        UnauthorizedError: ListGroupRolesUnauthorizedError,
        ForbiddenError: ListGroupRolesForbiddenError,
        NotFoundError: ListGroupRolesNotFoundError,
        InternalServerError: ListGroupRolesInternalServerError,
        BadGatewayError: ListGroupRolesBadGatewayError,
        GatewayTimeoutError: ListGroupRolesGatewayTimeoutError,
        GenericError: ListGroupRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListGroupTeams: {
        InvalidParameterError: ListGroupTeamsInvalidParameterError,
        UnauthorizedError: ListGroupTeamsUnauthorizedError,
        ForbiddenError: ListGroupTeamsForbiddenError,
        NotFoundError: ListGroupTeamsNotFoundError,
        InternalServerError: ListGroupTeamsInternalServerError,
        BadGatewayError: ListGroupTeamsBadGatewayError,
        GatewayTimeoutError: ListGroupTeamsGatewayTimeoutError,
        GenericError: ListGroupTeamsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListGroupUsers: {
        InvalidParameterError: ListGroupUsersInvalidParameterError,
        UnauthorizedError: ListGroupUsersUnauthorizedError,
        ForbiddenError: ListGroupUsersForbiddenError,
        NotFoundError: ListGroupUsersNotFoundError,
        InternalServerError: ListGroupUsersInternalServerError,
        BadGatewayError: ListGroupUsersBadGatewayError,
        GatewayTimeoutError: ListGroupUsersGatewayTimeoutError,
        GenericError: ListGroupUsersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AcceptInvitation: {
        InvalidParameterError: AcceptInvitationInvalidParameterError,
        InvalidInvitationError: AcceptInvitationInvalidInvitationError,
        InvalidInvitationSecretError: AcceptInvitationInvalidInvitationSecretError,
        ExpiredInvitationError: AcceptInvitationExpiredInvitationError,
        NotFoundError: AcceptInvitationNotFoundError,
        InternalServerError: AcceptInvitationInternalServerError,
        BadGatewayError: AcceptInvitationBadGatewayError,
        GatewayTimeoutError: AcceptInvitationGatewayTimeoutError,
        GenericError: AcceptInvitationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AcceptUserInvitation: {
        InvalidParameterError: AcceptUserInvitationInvalidParameterError,
        InvalidInvitationError: AcceptUserInvitationInvalidInvitationError,
        ExpiredInvitationError: AcceptUserInvitationExpiredInvitationError,
        NotFoundError: AcceptUserInvitationNotFoundError,
        InternalServerError: AcceptUserInvitationInternalServerError,
        BadGatewayError: AcceptUserInvitationBadGatewayError,
        GatewayTimeoutError: AcceptUserInvitationGatewayTimeoutError,
        GenericError: AcceptUserInvitationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachGroupRole: {
        InvalidParameterError: AttachGroupRoleInvalidParameterError,
        UnauthorizedError: AttachGroupRoleUnauthorizedError,
        ForbiddenError: AttachGroupRoleForbiddenError,
        NotFoundError: AttachGroupRoleNotFoundError,
        ConflictError: AttachGroupRoleConflictError,
        InternalServerError: AttachGroupRoleInternalServerError,
        BadGatewayError: AttachGroupRoleBadGatewayError,
        GatewayTimeoutError: AttachGroupRoleGatewayTimeoutError,
        GenericError: AttachGroupRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachGroupUser: {
        InvalidParameterError: AttachGroupUserInvalidParameterError,
        UnauthorizedError: AttachGroupUserUnauthorizedError,
        ForbiddenError: AttachGroupUserForbiddenError,
        NotFoundError: AttachGroupUserNotFoundError,
        ConflictError: AttachGroupUserConflictError,
        InternalServerError: AttachGroupUserInternalServerError,
        BadGatewayError: AttachGroupUserBadGatewayError,
        GatewayTimeoutError: AttachGroupUserGatewayTimeoutError,
        GenericError: AttachGroupUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachRolePolicy: {
        InvalidParameterError: AttachRolePolicyInvalidParameterError,
        UnauthorizedError: AttachRolePolicyUnauthorizedError,
        ForbiddenError: AttachRolePolicyForbiddenError,
        NotFoundError: AttachRolePolicyNotFoundError,
        ConflictError: AttachRolePolicyConflictError,
        InternalServerError: AttachRolePolicyInternalServerError,
        BadGatewayError: AttachRolePolicyBadGatewayError,
        GatewayTimeoutError: AttachRolePolicyGatewayTimeoutError,
        GenericError: AttachRolePolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachTeamGroup: {
        InvalidParameterError: AttachTeamGroupInvalidParameterError,
        UnauthorizedError: AttachTeamGroupUnauthorizedError,
        ForbiddenError: AttachTeamGroupForbiddenError,
        NotFoundError: AttachTeamGroupNotFoundError,
        ConflictError: AttachTeamGroupConflictError,
        InternalServerError: AttachTeamGroupInternalServerError,
        BadGatewayError: AttachTeamGroupBadGatewayError,
        GatewayTimeoutError: AttachTeamGroupGatewayTimeoutError,
        GenericError: AttachTeamGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachTeamGroupRole: {
        InvalidParameterError: AttachTeamGroupRoleInvalidParameterError,
        UnauthorizedError: AttachTeamGroupRoleUnauthorizedError,
        ForbiddenError: AttachTeamGroupRoleForbiddenError,
        NotFoundError: AttachTeamGroupRoleNotFoundError,
        ConflictError: AttachTeamGroupRoleConflictError,
        InternalServerError: AttachTeamGroupRoleInternalServerError,
        BadGatewayError: AttachTeamGroupRoleBadGatewayError,
        GatewayTimeoutError: AttachTeamGroupRoleGatewayTimeoutError,
        GenericError: AttachTeamGroupRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachTeamGroupUser: {
        InvalidParameterError: AttachTeamGroupUserInvalidParameterError,
        UnauthorizedError: AttachTeamGroupUserUnauthorizedError,
        ForbiddenError: AttachTeamGroupUserForbiddenError,
        NotFoundError: AttachTeamGroupUserNotFoundError,
        ConflictError: AttachTeamGroupUserConflictError,
        InternalServerError: AttachTeamGroupUserInternalServerError,
        BadGatewayError: AttachTeamGroupUserBadGatewayError,
        GatewayTimeoutError: AttachTeamGroupUserGatewayTimeoutError,
        GenericError: AttachTeamGroupUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachTeamRole: {
        InvalidParameterError: AttachTeamRoleInvalidParameterError,
        UnauthorizedError: AttachTeamRoleUnauthorizedError,
        ForbiddenError: AttachTeamRoleForbiddenError,
        NotFoundError: AttachTeamRoleNotFoundError,
        ConflictError: AttachTeamRoleConflictError,
        InternalServerError: AttachTeamRoleInternalServerError,
        BadGatewayError: AttachTeamRoleBadGatewayError,
        GatewayTimeoutError: AttachTeamRoleGatewayTimeoutError,
        GenericError: AttachTeamRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachTeamUser: {
        InvalidParameterError: AttachTeamUserInvalidParameterError,
        UnauthorizedError: AttachTeamUserUnauthorizedError,
        ForbiddenError: AttachTeamUserForbiddenError,
        NotFoundError: AttachTeamUserNotFoundError,
        ConflictError: AttachTeamUserConflictError,
        InternalServerError: AttachTeamUserInternalServerError,
        BadGatewayError: AttachTeamUserBadGatewayError,
        GatewayTimeoutError: AttachTeamUserGatewayTimeoutError,
        GenericError: AttachTeamUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachTeamUserRole: {
        InvalidParameterError: AttachTeamUserRoleInvalidParameterError,
        UnauthorizedError: AttachTeamUserRoleUnauthorizedError,
        ForbiddenError: AttachTeamUserRoleForbiddenError,
        NotFoundError: AttachTeamUserRoleNotFoundError,
        ConflictError: AttachTeamUserRoleConflictError,
        InternalServerError: AttachTeamUserRoleInternalServerError,
        BadGatewayError: AttachTeamUserRoleBadGatewayError,
        GatewayTimeoutError: AttachTeamUserRoleGatewayTimeoutError,
        GenericError: AttachTeamUserRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachUserRole: {
        InvalidParameterError: AttachUserRoleInvalidParameterError,
        UnauthorizedError: AttachUserRoleUnauthorizedError,
        ForbiddenError: AttachUserRoleForbiddenError,
        NotFoundError: AttachUserRoleNotFoundError,
        ConflictError: AttachUserRoleConflictError,
        InternalServerError: AttachUserRoleInternalServerError,
        BadGatewayError: AttachUserRoleBadGatewayError,
        GatewayTimeoutError: AttachUserRoleGatewayTimeoutError,
        GenericError: AttachUserRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ChangePassword: {
        InvalidParameterError: ChangePasswordInvalidParameterError,
        InvalidSecretError: ChangePasswordInvalidSecretError,
        ExpiredSecretError: ChangePasswordExpiredSecretError,
        NotFoundError: ChangePasswordNotFoundError,
        InternalServerError: ChangePasswordInternalServerError,
        BadGatewayError: ChangePasswordBadGatewayError,
        GatewayTimeoutError: ChangePasswordGatewayTimeoutError,
        GenericError: ChangePasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateAccount: {
        InvalidParameterError: CreateAccountInvalidParameterError,
        NotFoundError: CreateAccountNotFoundError,
        ConflictError: CreateAccountConflictError,
        InternalServerError: CreateAccountInternalServerError,
        BadGatewayError: CreateAccountBadGatewayError,
        GatewayTimeoutError: CreateAccountGatewayTimeoutError,
        GenericError: CreateAccountGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateGroup: {
        InvalidParameterError: CreateGroupInvalidParameterError,
        UnauthorizedError: CreateGroupUnauthorizedError,
        ForbiddenError: CreateGroupForbiddenError,
        ConflictError: CreateGroupConflictError,
        InternalServerError: CreateGroupInternalServerError,
        BadGatewayError: CreateGroupBadGatewayError,
        GatewayTimeoutError: CreateGroupGatewayTimeoutError,
        GenericError: CreateGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateGroupSCIM: {
        InvalidParameterError: CreateGroupSCIMInvalidParameterError,
        UnauthorizedError: CreateGroupSCIMUnauthorizedError,
        ForbiddenError: CreateGroupSCIMForbiddenError,
        NotFoundError: CreateGroupSCIMNotFoundError,
        ConflictError: CreateGroupSCIMConflictError,
        InternalServerError: CreateGroupSCIMInternalServerError,
        BadGatewayError: CreateGroupSCIMBadGatewayError,
        GatewayTimeoutError: CreateGroupSCIMGatewayTimeoutError,
        GenericError: CreateGroupSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateMfaFactorSecret: {
        InvalidParameterError: CreateMfaFactorSecretInvalidParameterError,
        InvalidTokenError: CreateMfaFactorSecretInvalidTokenError,
        MfaFactorNotAllowedError: CreateMfaFactorSecretMfaFactorNotAllowedError,
        NotFoundError: CreateMfaFactorSecretNotFoundError,
        InternalServerError: CreateMfaFactorSecretInternalServerError,
        BadGatewayError: CreateMfaFactorSecretBadGatewayError,
        GatewayTimeoutError: CreateMfaFactorSecretGatewayTimeoutError,
        GenericError: CreateMfaFactorSecretGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreatePolicy: {
        InvalidParameterError: CreatePolicyInvalidParameterError,
        UnauthorizedError: CreatePolicyUnauthorizedError,
        ForbiddenError: CreatePolicyForbiddenError,
        ConflictError: CreatePolicyConflictError,
        InternalServerError: CreatePolicyInternalServerError,
        BadGatewayError: CreatePolicyBadGatewayError,
        GatewayTimeoutError: CreatePolicyGatewayTimeoutError,
        GenericError: CreatePolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateProvider: {
        InvalidParameterError: CreateProviderInvalidParameterError,
        UnauthorizedError: CreateProviderUnauthorizedError,
        InvalidCertificateError: CreateProviderInvalidCertificateError,
        ForbiddenError: CreateProviderForbiddenError,
        ConflictError: CreateProviderConflictError,
        InternalServerError: CreateProviderInternalServerError,
        BadGatewayError: CreateProviderBadGatewayError,
        GatewayTimeoutError: CreateProviderGatewayTimeoutError,
        GenericError: CreateProviderGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateRole: {
        InvalidParameterError: CreateRoleInvalidParameterError,
        UnauthorizedError: CreateRoleUnauthorizedError,
        ForbiddenError: CreateRoleForbiddenError,
        ConflictError: CreateRoleConflictError,
        InternalServerError: CreateRoleInternalServerError,
        BadGatewayError: CreateRoleBadGatewayError,
        GatewayTimeoutError: CreateRoleGatewayTimeoutError,
        GenericError: CreateRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTeam: {
        InvalidParameterError: CreateTeamInvalidParameterError,
        UnauthorizedError: CreateTeamUnauthorizedError,
        ForbiddenError: CreateTeamForbiddenError,
        ConflictError: CreateTeamConflictError,
        InternalServerError: CreateTeamInternalServerError,
        BadGatewayError: CreateTeamBadGatewayError,
        GatewayTimeoutError: CreateTeamGatewayTimeoutError,
        GenericError: CreateTeamGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateToken: {
        InvalidParameterError: CreateTokenInvalidParameterError,
        InvalidCredentialsError: CreateTokenInvalidCredentialsError,
        PasswordRevokedError: CreateTokenPasswordRevokedError,
        IdentityDisabledError: CreateTokenIdentityDisabledError,
        InvalidAuthenticationModeError: CreateTokenInvalidAuthenticationModeError,
        MfaRequiredError: CreateTokenMfaRequiredError,
        NotFoundError: CreateTokenNotFoundError,
        ConflictError: CreateTokenConflictError,
        InternalServerError: CreateTokenInternalServerError,
        BadGatewayError: CreateTokenBadGatewayError,
        GatewayTimeoutError: CreateTokenGatewayTimeoutError,
        GenericError: CreateTokenGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateUser: {
        InvalidParameterError: CreateUserInvalidParameterError,
        UnauthorizedError: CreateUserUnauthorizedError,
        InvalidSubscriptionError: CreateUserInvalidSubscriptionError,
        ForbiddenError: CreateUserForbiddenError,
        ConflictError: CreateUserConflictError,
        InternalServerError: CreateUserInternalServerError,
        BadGatewayError: CreateUserBadGatewayError,
        GatewayTimeoutError: CreateUserGatewayTimeoutError,
        GenericError: CreateUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateUserMfaFactorSecret: {
        InvalidParameterError: CreateUserMfaFactorSecretInvalidParameterError,
        InvalidTokenError: CreateUserMfaFactorSecretInvalidTokenError,
        MfaFactorNotAllowedError: CreateUserMfaFactorSecretMfaFactorNotAllowedError,
        NotFoundError: CreateUserMfaFactorSecretNotFoundError,
        InternalServerError: CreateUserMfaFactorSecretInternalServerError,
        BadGatewayError: CreateUserMfaFactorSecretBadGatewayError,
        GatewayTimeoutError: CreateUserMfaFactorSecretGatewayTimeoutError,
        GenericError: CreateUserMfaFactorSecretGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateUserSCIM: {
        InvalidParameterError: CreateUserSCIMInvalidParameterError,
        UnauthorizedError: CreateUserSCIMUnauthorizedError,
        ForbiddenError: CreateUserSCIMForbiddenError,
        NotFoundError: CreateUserSCIMNotFoundError,
        ConflictError: CreateUserSCIMConflictError,
        InternalServerError: CreateUserSCIMInternalServerError,
        BadGatewayError: CreateUserSCIMBadGatewayError,
        GatewayTimeoutError: CreateUserSCIMGatewayTimeoutError,
        GenericError: CreateUserSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateUserToken: {
        InvalidParameterError: CreateUserTokenInvalidParameterError,
        UnauthorizedError: CreateUserTokenUnauthorizedError,
        IdentityDisabledError: CreateUserTokenIdentityDisabledError,
        ForbiddenError: CreateUserTokenForbiddenError,
        NotFoundError: CreateUserTokenNotFoundError,
        ConflictError: CreateUserTokenConflictError,
        InternalServerError: CreateUserTokenInternalServerError,
        BadGatewayError: CreateUserTokenBadGatewayError,
        GatewayTimeoutError: CreateUserTokenGatewayTimeoutError,
        GenericError: CreateUserTokenGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteAccount: {
        UnauthorizedError: DeleteAccountUnauthorizedError,
        ForbiddenError: DeleteAccountForbiddenError,
        NotFoundError: DeleteAccountNotFoundError,
        InternalServerError: DeleteAccountInternalServerError,
        BadGatewayError: DeleteAccountBadGatewayError,
        GatewayTimeoutError: DeleteAccountGatewayTimeoutError,
        GenericError: DeleteAccountGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteGroup: {
        InvalidParameterError: DeleteGroupInvalidParameterError,
        UnauthorizedError: DeleteGroupUnauthorizedError,
        ForbiddenError: DeleteGroupForbiddenError,
        NotFoundError: DeleteGroupNotFoundError,
        InternalServerError: DeleteGroupInternalServerError,
        BadGatewayError: DeleteGroupBadGatewayError,
        GatewayTimeoutError: DeleteGroupGatewayTimeoutError,
        GenericError: DeleteGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteGroupSCIM: {
        InvalidParameterError: DeleteGroupSCIMInvalidParameterError,
        UnauthorizedError: DeleteGroupSCIMUnauthorizedError,
        ForbiddenError: DeleteGroupSCIMForbiddenError,
        NotFoundError: DeleteGroupSCIMNotFoundError,
        InternalServerError: DeleteGroupSCIMInternalServerError,
        BadGatewayError: DeleteGroupSCIMBadGatewayError,
        GatewayTimeoutError: DeleteGroupSCIMGatewayTimeoutError,
        GenericError: DeleteGroupSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeletePolicy: {
        InvalidParameterError: DeletePolicyInvalidParameterError,
        UnauthorizedError: DeletePolicyUnauthorizedError,
        ForbiddenError: DeletePolicyForbiddenError,
        NotFoundError: DeletePolicyNotFoundError,
        InternalServerError: DeletePolicyInternalServerError,
        BadGatewayError: DeletePolicyBadGatewayError,
        GatewayTimeoutError: DeletePolicyGatewayTimeoutError,
        GenericError: DeletePolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteProvider: {
        InvalidParameterError: DeleteProviderInvalidParameterError,
        UnauthorizedError: DeleteProviderUnauthorizedError,
        ForbiddenError: DeleteProviderForbiddenError,
        NotFoundError: DeleteProviderNotFoundError,
        InternalServerError: DeleteProviderInternalServerError,
        BadGatewayError: DeleteProviderBadGatewayError,
        GatewayTimeoutError: DeleteProviderGatewayTimeoutError,
        GenericError: DeleteProviderGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteRole: {
        InvalidParameterError: DeleteRoleInvalidParameterError,
        UnauthorizedError: DeleteRoleUnauthorizedError,
        ForbiddenError: DeleteRoleForbiddenError,
        NotFoundError: DeleteRoleNotFoundError,
        InternalServerError: DeleteRoleInternalServerError,
        BadGatewayError: DeleteRoleBadGatewayError,
        GatewayTimeoutError: DeleteRoleGatewayTimeoutError,
        GenericError: DeleteRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DecodeToken: {
        FailedToDecodeTokenError: DecodeTokenFailedToDecodeTokenError,
        GenericError: DecodeTokenGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListGroupsError: {
        UnauthorizedError: ListGroupsUnauthorizedError,
        ForbiddenError: ListGroupsForbiddenError,
        NotFoundError: ListGroupsNotFoundError,
        InternalServerError: ListGroupsInternalServerError,
        BadGatewayError: ListGroupsBadGatewayError,
        GatewayTimeoutError: ListGroupsGatewayTimeoutError,
        GenericError: ListGroupsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListGroupsSCIMError: {
        InvalidParameterError: ListGroupsSCIMInvalidParameterError,
        UnauthorizedError: ListGroupsSCIMUnauthorizedError,
        ForbiddenError: ListGroupsSCIMForbiddenError,
        InternalServerError: ListGroupsSCIMInternalServerError,
        BadGatewayError: ListGroupsSCIMBadGatewayError,
        GatewayTimeoutError: ListGroupsSCIMGatewayTimeoutError,
        GenericError: ListGroupsSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListPoliciesError: {
        UnauthorizedError: ListPoliciesUnauthorizedError,
        ForbiddenError: ListPoliciesForbiddenError,
        InternalServerError: ListPoliciesInternalServerError,
        BadGatewayError: ListPoliciesBadGatewayError,
        GatewayTimeoutError: ListPoliciesGatewayTimeoutError,
        GenericError: ListPoliciesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListProvidersError: {
        UnauthorizedError: ListProvidersUnauthorizedError,
        ForbiddenError: ListProvidersForbiddenError,
        InternalServerError: ListProvidersInternalServerError,
        BadGatewayError: ListProvidersBadGatewayError,
        GatewayTimeoutError: ListProvidersGatewayTimeoutError,
        GenericError: ListProvidersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListRolesError: {
        UnauthorizedError: ListRolesUnauthorizedError,
        ForbiddenError: ListRolesForbiddenError,
        InternalServerError: ListRolesInternalServerError,
        BadGatewayError: ListRolesBadGatewayError,
        GatewayTimeoutError: ListRolesGatewayTimeoutError,
        GenericError: ListRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamGroupRolesError: {
        InvalidParameterError: ListTeamGroupRolesInvalidParameterError,
        UnauthorizedError: ListTeamGroupRolesUnauthorizedError,
        ForbiddenError: ListTeamGroupRolesForbiddenError,
        NotFoundError: ListTeamGroupRolesNotFoundError,
        InternalServerError: ListTeamGroupRolesInternalServerError,
        BadGatewayError: ListTeamGroupRolesBadGatewayError,
        GatewayTimeoutError: ListTeamGroupRolesGatewayTimeoutError,
        GenericError: ListTeamGroupRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamGroupUsersError: {
        InvalidParameterError: ListTeamGroupUsersInvalidParameterError,
        UnauthorizedError: ListTeamGroupUsersUnauthorizedError,
        ForbiddenError: ListTeamGroupUsersForbiddenError,
        NotFoundError: ListTeamGroupUsersNotFoundError,
        InternalServerError: ListTeamGroupUsersInternalServerError,
        BadGatewayError: ListTeamGroupUsersBadGatewayError,
        GatewayTimeoutError: ListTeamGroupUsersGatewayTimeoutError,
        GenericError: ListTeamGroupUsersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamGroupsError: {
        InvalidParameterError: ListTeamGroupsInvalidParameterError,
        UnauthorizedError: ListTeamGroupsUnauthorizedError,
        ForbiddenError: ListTeamGroupsForbiddenError,
        NotFoundError: ListTeamGroupsNotFoundError,
        InternalServerError: ListTeamGroupsInternalServerError,
        BadGatewayError: ListTeamGroupsBadGatewayError,
        GatewayTimeoutError: ListTeamGroupsGatewayTimeoutError,
        GenericError: ListTeamGroupsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamRolesError: {
        InvalidParameterError: ListTeamRolesInvalidParameterError,
        UnauthorizedError: ListTeamRolesUnauthorizedError,
        ForbiddenError: ListTeamRolesForbiddenError,
        NotFoundError: ListTeamRolesNotFoundError,
        InternalServerError: ListTeamRolesInternalServerError,
        BadGatewayError: ListTeamRolesBadGatewayError,
        GatewayTimeoutError: ListTeamRolesGatewayTimeoutError,
        GenericError: ListTeamRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUserGroupsError: {
        InvalidParameterError: ListTeamUserGroupsInvalidParameterError,
        UnauthorizedError: ListTeamUserGroupsUnauthorizedError,
        ForbiddenError: ListTeamUserGroupsForbiddenError,
        NotFoundError: ListTeamUserGroupsNotFoundError,
        InternalServerError: ListTeamUserGroupsInternalServerError,
        BadGatewayError: ListTeamUserGroupsBadGatewayError,
        GatewayTimeoutError: ListTeamUserGroupsGatewayTimeoutError,
        GenericError: ListTeamUserGroupsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUserRolesError: {
        InvalidParameterError: ListTeamUserRolesInvalidParameterError,
        UnauthorizedError: ListTeamUserRolesUnauthorizedError,
        ForbiddenError: ListTeamUserRolesForbiddenError,
        NotFoundError: ListTeamUserRolesNotFoundError,
        InternalServerError: ListTeamUserRolesInternalServerError,
        BadGatewayError: ListTeamUserRolesBadGatewayError,
        GatewayTimeoutError: ListTeamUserRolesGatewayTimeoutError,
        GenericError: ListTeamUserRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUsersError: {
        InvalidParameterError: ListTeamUsersInvalidParameterError,
        UnauthorizedError: ListTeamUsersUnauthorizedError,
        ForbiddenError: ListTeamUsersForbiddenError,
        NotFoundError: ListTeamUsersNotFoundError,
        InternalServerError: ListTeamUsersInternalServerError,
        BadGatewayError: ListTeamUsersBadGatewayError,
        GatewayTimeoutError: ListTeamUsersGatewayTimeoutError,
        GenericError: ListTeamUsersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamsError: {
        UnauthorizedError: ListTeamsUnauthorizedError,
        ForbiddenError: ListTeamsForbiddenError,
        InternalServerError: ListTeamsInternalServerError,
        BadGatewayError: ListTeamsBadGatewayError,
        GatewayTimeoutError: ListTeamsGatewayTimeoutError,
        GenericError: ListTeamsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserGroupsError: {
        InvalidParameterError: ListUserGroupsInvalidParameterError,
        UnauthorizedError: ListUserGroupsUnauthorizedError,
        ForbiddenError: ListUserGroupsForbiddenError,
        NotFoundError: ListUserGroupsNotFoundError,
        InternalServerError: ListUserGroupsInternalServerError,
        BadGatewayError: ListUserGroupsBadGatewayError,
        GatewayTimeoutError: ListUserGroupsGatewayTimeoutError,
        GenericError: ListUserGroupsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserGroupsRolesError: {
        InvalidParameterError: ListUserGroupsRolesInvalidParameterError,
        UnauthorizedError: ListUserGroupsRolesUnauthorizedError,
        ForbiddenError: ListUserGroupsRolesForbiddenError,
        NotFoundError: ListUserGroupsRolesNotFoundError,
        InternalServerError: ListUserGroupsRolesInternalServerError,
        BadGatewayError: ListUserGroupsRolesBadGatewayError,
        GatewayTimeoutError: ListUserGroupsRolesGatewayTimeoutError,
        GenericError: ListUserGroupsRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserGroupsTeamsError: {
        InvalidParameterError: ListUserGroupsTeamsInvalidParameterError,
        UnauthorizedError: ListUserGroupsTeamsUnauthorizedError,
        ForbiddenError: ListUserGroupsTeamsForbiddenError,
        NotFoundError: ListUserGroupsTeamsNotFoundError,
        InternalServerError: ListUserGroupsTeamsInternalServerError,
        BadGatewayError: ListUserGroupsTeamsBadGatewayError,
        GatewayTimeoutError: ListUserGroupsTeamsGatewayTimeoutError,
        GenericError: ListUserGroupsTeamsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserRolesError: {
        InvalidParameterError: ListUserRolesInvalidParameterError,
        UnauthorizedError: ListUserRolesUnauthorizedError,
        ForbiddenError: ListUserRolesForbiddenError,
        NotFoundError: ListUserRolesNotFoundError,
        InternalServerError: ListUserRolesInternalServerError,
        BadGatewayError: ListUserRolesBadGatewayError,
        GatewayTimeoutError: ListUserRolesGatewayTimeoutError,
        GenericError: ListUserRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserTeamsError: {
        InvalidParameterError: ListUserTeamsInvalidParameterError,
        UnauthorizedError: ListUserTeamsUnauthorizedError,
        ForbiddenError: ListUserTeamsForbiddenError,
        NotFoundError: ListUserTeamsNotFoundError,
        InternalServerError: ListUserTeamsInternalServerError,
        BadGatewayError: ListUserTeamsBadGatewayError,
        GatewayTimeoutError: ListUserTeamsGatewayTimeoutError,
        GenericError: ListUserTeamsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUsersError: {
        UnauthorizedError: ListUsersUnauthorizedError,
        ForbiddenError: ListUsersForbiddenError,
        InternalServerError: ListUsersInternalServerError,
        BadGatewayError: ListUsersBadGatewayError,
        GatewayTimeoutError: ListUsersGatewayTimeoutError,
        GenericError: ListUsersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUsersSCIMError: {
        InvalidParameterError: ListUsersSCIMInvalidParameterError,
        UnauthorizedError: ListUsersSCIMUnauthorizedError,
        ForbiddenError: ListUsersSCIMForbiddenError,
        InternalServerError: ListUsersSCIMInternalServerError,
        BadGatewayError: ListUsersSCIMBadGatewayError,
        GatewayTimeoutError: ListUsersSCIMGatewayTimeoutError,
        GenericError: ListUsersSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    PatchGroupSCIMError: {
        InvalidParameterError: PatchGroupSCIMInvalidParameterError,
        UnauthorizedError: PatchGroupSCIMUnauthorizedError,
        ForbiddenError: PatchGroupSCIMForbiddenError,
        NotFoundError: PatchGroupSCIMNotFoundError,
        InternalServerError: PatchGroupSCIMInternalServerError,
        BadGatewayError: PatchGroupSCIMBadGatewayError,
        GatewayTimeoutError: PatchGroupSCIMGatewayTimeoutError,
        GenericError: PatchGroupSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    PatchUserSCIMError: {
        InvalidParameterError: PatchUserSCIMInvalidParameterError,
        UnauthorizedError: PatchUserSCIMUnauthorizedError,
        ForbiddenError: PatchUserSCIMForbiddenError,
        NotFoundError: PatchUserSCIMNotFoundError,
        ConflictError: PatchUserSCIMConflictError,
        InternalServerError: PatchUserSCIMInternalServerError,
        BadGatewayError: PatchUserSCIMBadGatewayError,
        GatewayTimeoutError: PatchUserSCIMGatewayTimeoutError,
        GenericError: PatchUserSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    RenewTokenError: {
        InvalidParameterError: RenewTokenInvalidParameterError,
        PasswordRevokedError: RenewTokenPasswordRevokedError,
        IdentityDisabledError: RenewTokenIdentityDisabledError,
        NotAllowedError: RenewTokenNotAllowedError,
        InvalidRefreshTokenError: RenewTokenInvalidRefreshTokenError,
        NotFoundError: RenewTokenNotFoundError,
        InternalServerError: RenewTokenInternalServerError,
        BadGatewayError: RenewTokenBadGatewayError,
        GatewayTimeoutError: RenewTokenGatewayTimeoutError,
        GenericError: RenewTokenGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ResetMfaFactorError: {
        InvalidParameterError: ResetMfaFactorInvalidParameterError,
        UnauthorizedError: ResetMfaFactorUnauthorizedError,
        ForbiddenError: ResetMfaFactorForbiddenError,
        NotFoundError: ResetMfaFactorNotFoundError,
        InternalServerError: ResetMfaFactorInternalServerError,
        BadGatewayError: ResetMfaFactorBadGatewayError,
        GatewayTimeoutError: ResetMfaFactorGatewayTimeoutError,
        GenericError: ResetMfaFactorGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ResetPasswordError: {
        InvalidParameterError: ResetPasswordInvalidParameterError,
        InvalidSecretError: ResetPasswordInvalidSecretError,
        ExpiredSecretError: ResetPasswordExpiredSecretError,
        NotFoundError: ResetPasswordNotFoundError,
        InternalServerError: ResetPasswordInternalServerError,
        BadGatewayError: ResetPasswordBadGatewayError,
        GatewayTimeoutError: ResetPasswordGatewayTimeoutError,
        GenericError: ResetPasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ResetUserMfaFactorError: {
        InvalidParameterError: ResetUserMfaFactorInvalidParameterError,
        UnauthorizedError: ResetUserMfaFactorUnauthorizedError,
        ForbiddenError: ResetUserMfaFactorForbiddenError,
        NotFoundError: ResetUserMfaFactorNotFoundError,
        InternalServerError: ResetUserMfaFactorInternalServerError,
        BadGatewayError: ResetUserMfaFactorBadGatewayError,
        GatewayTimeoutError: ResetUserMfaFactorGatewayTimeoutError,
        GenericError: ResetUserMfaFactorGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    RotateKeyError: {
        UnauthorizedError: RotateKeyUnauthorizedError,
        ForbiddenError: RotateKeyForbiddenError,
        NotFoundError: RotateKeyNotFoundError,
        InternalServerError: RotateKeyInternalServerError,
        BadGatewayError: RotateKeyBadGatewayError,
        GatewayTimeoutError: RotateKeyGatewayTimeoutError,
        GenericError: RotateKeyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    RotateUserKeyError: {
        InvalidParameterError: RotateUserKeyInvalidParameterError,
        UnauthorizedError: RotateUserKeyUnauthorizedError,
        ForbiddenError: RotateUserKeyForbiddenError,
        NotFoundError: RotateUserKeyNotFoundError,
        InternalServerError: RotateUserKeyInternalServerError,
        BadGatewayError: RotateUserKeyBadGatewayError,
        GatewayTimeoutError: RotateUserKeyGatewayTimeoutError,
        GenericError: RotateUserKeyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    SamlSignonError: {
        InvalidParameterError: SamlSignonInvalidParameterError,
        UserNotAllowedToSignonError: SamlSignonUserNotAllowedToSignonError,
        InvalidAudienceUriError: SamlSignonInvalidAudienceUriError,
        NotFoundError: SamlSignonNotFoundError,
        ConflictError: SamlSignonConflictError,
        InternalServerError: SamlSignonInternalServerError,
        BadGatewayError: SamlSignonBadGatewayError,
        GatewayTimeoutError: SamlSignonGatewayTimeoutError,
        GenericError: SamlSignonGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    SendOtpError: {
        InvalidParameterError: SendOtpInvalidParameterError,
        InvalidTokenError: SendOtpInvalidTokenError,
        MfaFactorNotAllowedError: SendOtpMfaFactorNotAllowedError,
        ConflictError: SendOtpConflictError,
        InternalServerError: SendOtpInternalServerError,
        BadGatewayError: SendOtpBadGatewayError,
        GatewayTimeoutError: SendOtpGatewayTimeoutError,
        GenericError: SendOtpGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    SsoSigninError: {
        InvalidParameterError: SsoSigninInvalidParameterError,
        NotFoundError: SsoSigninNotFoundError,
        ConflictError: SsoSigninConflictError,
        InternalServerError: SsoSigninInternalServerError,
        BadGatewayError: SsoSigninBadGatewayError,
        GatewayTimeoutError: SsoSigninGatewayTimeoutError,
        GenericError: SsoSigninGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateAccountError: {
        InvalidParameterError: UpdateAccountInvalidParameterError,
        UnauthorizedError: UpdateAccountUnauthorizedError,
        ForbiddenError: UpdateAccountForbiddenError,
        NotFoundError: UpdateAccountNotFoundError,
        ConflictError: UpdateAccountConflictError,
        InternalServerError: UpdateAccountInternalServerError,
        BadGatewayError: UpdateAccountBadGatewayError,
        GatewayTimeoutError: UpdateAccountGatewayTimeoutError,
        GenericError: UpdateAccountGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateGroupError: {
        InvalidParameterError: UpdateGroupInvalidParameterError,
        UnauthorizedError: UpdateGroupUnauthorizedError,
        ForbiddenError: UpdateGroupForbiddenError,
        NotFoundError: UpdateGroupNotFoundError,
        InternalServerError: UpdateGroupInternalServerError,
        BadGatewayError: UpdateGroupBadGatewayError,
        GatewayTimeoutError: UpdateGroupGatewayTimeoutError,
        GenericError: UpdateGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateGroupSCIMError: {
        InvalidParameterError: UpdateGroupSCIMInvalidParameterError,
        UnauthorizedError: UpdateGroupSCIMUnauthorizedError,
        ForbiddenError: UpdateGroupSCIMForbiddenError,
        NotFoundError: UpdateGroupSCIMNotFoundError,
        InternalServerError: UpdateGroupSCIMInternalServerError,
        BadGatewayError: UpdateGroupSCIMBadGatewayError,
        GatewayTimeoutError: UpdateGroupSCIMGatewayTimeoutError,
        GenericError: UpdateGroupSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateManagedPolicyError: {
        InvalidParameterError: UpdateManagedPolicyInvalidParameterError,
        UnauthorizedError: UpdateManagedPolicyUnauthorizedError,
        ForbiddenError: UpdateManagedPolicyForbiddenError,
        NotFoundError: UpdateManagedPolicyNotFoundError,
        InternalServerError: UpdateManagedPolicyInternalServerError,
        BadGatewayError: UpdateManagedPolicyBadGatewayError,
        GatewayTimeoutError: UpdateManagedPolicyGatewayTimeoutError,
        GenericError: UpdateManagedPolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateMfaError: {
        InvalidParameterError: UpdateMfaInvalidParameterError,
        UnauthorizedError: UpdateMfaUnauthorizedError,
        MfaFactorNotVerifiedError: UpdateMfaMfaFactorNotVerifiedError,
        ForbiddenError: UpdateMfaForbiddenError,
        NotFoundError: UpdateMfaNotFoundError,
        InternalServerError: UpdateMfaInternalServerError,
        BadGatewayError: UpdateMfaBadGatewayError,
        GatewayTimeoutError: UpdateMfaGatewayTimeoutError,
        GenericError: UpdateMfaGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdatePasswordError: {
        InvalidParameterError: UpdatePasswordInvalidParameterError,
        UnauthorizedError: UpdatePasswordUnauthorizedError,
        InvalidAuthenticationModeError: UpdatePasswordInvalidAuthenticationModeError,
        PasswordDoesNotMatchError: UpdatePasswordPasswordDoesNotMatchError,
        ForbiddenError: UpdatePasswordForbiddenError,
        NotFoundError: UpdatePasswordNotFoundError,
        InternalServerError: UpdatePasswordInternalServerError,
        BadGatewayError: UpdatePasswordBadGatewayError,
        GatewayTimeoutError: UpdatePasswordGatewayTimeoutError,
        GenericError: UpdatePasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdatePolicyError: {
        InvalidParameterError: UpdatePolicyInvalidParameterError,
        UnauthorizedError: UpdatePolicyUnauthorizedError,
        ForbiddenError: UpdatePolicyForbiddenError,
        NotFoundError: UpdatePolicyNotFoundError,
        InternalServerError: UpdatePolicyInternalServerError,
        BadGatewayError: UpdatePolicyBadGatewayError,
        GatewayTimeoutError: UpdatePolicyGatewayTimeoutError,
        GenericError: UpdatePolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateProviderError: {
        InvalidParameterError: UpdateProviderInvalidParameterError,
        UnauthorizedError: UpdateProviderUnauthorizedError,
        InvalidCertificateError: UpdateProviderInvalidCertificateError,
        ForbiddenError: UpdateProviderForbiddenError,
        NotFoundError: UpdateProviderNotFoundError,
        InternalServerError: UpdateProviderInternalServerError,
        BadGatewayError: UpdateProviderBadGatewayError,
        GatewayTimeoutError: UpdateProviderGatewayTimeoutError,
        GenericError: UpdateProviderGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateRoleError: {
        InvalidParameterError: UpdateRoleInvalidParameterError,
        UnauthorizedError: UpdateRoleUnauthorizedError,
        ForbiddenError: UpdateRoleForbiddenError,
        NotFoundError: UpdateRoleNotFoundError,
        InternalServerError: UpdateRoleInternalServerError,
        BadGatewayError: UpdateRoleBadGatewayError,
        GatewayTimeoutError: UpdateRoleGatewayTimeoutError,
        GenericError: UpdateRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateSecurityError: {
        InvalidParameterError: UpdateSecurityInvalidParameterError,
        UnauthorizedError: UpdateSecurityUnauthorizedError,
        ForbiddenError: UpdateSecurityForbiddenError,
        NotFoundError: UpdateSecurityNotFoundError,
        InternalServerError: UpdateSecurityInternalServerError,
        BadGatewayError: UpdateSecurityBadGatewayError,
        GatewayTimeoutError: UpdateSecurityGatewayTimeoutError,
        GenericError: UpdateSecurityGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTeamError: {
        InvalidParameterError: UpdateTeamInvalidParameterError,
        UnauthorizedError: UpdateTeamUnauthorizedError,
        ForbiddenError: UpdateTeamForbiddenError,
        NotFoundError: UpdateTeamNotFoundError,
        InternalServerError: UpdateTeamInternalServerError,
        BadGatewayError: UpdateTeamBadGatewayError,
        GatewayTimeoutError: UpdateTeamGatewayTimeoutError,
        GenericError: UpdateTeamGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTeamGroupError: {
        InvalidParameterError: UpdateTeamGroupInvalidParameterError,
        UnauthorizedError: UpdateTeamGroupUnauthorizedError,
        ForbiddenError: UpdateTeamGroupForbiddenError,
        NotFoundError: UpdateTeamGroupNotFoundError,
        InternalServerError: UpdateTeamGroupInternalServerError,
        BadGatewayError: UpdateTeamGroupBadGatewayError,
        GatewayTimeoutError: UpdateTeamGroupGatewayTimeoutError,
        GenericError: UpdateTeamGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTeamUserError: {
        InvalidParameterError: UpdateTeamUserInvalidParameterError,
        UnauthorizedError: UpdateTeamUserUnauthorizedError,
        InvalidSubscriptionError: UpdateTeamUserInvalidSubscriptionError,
        ForbiddenToUpdateProvisionedUserError: UpdateTeamUserForbiddenToUpdateProvisionedUserError,
        ForbiddenError: UpdateTeamUserForbiddenError,
        NotFoundError: UpdateTeamUserNotFoundError,
        ConflictError: UpdateTeamUserConflictError,
        InternalServerError: UpdateTeamUserInternalServerError,
        BadGatewayError: UpdateTeamUserBadGatewayError,
        GatewayTimeoutError: UpdateTeamUserGatewayTimeoutError,
        GenericError: UpdateTeamUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateUserError: {
        InvalidParameterError: UpdateUserInvalidParameterError,
        UnauthorizedError: UpdateUserUnauthorizedError,
        ForbiddenToUpdateProvisionedUserError: UpdateUserForbiddenToUpdateProvisionedUserError,
        InvalidSubscriptionError: UpdateUserInvalidSubscriptionError,
        ForbiddenError: UpdateUserForbiddenError,
        NotFoundError: UpdateUserNotFoundError,
        InternalServerError: UpdateUserInternalServerError,
        BadGatewayError: UpdateUserBadGatewayError,
        GatewayTimeoutError: UpdateUserGatewayTimeoutError,
        GenericError: UpdateUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateUserMfaError: {
        InvalidParameterError: UpdateUserMfaInvalidParameterError,
        UnauthorizedError: UpdateUserMfaUnauthorizedError,
        MfaFactorNotVerifiedError: UpdateUserMfaMfaFactorNotVerifiedError,
        ForbiddenError: UpdateUserMfaForbiddenError,
        NotFoundError: UpdateUserMfaNotFoundError,
        InternalServerError: UpdateUserMfaInternalServerError,
        BadGatewayError: UpdateUserMfaBadGatewayError,
        GatewayTimeoutError: UpdateUserMfaGatewayTimeoutError,
        GenericError: UpdateUserMfaGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateUserSCIMError: {
        InvalidParameterError: UpdateUserSCIMInvalidParameterError,
        UnauthorizedError: UpdateUserSCIMUnauthorizedError,
        ForbiddenError: UpdateUserSCIMForbiddenError,
        NotFoundError: UpdateUserSCIMNotFoundError,
        ConflictError: UpdateUserSCIMConflictError,
        InternalServerError: UpdateUserSCIMInternalServerError,
        BadGatewayError: UpdateUserSCIMBadGatewayError,
        GatewayTimeoutError: UpdateUserSCIMGatewayTimeoutError,
        GenericError: UpdateUserSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    VerifyMfaFactorError: {
        InvalidParameterError: VerifyMfaFactorInvalidParameterError,
        InvalidTokenError: VerifyMfaFactorInvalidTokenError,
        InvalidOtpError: VerifyMfaFactorInvalidOtpError,
        MfaFactorNotAllowedError: VerifyMfaFactorMfaFactorNotAllowedError,
        NotFoundError: VerifyMfaFactorNotFoundError,
        InternalServerError: VerifyMfaFactorInternalServerError,
        BadGatewayError: VerifyMfaFactorBadGatewayError,
        GatewayTimeoutError: VerifyMfaFactorGatewayTimeoutError,
        GenericError: VerifyMfaFactorGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    VerifyOtpError: {
        InvalidParameterError: VerifyOtpInvalidParameterError,
        InvalidOtpError: VerifyOtpInvalidOtpError,
        InvalidTokenError: VerifyOtpInvalidTokenError,
        TokenExpiredError: VerifyOtpTokenExpiredError,
        NotFoundError: VerifyOtpNotFoundError,
        InternalServerError: VerifyOtpInternalServerError,
        BadGatewayError: VerifyOtpBadGatewayError,
        GatewayTimeoutError: VerifyOtpGatewayTimeoutError,
        GenericError: VerifyOtpGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    VerifyUserMfaFactorError: {
        InvalidParameterError: VerifyUserMfaFactorInvalidParameterError,
        InvalidTokenError: VerifyUserMfaFactorInvalidTokenError,
        InvalidOtpError: VerifyUserMfaFactorInvalidOtpError,
        MfaFactorNotAllowedError: VerifyUserMfaFactorMfaFactorNotAllowedError,
        NotFoundError: VerifyUserMfaFactorNotFoundError,
        InternalServerError: VerifyUserMfaFactorInternalServerError,
        BadGatewayError: VerifyUserMfaFactorBadGatewayError,
        GatewayTimeoutError: VerifyUserMfaFactorGatewayTimeoutError,
        GenericError: VerifyUserMfaFactorGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTeamError: {
        InvalidParameterError: DeleteTeamInvalidParameterError,
        UnauthorizedError: DeleteTeamUnauthorizedError,
        ForbiddenError: DeleteTeamForbiddenError,
        NotFoundError: DeleteTeamNotFoundError,
        InternalServerError: DeleteTeamInternalServerError,
        BadGatewayError: DeleteTeamBadGatewayError,
        GatewayTimeoutError: DeleteTeamGatewayTimeoutError,
        GenericError: DeleteTeamGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteUserError: {
        InvalidParameterError: DeleteUserInvalidParameterError,
        UnauthorizedError: DeleteUserUnauthorizedError,
        ForbiddenError: DeleteUserForbiddenError,
        NotFoundError: DeleteUserNotFoundError,
        InternalServerError: DeleteUserInternalServerError,
        BadGatewayError: DeleteUserBadGatewayError,
        GatewayTimeoutError: DeleteUserGatewayTimeoutError,
        GenericError: DeleteUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteUserSCIMError: {
        InvalidParameterError: DeleteUserSCIMInvalidParameterError,
        UnauthorizedError: DeleteUserSCIMUnauthorizedError,
        ForbiddenError: DeleteUserSCIMForbiddenError,
        NotFoundError: DeleteUserSCIMNotFoundError,
        InternalServerError: DeleteUserSCIMInternalServerError,
        BadGatewayError: DeleteUserSCIMBadGatewayError,
        GatewayTimeoutError: DeleteUserSCIMGatewayTimeoutError,
        GenericError: DeleteUserSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachGroupRoleError: {
        InvalidParameterError: DetachGroupRoleInvalidParameterError,
        UnauthorizedError: DetachGroupRoleUnauthorizedError,
        ForbiddenError: DetachGroupRoleForbiddenError,
        NotFoundError: DetachGroupRoleNotFoundError,
        InternalServerError: DetachGroupRoleInternalServerError,
        BadGatewayError: DetachGroupRoleBadGatewayError,
        GatewayTimeoutError: DetachGroupRoleGatewayTimeoutError,
        GenericError: DetachGroupRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachGroupUserError: {
        InvalidParameterError: DetachGroupUserInvalidParameterError,
        UnauthorizedError: DetachGroupUserUnauthorizedError,
        ForbiddenError: DetachGroupUserForbiddenError,
        NotFoundError: DetachGroupUserNotFoundError,
        InternalServerError: DetachGroupUserInternalServerError,
        BadGatewayError: DetachGroupUserBadGatewayError,
        GatewayTimeoutError: DetachGroupUserGatewayTimeoutError,
        GenericError: DetachGroupUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachRolePolicyError: {
        InvalidParameterError: DetachRolePolicyInvalidParameterError,
        UnauthorizedError: DetachRolePolicyUnauthorizedError,
        ForbiddenError: DetachRolePolicyForbiddenError,
        NotFoundError: DetachRolePolicyNotFoundError,
        InternalServerError: DetachRolePolicyInternalServerError,
        BadGatewayError: DetachRolePolicyBadGatewayError,
        GatewayTimeoutError: DetachRolePolicyGatewayTimeoutError,
        GenericError: DetachRolePolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachTeamGroupError: {
        InvalidParameterError: DetachTeamGroupInvalidParameterError,
        UnauthorizedError: DetachTeamGroupUnauthorizedError,
        ForbiddenError: DetachTeamGroupForbiddenError,
        NotFoundError: DetachTeamGroupNotFoundError,
        InternalServerError: DetachTeamGroupInternalServerError,
        BadGatewayError: DetachTeamGroupBadGatewayError,
        GatewayTimeoutError: DetachTeamGroupGatewayTimeoutError,
        GenericError: DetachTeamGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachTeamGroupRoleError: {
        InvalidParameterError: DetachTeamGroupRoleInvalidParameterError,
        UnauthorizedError: DetachTeamGroupRoleUnauthorizedError,
        ForbiddenError: DetachTeamGroupRoleForbiddenError,
        NotFoundError: DetachTeamGroupRoleNotFoundError,
        InternalServerError: DetachTeamGroupRoleInternalServerError,
        BadGatewayError: DetachTeamGroupRoleBadGatewayError,
        GatewayTimeoutError: DetachTeamGroupRoleGatewayTimeoutError,
        GenericError: DetachTeamGroupRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachTeamGroupUserError: {
        InvalidParameterError: DetachTeamGroupUserInvalidParameterError,
        UnauthorizedError: DetachTeamGroupUserUnauthorizedError,
        ForbiddenError: DetachTeamGroupUserForbiddenError,
        NotFoundError: DetachTeamGroupUserNotFoundError,
        InternalServerError: DetachTeamGroupUserInternalServerError,
        BadGatewayError: DetachTeamGroupUserBadGatewayError,
        GatewayTimeoutError: DetachTeamGroupUserGatewayTimeoutError,
        GenericError: DetachTeamGroupUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachTeamRoleError: {
        InvalidParameterError: DetachTeamRoleInvalidParameterError,
        UnauthorizedError: DetachTeamRoleUnauthorizedError,
        ForbiddenError: DetachTeamRoleForbiddenError,
        NotFoundError: DetachTeamRoleNotFoundError,
        InternalServerError: DetachTeamRoleInternalServerError,
        BadGatewayError: DetachTeamRoleBadGatewayError,
        GatewayTimeoutError: DetachTeamRoleGatewayTimeoutError,
        GenericError: DetachTeamRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachTeamUserError: {
        InvalidParameterError: DetachTeamUserInvalidParameterError,
        UnauthorizedError: DetachTeamUserUnauthorizedError,
        ForbiddenError: DetachTeamUserForbiddenError,
        NotFoundError: DetachTeamUserNotFoundError,
        InternalServerError: DetachTeamUserInternalServerError,
        BadGatewayError: DetachTeamUserBadGatewayError,
        GatewayTimeoutError: DetachTeamUserGatewayTimeoutError,
        GenericError: DetachTeamUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachTeamUserRoleError: {
        InvalidParameterError: DetachTeamUserRoleInvalidParameterError,
        UnauthorizedError: DetachTeamUserRoleUnauthorizedError,
        ForbiddenError: DetachTeamUserRoleForbiddenError,
        NotFoundError: DetachTeamUserRoleNotFoundError,
        InternalServerError: DetachTeamUserRoleInternalServerError,
        BadGatewayError: DetachTeamUserRoleBadGatewayError,
        GatewayTimeoutError: DetachTeamUserRoleGatewayTimeoutError,
        GenericError: DetachTeamUserRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DetachUserRoleError: {
        InvalidParameterError: DetachUserRoleInvalidParameterError,
        UnauthorizedError: DetachUserRoleUnauthorizedError,
        ForbiddenError: DetachUserRoleForbiddenError,
        NotFoundError: DetachUserRoleNotFoundError,
        InternalServerError: DetachUserRoleInternalServerError,
        BadGatewayError: DetachUserRoleBadGatewayError,
        GatewayTimeoutError: DetachUserRoleGatewayTimeoutError,
        GenericError: DetachUserRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ForgotPasswordError: {
        InvalidParameterError: ForgotPasswordInvalidParameterError,
        InvalidIdentityUsernameError: ForgotPasswordInvalidIdentityUsernameError,
        NotFoundError: ForgotPasswordNotFoundError,
        InternalServerError: ForgotPasswordInternalServerError,
        BadGatewayError: ForgotPasswordBadGatewayError,
        GatewayTimeoutError: ForgotPasswordGatewayTimeoutError,
        GenericError: ForgotPasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountError: {
        UnauthorizedError: GetAccountUnauthorizedError,
        ForbiddenError: GetAccountForbiddenError,
        NotFoundError: GetAccountNotFoundError,
        InternalServerError: GetAccountInternalServerError,
        BadGatewayError: GetAccountBadGatewayError,
        GatewayTimeoutError: GetAccountGatewayTimeoutError,
        GenericError: GetAccountGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetGroupError: {
        InvalidParameterError: GetGroupInvalidParameterError,
        UnauthorizedError: GetGroupUnauthorizedError,
        ForbiddenError: GetGroupForbiddenError,
        NotFoundError: GetGroupNotFoundError,
        InternalServerError: GetGroupInternalServerError,
        BadGatewayError: GetGroupBadGatewayError,
        GatewayTimeoutError: GetGroupGatewayTimeoutError,
        GenericError: GetGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetGroupSCIMError: {
        InvalidParameterError: GetGroupSCIMInvalidParameterError,
        UnauthorizedError: GetGroupSCIMUnauthorizedError,
        ForbiddenError: GetGroupSCIMForbiddenError,
        NotFoundError: GetGroupSCIMNotFoundError,
        InternalServerError: GetGroupSCIMInternalServerError,
        BadGatewayError: GetGroupSCIMBadGatewayError,
        GatewayTimeoutError: GetGroupSCIMGatewayTimeoutError,
        GenericError: GetGroupSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetMfaError: {
        UnauthorizedError: GetMfaUnauthorizedError,
        ForbiddenError: GetMfaForbiddenError,
        NotFoundError: GetMfaNotFoundError,
        InternalServerError: GetMfaInternalServerError,
        BadGatewayError: GetMfaBadGatewayError,
        GatewayTimeoutError: GetMfaGatewayTimeoutError,
        GenericError: GetMfaGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetPolicyError: {
        InvalidParameterError: GetPolicyInvalidParameterError,
        UnauthorizedError: GetPolicyUnauthorizedError,
        ForbiddenError: GetPolicyForbiddenError,
        NotFoundError: GetPolicyNotFoundError,
        InternalServerError: GetPolicyInternalServerError,
        BadGatewayError: GetPolicyBadGatewayError,
        GatewayTimeoutError: GetPolicyGatewayTimeoutError,
        GenericError: GetPolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetProviderError: {
        InvalidParameterError: GetProviderInvalidParameterError,
        UnauthorizedError: GetProviderUnauthorizedError,
        ForbiddenError: GetProviderForbiddenError,
        NotFoundError: GetProviderNotFoundError,
        InternalServerError: GetProviderInternalServerError,
        BadGatewayError: GetProviderBadGatewayError,
        GatewayTimeoutError: GetProviderGatewayTimeoutError,
        GenericError: GetProviderGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetResourceTypesError: {
        UnauthorizedError: GetResourceTypesUnauthorizedError,
        ForbiddenError: GetResourceTypesForbiddenError,
        InternalServerError: GetResourceTypesInternalServerError,
        BadGatewayError: GetResourceTypesBadGatewayError,
        GatewayTimeoutError: GetResourceTypesGatewayTimeoutError,
        GenericError: GetResourceTypesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetRoleError: {
        InvalidParameterError: GetRoleInvalidParameterError,
        UnauthorizedError: GetRoleUnauthorizedError,
        ForbiddenError: GetRoleForbiddenError,
        NotFoundError: GetRoleNotFoundError,
        InternalServerError: GetRoleInternalServerError,
        BadGatewayError: GetRoleBadGatewayError,
        GatewayTimeoutError: GetRoleGatewayTimeoutError,
        GenericError: GetRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetSchemasError: {
        UnauthorizedError: GetSchemasUnauthorizedError,
        ForbiddenError: GetSchemasForbiddenError,
        InternalServerError: GetSchemasInternalServerError,
        BadGatewayError: GetSchemasBadGatewayError,
        GatewayTimeoutError: GetSchemasGatewayTimeoutError,
        GenericError: GetSchemasGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetSecurityError: {
        UnauthorizedError: GetSecurityUnauthorizedError,
        ForbiddenError: GetSecurityForbiddenError,
        NotFoundError: GetSecurityNotFoundError,
        InternalServerError: GetSecurityInternalServerError,
        BadGatewayError: GetSecurityBadGatewayError,
        GatewayTimeoutError: GetSecurityGatewayTimeoutError,
        GenericError: GetSecurityGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetServiceProviderConfigError: {
        UnauthorizedError: GetServiceProviderConfigUnauthorizedError,
        ForbiddenError: GetServiceProviderConfigForbiddenError,
        InternalServerError: GetServiceProviderConfigInternalServerError,
        BadGatewayError: GetServiceProviderConfigBadGatewayError,
        GatewayTimeoutError: GetServiceProviderConfigGatewayTimeoutError,
        GenericError: GetServiceProviderConfigGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetSigninConfigurationError: {
        InvalidParameterError: GetSigninConfigurationInvalidParameterError,
        NotFoundError: GetSigninConfigurationNotFoundError,
        InternalServerError: GetSigninConfigurationInternalServerError,
        BadGatewayError: GetSigninConfigurationBadGatewayError,
        GatewayTimeoutError: GetSigninConfigurationGatewayTimeoutError,
        GenericError: GetSigninConfigurationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamError: {
        InvalidParameterError: GetTeamInvalidParameterError,
        UnauthorizedError: GetTeamUnauthorizedError,
        ForbiddenError: GetTeamForbiddenError,
        NotFoundError: GetTeamNotFoundError,
        InternalServerError: GetTeamInternalServerError,
        BadGatewayError: GetTeamBadGatewayError,
        GatewayTimeoutError: GetTeamGatewayTimeoutError,
        GenericError: GetTeamGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamGroupError: {
        InvalidParameterError: GetTeamGroupInvalidParameterError,
        UnauthorizedError: GetTeamGroupUnauthorizedError,
        ForbiddenError: GetTeamGroupForbiddenError,
        NotFoundError: GetTeamGroupNotFoundError,
        InternalServerError: GetTeamGroupInternalServerError,
        BadGatewayError: GetTeamGroupBadGatewayError,
        GatewayTimeoutError: GetTeamGroupGatewayTimeoutError,
        GenericError: GetTeamGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserError: {
        InvalidParameterError: GetTeamUserInvalidParameterError,
        UnauthorizedError: GetTeamUserUnauthorizedError,
        ForbiddenError: GetTeamUserForbiddenError,
        NotFoundError: GetTeamUserNotFoundError,
        InternalServerError: GetTeamUserInternalServerError,
        BadGatewayError: GetTeamUserBadGatewayError,
        GatewayTimeoutError: GetTeamUserGatewayTimeoutError,
        GenericError: GetTeamUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserError: {
        InvalidParameterError: GetUserInvalidParameterError,
        UnauthorizedError: GetUserUnauthorizedError,
        ForbiddenError: GetUserForbiddenError,
        NotFoundError: GetUserNotFoundError,
        InternalServerError: GetUserInternalServerError,
        BadGatewayError: GetUserBadGatewayError,
        GatewayTimeoutError: GetUserGatewayTimeoutError,
        GenericError: GetUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserMfaError: {
        InvalidParameterError: GetUserMfaInvalidParameterError,
        UnauthorizedError: GetUserMfaUnauthorizedError,
        ForbiddenError: GetUserMfaForbiddenError,
        NotFoundError: GetUserMfaNotFoundError,
        InternalServerError: GetUserMfaInternalServerError,
        BadGatewayError: GetUserMfaBadGatewayError,
        GatewayTimeoutError: GetUserMfaGatewayTimeoutError,
        GenericError: GetUserMfaGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserSCIMError: {
        InvalidParameterError: GetUserSCIMInvalidParameterError,
        UnauthorizedError: GetUserSCIMUnauthorizedError,
        ForbiddenError: GetUserSCIMForbiddenError,
        NotFoundError: GetUserSCIMNotFoundError,
        InternalServerError: GetUserSCIMInternalServerError,
        BadGatewayError: GetUserSCIMBadGatewayError,
        GatewayTimeoutError: GetUserSCIMGatewayTimeoutError,
        GenericError: GetUserSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InviteTeamUserError: {
        InvalidParameterError: InviteTeamUserInvalidParameterError,
        UnauthorizedError: InviteTeamUserUnauthorizedError,
        ForbiddenError: InviteTeamUserForbiddenError,
        NotFoundError: InviteTeamUserNotFoundError,
        InternalServerError: InviteTeamUserInternalServerError,
        BadGatewayError: InviteTeamUserBadGatewayError,
        GatewayTimeoutError: InviteTeamUserGatewayTimeoutError,
        GenericError: InviteTeamUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InviteUserError: {
        InvalidParameterError: InviteUserInvalidParameterError,
        UnauthorizedError: InviteUserUnauthorizedError,
        InvalidEmailError: InviteUserInvalidEmailError,
        ForbiddenError: InviteUserForbiddenError,
        NotFoundError: InviteUserNotFoundError,
        InternalServerError: InviteUserInternalServerError,
        BadGatewayError: InviteUserBadGatewayError,
        GatewayTimeoutError: InviteUserGatewayTimeoutError,
        GenericError: InviteUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListGroupRolesError: {
        InvalidParameterError: ListGroupRolesInvalidParameterError,
        UnauthorizedError: ListGroupRolesUnauthorizedError,
        ForbiddenError: ListGroupRolesForbiddenError,
        NotFoundError: ListGroupRolesNotFoundError,
        InternalServerError: ListGroupRolesInternalServerError,
        BadGatewayError: ListGroupRolesBadGatewayError,
        GatewayTimeoutError: ListGroupRolesGatewayTimeoutError,
        GenericError: ListGroupRolesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListGroupTeamsError: {
        InvalidParameterError: ListGroupTeamsInvalidParameterError,
        UnauthorizedError: ListGroupTeamsUnauthorizedError,
        ForbiddenError: ListGroupTeamsForbiddenError,
        NotFoundError: ListGroupTeamsNotFoundError,
        InternalServerError: ListGroupTeamsInternalServerError,
        BadGatewayError: ListGroupTeamsBadGatewayError,
        GatewayTimeoutError: ListGroupTeamsGatewayTimeoutError,
        GenericError: ListGroupTeamsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListGroupUsersError: {
        InvalidParameterError: ListGroupUsersInvalidParameterError,
        UnauthorizedError: ListGroupUsersUnauthorizedError,
        ForbiddenError: ListGroupUsersForbiddenError,
        NotFoundError: ListGroupUsersNotFoundError,
        InternalServerError: ListGroupUsersInternalServerError,
        BadGatewayError: ListGroupUsersBadGatewayError,
        GatewayTimeoutError: ListGroupUsersGatewayTimeoutError,
        GenericError: ListGroupUsersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AcceptInvitationError: {
        InvalidParameterError: AcceptInvitationInvalidParameterError,
        InvalidInvitationError: AcceptInvitationInvalidInvitationError,
        InvalidInvitationSecretError: AcceptInvitationInvalidInvitationSecretError,
        ExpiredInvitationError: AcceptInvitationExpiredInvitationError,
        NotFoundError: AcceptInvitationNotFoundError,
        InternalServerError: AcceptInvitationInternalServerError,
        BadGatewayError: AcceptInvitationBadGatewayError,
        GatewayTimeoutError: AcceptInvitationGatewayTimeoutError,
        GenericError: AcceptInvitationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AcceptUserInvitationError: {
        InvalidParameterError: AcceptUserInvitationInvalidParameterError,
        InvalidInvitationError: AcceptUserInvitationInvalidInvitationError,
        ExpiredInvitationError: AcceptUserInvitationExpiredInvitationError,
        NotFoundError: AcceptUserInvitationNotFoundError,
        InternalServerError: AcceptUserInvitationInternalServerError,
        BadGatewayError: AcceptUserInvitationBadGatewayError,
        GatewayTimeoutError: AcceptUserInvitationGatewayTimeoutError,
        GenericError: AcceptUserInvitationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachGroupRoleError: {
        InvalidParameterError: AttachGroupRoleInvalidParameterError,
        UnauthorizedError: AttachGroupRoleUnauthorizedError,
        ForbiddenError: AttachGroupRoleForbiddenError,
        NotFoundError: AttachGroupRoleNotFoundError,
        ConflictError: AttachGroupRoleConflictError,
        InternalServerError: AttachGroupRoleInternalServerError,
        BadGatewayError: AttachGroupRoleBadGatewayError,
        GatewayTimeoutError: AttachGroupRoleGatewayTimeoutError,
        GenericError: AttachGroupRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachGroupUserError: {
        InvalidParameterError: AttachGroupUserInvalidParameterError,
        UnauthorizedError: AttachGroupUserUnauthorizedError,
        ForbiddenError: AttachGroupUserForbiddenError,
        NotFoundError: AttachGroupUserNotFoundError,
        ConflictError: AttachGroupUserConflictError,
        InternalServerError: AttachGroupUserInternalServerError,
        BadGatewayError: AttachGroupUserBadGatewayError,
        GatewayTimeoutError: AttachGroupUserGatewayTimeoutError,
        GenericError: AttachGroupUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachRolePolicyError: {
        InvalidParameterError: AttachRolePolicyInvalidParameterError,
        UnauthorizedError: AttachRolePolicyUnauthorizedError,
        ForbiddenError: AttachRolePolicyForbiddenError,
        NotFoundError: AttachRolePolicyNotFoundError,
        ConflictError: AttachRolePolicyConflictError,
        InternalServerError: AttachRolePolicyInternalServerError,
        BadGatewayError: AttachRolePolicyBadGatewayError,
        GatewayTimeoutError: AttachRolePolicyGatewayTimeoutError,
        GenericError: AttachRolePolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachTeamGroupError: {
        InvalidParameterError: AttachTeamGroupInvalidParameterError,
        UnauthorizedError: AttachTeamGroupUnauthorizedError,
        ForbiddenError: AttachTeamGroupForbiddenError,
        NotFoundError: AttachTeamGroupNotFoundError,
        ConflictError: AttachTeamGroupConflictError,
        InternalServerError: AttachTeamGroupInternalServerError,
        BadGatewayError: AttachTeamGroupBadGatewayError,
        GatewayTimeoutError: AttachTeamGroupGatewayTimeoutError,
        GenericError: AttachTeamGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachTeamGroupRoleError: {
        InvalidParameterError: AttachTeamGroupRoleInvalidParameterError,
        UnauthorizedError: AttachTeamGroupRoleUnauthorizedError,
        ForbiddenError: AttachTeamGroupRoleForbiddenError,
        NotFoundError: AttachTeamGroupRoleNotFoundError,
        ConflictError: AttachTeamGroupRoleConflictError,
        InternalServerError: AttachTeamGroupRoleInternalServerError,
        BadGatewayError: AttachTeamGroupRoleBadGatewayError,
        GatewayTimeoutError: AttachTeamGroupRoleGatewayTimeoutError,
        GenericError: AttachTeamGroupRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachTeamGroupUserError: {
        InvalidParameterError: AttachTeamGroupUserInvalidParameterError,
        UnauthorizedError: AttachTeamGroupUserUnauthorizedError,
        ForbiddenError: AttachTeamGroupUserForbiddenError,
        NotFoundError: AttachTeamGroupUserNotFoundError,
        ConflictError: AttachTeamGroupUserConflictError,
        InternalServerError: AttachTeamGroupUserInternalServerError,
        BadGatewayError: AttachTeamGroupUserBadGatewayError,
        GatewayTimeoutError: AttachTeamGroupUserGatewayTimeoutError,
        GenericError: AttachTeamGroupUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachTeamRoleError: {
        InvalidParameterError: AttachTeamRoleInvalidParameterError,
        UnauthorizedError: AttachTeamRoleUnauthorizedError,
        ForbiddenError: AttachTeamRoleForbiddenError,
        NotFoundError: AttachTeamRoleNotFoundError,
        ConflictError: AttachTeamRoleConflictError,
        InternalServerError: AttachTeamRoleInternalServerError,
        BadGatewayError: AttachTeamRoleBadGatewayError,
        GatewayTimeoutError: AttachTeamRoleGatewayTimeoutError,
        GenericError: AttachTeamRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachTeamUserError: {
        InvalidParameterError: AttachTeamUserInvalidParameterError,
        UnauthorizedError: AttachTeamUserUnauthorizedError,
        ForbiddenError: AttachTeamUserForbiddenError,
        NotFoundError: AttachTeamUserNotFoundError,
        ConflictError: AttachTeamUserConflictError,
        InternalServerError: AttachTeamUserInternalServerError,
        BadGatewayError: AttachTeamUserBadGatewayError,
        GatewayTimeoutError: AttachTeamUserGatewayTimeoutError,
        GenericError: AttachTeamUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachTeamUserRoleError: {
        InvalidParameterError: AttachTeamUserRoleInvalidParameterError,
        UnauthorizedError: AttachTeamUserRoleUnauthorizedError,
        ForbiddenError: AttachTeamUserRoleForbiddenError,
        NotFoundError: AttachTeamUserRoleNotFoundError,
        ConflictError: AttachTeamUserRoleConflictError,
        InternalServerError: AttachTeamUserRoleInternalServerError,
        BadGatewayError: AttachTeamUserRoleBadGatewayError,
        GatewayTimeoutError: AttachTeamUserRoleGatewayTimeoutError,
        GenericError: AttachTeamUserRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    AttachUserRoleError: {
        InvalidParameterError: AttachUserRoleInvalidParameterError,
        UnauthorizedError: AttachUserRoleUnauthorizedError,
        ForbiddenError: AttachUserRoleForbiddenError,
        NotFoundError: AttachUserRoleNotFoundError,
        ConflictError: AttachUserRoleConflictError,
        InternalServerError: AttachUserRoleInternalServerError,
        BadGatewayError: AttachUserRoleBadGatewayError,
        GatewayTimeoutError: AttachUserRoleGatewayTimeoutError,
        GenericError: AttachUserRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ChangePasswordError: {
        InvalidParameterError: ChangePasswordInvalidParameterError,
        InvalidSecretError: ChangePasswordInvalidSecretError,
        ExpiredSecretError: ChangePasswordExpiredSecretError,
        NotFoundError: ChangePasswordNotFoundError,
        InternalServerError: ChangePasswordInternalServerError,
        BadGatewayError: ChangePasswordBadGatewayError,
        GatewayTimeoutError: ChangePasswordGatewayTimeoutError,
        GenericError: ChangePasswordGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateAccountError: {
        InvalidParameterError: CreateAccountInvalidParameterError,
        NotFoundError: CreateAccountNotFoundError,
        ConflictError: CreateAccountConflictError,
        InternalServerError: CreateAccountInternalServerError,
        BadGatewayError: CreateAccountBadGatewayError,
        GatewayTimeoutError: CreateAccountGatewayTimeoutError,
        GenericError: CreateAccountGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateGroupError: {
        InvalidParameterError: CreateGroupInvalidParameterError,
        UnauthorizedError: CreateGroupUnauthorizedError,
        ForbiddenError: CreateGroupForbiddenError,
        ConflictError: CreateGroupConflictError,
        InternalServerError: CreateGroupInternalServerError,
        BadGatewayError: CreateGroupBadGatewayError,
        GatewayTimeoutError: CreateGroupGatewayTimeoutError,
        GenericError: CreateGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateGroupSCIMError: {
        InvalidParameterError: CreateGroupSCIMInvalidParameterError,
        UnauthorizedError: CreateGroupSCIMUnauthorizedError,
        ForbiddenError: CreateGroupSCIMForbiddenError,
        NotFoundError: CreateGroupSCIMNotFoundError,
        ConflictError: CreateGroupSCIMConflictError,
        InternalServerError: CreateGroupSCIMInternalServerError,
        BadGatewayError: CreateGroupSCIMBadGatewayError,
        GatewayTimeoutError: CreateGroupSCIMGatewayTimeoutError,
        GenericError: CreateGroupSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateMfaFactorSecretError: {
        InvalidParameterError: CreateMfaFactorSecretInvalidParameterError,
        InvalidTokenError: CreateMfaFactorSecretInvalidTokenError,
        MfaFactorNotAllowedError: CreateMfaFactorSecretMfaFactorNotAllowedError,
        NotFoundError: CreateMfaFactorSecretNotFoundError,
        InternalServerError: CreateMfaFactorSecretInternalServerError,
        BadGatewayError: CreateMfaFactorSecretBadGatewayError,
        GatewayTimeoutError: CreateMfaFactorSecretGatewayTimeoutError,
        GenericError: CreateMfaFactorSecretGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreatePolicyError: {
        InvalidParameterError: CreatePolicyInvalidParameterError,
        UnauthorizedError: CreatePolicyUnauthorizedError,
        ForbiddenError: CreatePolicyForbiddenError,
        ConflictError: CreatePolicyConflictError,
        InternalServerError: CreatePolicyInternalServerError,
        BadGatewayError: CreatePolicyBadGatewayError,
        GatewayTimeoutError: CreatePolicyGatewayTimeoutError,
        GenericError: CreatePolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateProviderError: {
        InvalidParameterError: CreateProviderInvalidParameterError,
        UnauthorizedError: CreateProviderUnauthorizedError,
        InvalidCertificateError: CreateProviderInvalidCertificateError,
        ForbiddenError: CreateProviderForbiddenError,
        ConflictError: CreateProviderConflictError,
        InternalServerError: CreateProviderInternalServerError,
        BadGatewayError: CreateProviderBadGatewayError,
        GatewayTimeoutError: CreateProviderGatewayTimeoutError,
        GenericError: CreateProviderGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateRoleError: {
        InvalidParameterError: CreateRoleInvalidParameterError,
        UnauthorizedError: CreateRoleUnauthorizedError,
        ForbiddenError: CreateRoleForbiddenError,
        ConflictError: CreateRoleConflictError,
        InternalServerError: CreateRoleInternalServerError,
        BadGatewayError: CreateRoleBadGatewayError,
        GatewayTimeoutError: CreateRoleGatewayTimeoutError,
        GenericError: CreateRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTeamError: {
        InvalidParameterError: CreateTeamInvalidParameterError,
        UnauthorizedError: CreateTeamUnauthorizedError,
        ForbiddenError: CreateTeamForbiddenError,
        ConflictError: CreateTeamConflictError,
        InternalServerError: CreateTeamInternalServerError,
        BadGatewayError: CreateTeamBadGatewayError,
        GatewayTimeoutError: CreateTeamGatewayTimeoutError,
        GenericError: CreateTeamGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTokenError: {
        InvalidParameterError: CreateTokenInvalidParameterError,
        InvalidCredentialsError: CreateTokenInvalidCredentialsError,
        PasswordRevokedError: CreateTokenPasswordRevokedError,
        IdentityDisabledError: CreateTokenIdentityDisabledError,
        InvalidAuthenticationModeError: CreateTokenInvalidAuthenticationModeError,
        MfaRequiredError: CreateTokenMfaRequiredError,
        NotFoundError: CreateTokenNotFoundError,
        ConflictError: CreateTokenConflictError,
        InternalServerError: CreateTokenInternalServerError,
        BadGatewayError: CreateTokenBadGatewayError,
        GatewayTimeoutError: CreateTokenGatewayTimeoutError,
        GenericError: CreateTokenGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateUserError: {
        InvalidParameterError: CreateUserInvalidParameterError,
        UnauthorizedError: CreateUserUnauthorizedError,
        InvalidSubscriptionError: CreateUserInvalidSubscriptionError,
        ForbiddenError: CreateUserForbiddenError,
        ConflictError: CreateUserConflictError,
        InternalServerError: CreateUserInternalServerError,
        BadGatewayError: CreateUserBadGatewayError,
        GatewayTimeoutError: CreateUserGatewayTimeoutError,
        GenericError: CreateUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateUserMfaFactorSecretError: {
        InvalidParameterError: CreateUserMfaFactorSecretInvalidParameterError,
        InvalidTokenError: CreateUserMfaFactorSecretInvalidTokenError,
        MfaFactorNotAllowedError: CreateUserMfaFactorSecretMfaFactorNotAllowedError,
        NotFoundError: CreateUserMfaFactorSecretNotFoundError,
        InternalServerError: CreateUserMfaFactorSecretInternalServerError,
        BadGatewayError: CreateUserMfaFactorSecretBadGatewayError,
        GatewayTimeoutError: CreateUserMfaFactorSecretGatewayTimeoutError,
        GenericError: CreateUserMfaFactorSecretGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateUserSCIMError: {
        InvalidParameterError: CreateUserSCIMInvalidParameterError,
        UnauthorizedError: CreateUserSCIMUnauthorizedError,
        ForbiddenError: CreateUserSCIMForbiddenError,
        NotFoundError: CreateUserSCIMNotFoundError,
        ConflictError: CreateUserSCIMConflictError,
        InternalServerError: CreateUserSCIMInternalServerError,
        BadGatewayError: CreateUserSCIMBadGatewayError,
        GatewayTimeoutError: CreateUserSCIMGatewayTimeoutError,
        GenericError: CreateUserSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateUserTokenError: {
        InvalidParameterError: CreateUserTokenInvalidParameterError,
        UnauthorizedError: CreateUserTokenUnauthorizedError,
        IdentityDisabledError: CreateUserTokenIdentityDisabledError,
        ForbiddenError: CreateUserTokenForbiddenError,
        NotFoundError: CreateUserTokenNotFoundError,
        ConflictError: CreateUserTokenConflictError,
        InternalServerError: CreateUserTokenInternalServerError,
        BadGatewayError: CreateUserTokenBadGatewayError,
        GatewayTimeoutError: CreateUserTokenGatewayTimeoutError,
        GenericError: CreateUserTokenGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteAccountError: {
        UnauthorizedError: DeleteAccountUnauthorizedError,
        ForbiddenError: DeleteAccountForbiddenError,
        NotFoundError: DeleteAccountNotFoundError,
        InternalServerError: DeleteAccountInternalServerError,
        BadGatewayError: DeleteAccountBadGatewayError,
        GatewayTimeoutError: DeleteAccountGatewayTimeoutError,
        GenericError: DeleteAccountGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteGroupError: {
        InvalidParameterError: DeleteGroupInvalidParameterError,
        UnauthorizedError: DeleteGroupUnauthorizedError,
        ForbiddenError: DeleteGroupForbiddenError,
        NotFoundError: DeleteGroupNotFoundError,
        InternalServerError: DeleteGroupInternalServerError,
        BadGatewayError: DeleteGroupBadGatewayError,
        GatewayTimeoutError: DeleteGroupGatewayTimeoutError,
        GenericError: DeleteGroupGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteGroupSCIMError: {
        InvalidParameterError: DeleteGroupSCIMInvalidParameterError,
        UnauthorizedError: DeleteGroupSCIMUnauthorizedError,
        ForbiddenError: DeleteGroupSCIMForbiddenError,
        NotFoundError: DeleteGroupSCIMNotFoundError,
        InternalServerError: DeleteGroupSCIMInternalServerError,
        BadGatewayError: DeleteGroupSCIMBadGatewayError,
        GatewayTimeoutError: DeleteGroupSCIMGatewayTimeoutError,
        GenericError: DeleteGroupSCIMGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeletePolicyError: {
        InvalidParameterError: DeletePolicyInvalidParameterError,
        UnauthorizedError: DeletePolicyUnauthorizedError,
        ForbiddenError: DeletePolicyForbiddenError,
        NotFoundError: DeletePolicyNotFoundError,
        InternalServerError: DeletePolicyInternalServerError,
        BadGatewayError: DeletePolicyBadGatewayError,
        GatewayTimeoutError: DeletePolicyGatewayTimeoutError,
        GenericError: DeletePolicyGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteProviderError: {
        InvalidParameterError: DeleteProviderInvalidParameterError,
        UnauthorizedError: DeleteProviderUnauthorizedError,
        ForbiddenError: DeleteProviderForbiddenError,
        NotFoundError: DeleteProviderNotFoundError,
        InternalServerError: DeleteProviderInternalServerError,
        BadGatewayError: DeleteProviderBadGatewayError,
        GatewayTimeoutError: DeleteProviderGatewayTimeoutError,
        GenericError: DeleteProviderGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteRoleError: {
        InvalidParameterError: DeleteRoleInvalidParameterError,
        UnauthorizedError: DeleteRoleUnauthorizedError,
        ForbiddenError: DeleteRoleForbiddenError,
        NotFoundError: DeleteRoleNotFoundError,
        InternalServerError: DeleteRoleInternalServerError,
        BadGatewayError: DeleteRoleBadGatewayError,
        GatewayTimeoutError: DeleteRoleGatewayTimeoutError,
        GenericError: DeleteRoleGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DecodeTokenError: {
        FailedToDecodeTokenError: DecodeTokenFailedToDecodeTokenError,
        GenericError: DecodeTokenGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InvalidSdkConfigurationError,
    InvalidRegionOrHostError,
    InvalidRegionError,
    InvalidHostError,
};
